<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<div class="flex-container">
  <app-header
  [propertyAddress]="propertyAddress"
  [details]="details"
  [loading]="loading"
  [isHealthy$]="isHealthy$"
  [isEditVisible]="isEditVisible"
  [showStatus]="true"
  [isEdit]="isEdit"
  [saving]="saving"
  [form]="form"
  [showSaveEdit]="true"
  (save)="save($event)"
  (cancel)="load()">
</app-header>
  <div class="main-content" *ngIf="isHealthy$ | async">
    <div class="mobile-navbar mobile-nav">
      <button
        class="hamburger"
        (click)="toggleSidebar()"
        aria-label="Open navigation menu"
        aria-expanded="{{ isSidebarOpen }}"
        aria-controls="sidebar"
      >
        <i class="bi bi-list"></i>
      </button>
    
      <!-- Sidebar Overlay -->
      <div
        class="sidebar-overlay"
        [class.open]="isSidebarOpen === true"
        (click)="closeSidebar()"
      ></div>
    
      <!-- Sidebar -->
      <div
        id="sidebar"
        class="sidebar"
        [class.open]="isSidebarOpen === true"
        role="navigation"
        [attr.aria-hidden]="!isSidebarOpen"
      >
        <button
          class="close-btn"
          (click)="closeSidebar()"
          #closeButton
          aria-label="Close navigation menu"
        >
          <i class="bi bi-x"></i>
        </button>
        <ul ngbNav #navMobile="ngbNav" [(activeId)]="selectedTabIndex" class="side-tab">
          <h2 class="text-center" style="color:#4459a6; margin-bottom: 20px; margin-top: -44px;">RDSAP 9.9.4</h2>
          <li [ngbNavItem]="1" style="border-top: 1px solid #4459a6;">
            <a ngbNavLink (click)="onSelectTab(1)" role="button">
              General 
              <span>
                <i
                [ngClass]="{
                  'bi bi-exclamation-circle':
                    isTabClicked(1) === false ||
                    (isTabClicked(1) && !isGeneralTabValid()),
                  'bi bi-check-circle': isTabClicked(1) && isGeneralTabValid(),
                  'text-warning': isTabClicked(1) === false,
                  'text-danger': isTabClicked(1) && !isGeneralTabValid(),
                  'text-success': isTabClicked(1) && isGeneralTabValid()
                }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink (click)="onSelectTab(2)" role="button">
              Openings 
              <span >
                <i
                [ngClass]="{
                  'bi bi-exclamation-circle':
                    isTabClicked(2) === false ||
                    (isTabClicked(2) && !isOpeningsTabValid()),
                  'bi bi-check-circle': isTabClicked(2) && isOpeningsTabValid(),
                  'text-warning': isTabClicked(2) === false,
                  'text-danger': isTabClicked(2) && !isOpeningsTabValid(),
                  'text-success': isTabClicked(2) && isOpeningsTabValid()
                }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="3">
            <a ngbNavLink (click)="onSelectTab(3)" role="button">
              Main Building
              <span>
                <i
                [ngClass]="{
                  'bi bi-exclamation-circle':
                    isTabClicked(3) === false ||
                    (isTabClicked(3) && !isMainBuildingTabValid()),
                  'bi bi-check-circle': isTabClicked(3) && isMainBuildingTabValid(),
                  'text-warning': isTabClicked(3) === false,
                  'text-danger': isTabClicked(3) && !isMainBuildingTabValid(),
                  'text-success': isTabClicked(3) && isMainBuildingTabValid()
                }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="4" *ngIf="showBuildingExtensions.extension1">
            <!-- Extension 1 Tab -->
            <a
              ngbNavLink
              (click)="onSelectTab(4)"
              role="button"
              *ngIf="showBuildingExtensions.extension1"
            >
              Extension 1
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(4) === false ||
                      (isTabClicked(4) && !isExtension1TabValid()),
                    'bi bi-check-circle': isTabClicked(4) && isExtension1TabValid(),
                    'text-warning': isTabClicked(4) === false,
                    'text-danger': isTabClicked(4) && !isExtension1TabValid(),
                    'text-success': isTabClicked(4) && isExtension1TabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="5" *ngIf="showBuildingExtensions.extension2">
            <!-- Extension 2 Tab -->
            <a
              ngbNavLink
              (click)="onSelectTab(5)"
              role="button"
              *ngIf="showBuildingExtensions.extension2"
            >
              Extension 2
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(5) === false ||
                      (isTabClicked(5) && !isExtension2TabValid()),
                    'bi bi-check-circle': isTabClicked(5) && isExtension2TabValid(),
                    'text-warning': isTabClicked(5) === false,
                    'text-danger': isTabClicked(5) && !isExtension2TabValid(),
                    'text-success': isTabClicked(5) && isExtension2TabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="6" *ngIf="showBuildingExtensions.extension3">
            <!-- Extension 3 Tab -->
            <a
              ngbNavLink
              (click)="onSelectTab(6)"
              role="button"
              *ngIf="showBuildingExtensions.extension3"
            >
              Extension 3
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(6) === false ||
                      (isTabClicked(6) && !isExtension3TabValid()),
                    'bi bi-check-circle': isTabClicked(6) && isExtension3TabValid(),
                    'text-warning': isTabClicked(6) === false,
                    'text-danger': isTabClicked(6) && !isExtension3TabValid(),
                    'text-success': isTabClicked(6) && isExtension3TabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="7" *ngIf="showBuildingExtensions.extension4">
            <!-- Extension 4 Tab -->
            <a
              ngbNavLink
              (click)="onSelectTab(7)"
              role="button"
              *ngIf="showBuildingExtensions.extension4"
            >
              Extension 4
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(7) === false ||
                      (isTabClicked(7) && !isExtension4TabValid()),
                    'bi bi-check-circle': isTabClicked(7) && isExtension4TabValid(),
                    'text-warning': isTabClicked(7) === false,
                    'text-danger': isTabClicked(7) && !isExtension4TabValid(),
                    'text-success': isTabClicked(7) && isExtension4TabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="8">
            <!-- Heating Tab -->
            <a ngbNavLink (click)="onSelectTab(8)" role="button">
              Heating
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(8) === false ||
                      (isTabClicked(8) && !isHeatingTabValid()),
                    'bi bi-check-circle': isTabClicked(8) && isHeatingTabValid(),
                    'text-warning': isTabClicked(8) === false,
                    'text-danger': isTabClicked(8) && !isHeatingTabValid(),
                    'text-success': isTabClicked(8) && isHeatingTabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="9">
            <!-- Water Heating Tab -->
            <a ngbNavLink (click)="onSelectTab(9)" role="button">
              Water Heating
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(9) === false ||
                      (isTabClicked(9) && !isWaterHeatingTabValid()),
                    'bi bi-check-circle':
                      isTabClicked(9) && isWaterHeatingTabValid(),
                    'text-warning': isTabClicked(9) === false,
                    'text-danger': isTabClicked(9) && !isWaterHeatingTabValid(),
                    'text-success': isTabClicked(9) && isWaterHeatingTabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="10">
            <!-- Renewables Tab -->
            <a ngbNavLink (click)="onSelectTab(10)" role="button">
              Renewables
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(10) === false ||
                      (isTabClicked(10) && !isRenewablesTabValid()),
                    'bi bi-check-circle':
                      isTabClicked(10) && isRenewablesTabValid(),
                    'text-warning': isTabClicked(10) === false,
                    'text-danger': isTabClicked(10) && !isRenewablesTabValid(),
                    'text-success': isTabClicked(10) && isRenewablesTabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="11">
            <!-- Recovery Tab -->
            <a ngbNavLink (click)="onSelectTab(11)" role="button">
              Recovery
              <span>
                <i
                  [ngClass]="{
                    'bi bi-exclamation-circle':
                      isTabClicked(11) === false ||
                      (isTabClicked(11) && !isRecoveryTabValid()),
                    'bi bi-check-circle': isTabClicked(11) && isRecoveryTabValid(),
                    'text-warning': isTabClicked(11) === false,
                    'text-danger': isTabClicked(11) && !isRecoveryTabValid(),
                    'text-success': isTabClicked(11) && isRecoveryTabValid()
                  }"
                ></i>
              </span>
            </a>
          </li>
          <li [ngbNavItem]="0">
            <a ngbNavLink (click)="onSelectTab(0)" role="button">Results</a>
            <ng-template ngbNavContent>
              <app-rdsap-summary
                [isEdit]="isEdit"
                [canCalculate]="canCalculate()"
                (addendaData)="setAddendum($event.addendum)"
                (deselectedItemsData)="
                  setDeselectedItems($event.deselectedImprovementMeasures)
                "
                [getAddendum]="eeGeneralDetails?.addendum"
              ></app-rdsap-summary>
            </ng-template>
          </li>
        </ul>
      </div>
    </div>
    
    <ul  ngbNav #nav="ngbNav" [(activeId)]="selectedTabIndex" class="nav-tabs desktop-nav"  >
      <li [ngbNavItem]="1">
        <!-- General Tab -->
        <a ngbNavLink (click)="onSelectTab(1)" role="button">
          General
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(1) === false ||
                  (isTabClicked(1) && !isGeneralTabValid()),
                'bi bi-check-circle': isTabClicked(1) && isGeneralTabValid(),
                'text-warning': isTabClicked(1) === false,
                'text-danger': isTabClicked(1) && !isGeneralTabValid(),
                'text-success': isTabClicked(1) && isGeneralTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header bg-blue-grey-400">
                    Previous Report Checks
                  </div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label class="form-label">Property has existing EPC?</label>
                      <select appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeGeneralDetails.previousEpcExistsCode" (change)="previousEPCCheckChange()"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option value="NR">No</option>
                        <option value="Y">Yes</option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label">Reason for new EPC lodgement</label>
                        <select class="form-select" [(ngModel)]="eeGeneralDetails.previousEpcReasonCode"
                          [appHighlightRequired]="
                            eeGeneralDetails.previousEpcExistsCode == 'Y'
                          " [disabled]="
                            eeGeneralDetails.previousEpcExistsCode !== 'Y' ||
                            !isEdit
                          " (change)="
                            previousEPCReasonChange($event.target.value)
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'Previous EPC Reason'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="information" class="form-label mb-0">For information only</label>
                      <textarea class="form-control" id="information" rows="4"
                        [readonly]="true">{{ forInformationOnly }}</textarea>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <!-- here, hide before demo -->
                      <label hidden for="assessmentDate" class="form-label mb-0">Assessment date</label>
                      <div class="input-group">
                        <!-- here, hide before demo -->
                        <input hidden class="form-control" placeholder="yyyy-mm-dd" name="dp" id="assessmentDate"
                          [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" />
                        <!-- here, hide before demo -->
                        <button hidden class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                          type="button"></button>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label">Related Party Disclosure</label>
                        <!-- here, tbc related party disc, object is generic not general... should send numbers etc -->
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeGenericDetails.relatedPartyDisclosureNumber
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'Related Party Disclosure'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Property Details</div>
                  <div class="card-body">
                    <div class="mb-1">
                      <!-- here, hide before demo -->
                      <label hidden for="country" class="form-label mb-0">Country</label>
                      <!-- here, hide before demo -->
                      <select hidden id="country" class="form-select" [(ngModel)]="eeGeneralDetails.countryCode"
                        (ngModelChange)="
                          updateEeRRLookupCodesWithCountryCodeSpecificLookupItems(
                            eeGeneralDetails.countryCode
                          )
                        " [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let countryCode of countryLookupCodes" [value]="countryCode.lookupValue">
                          {{ countryCode.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1">
                      <label for="propertyType" class="form-label mb-0">Property Type</label>
                      <select appHighlightRequired="true" id="propertyType" class="form-select"
                        [(ngModel)]="eeGeneralDetails.propertyType" (ngModelChange)="onPropertyTypeChange()"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let propertyType of filterLookupCodes(
                              'PropertyType'
                            )
                          " [value]="propertyType.lookupValue">
                          {{ propertyType.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1">
                      <label for="transactionType" class="form-label mb-0">Transaction Type</label>
                      <select appHighlightRequired="true" id="transactionType" class="form-select"
                        [(ngModel)]="eeGeneralDetails.transactionType" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let property of filterLookupCodes('TransactionType')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1">
                      <label for="tenure" class="form-label mb-0">Tenure</label>
                      <select id="tenure" appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeGeneralDetails.tenure" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let tenure of filterLookupCodes('Tenure')" [value]="tenure.lookupValue">
                          {{ tenure.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <!-- Detachment Select Field -->
                    <div class="mb-1">
                      <label for="detachment" class="form-label mb-0">Detachment</label>
                      <select id="detachment" appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeGeneralDetails.builtForm" [disabled]="!isEdit"
                        (change)="changePartyWallConstruction()" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let detachment of filterLookupCodes('BuiltForm')
                          " [value]="detachment.lookupValue">
                          {{ detachment.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <!-- Terrain Select Field -->
                    <div class="mb-1">
                      <label for="terrain" class="form-label mb-0">Terrain</label>
                      <select id="terrain" appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeGeneralDetails.terrain" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let terrainType of filterLookupCodes('TerrainType')
                          " [value]="terrainType.lookupValue">
                          {{ terrainType.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <!-- Measurements Select Field -->
                    <div class="mb-1">
                      <label for="dimensionMeasurements" class="form-label mb-0">Dimension Measurements</label>
                      <select id="dimensionMeasurements" appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeGeneralDetails.measurements" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let measurements of filterLookupCodes(
                              'DimensionsType'
                            )
                          " [value]="measurements.lookupValue">
                          {{ measurements.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <div class="mb-1">
                      <input id="heatedBasement" class="form-check-input" type="checkbox"
                        (change)="onHeatedBasementChange($event)" [(ngModel)]="heatedBasement" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                      <label for="heatedBasement" class="form-label mb-0 ms-1">Heated Basement</label>
                    </div>

                    <!-- Extensions Select Field -->
                    <div class="mb-1">
                      <label for="extensions" class="form-label mb-0">Extensions</label>
                      <select id="extensions" appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeGeneralDetails.buildingConfiguration" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" (change)="updateBuildingExtensions()">
                        <option *ngFor="
                            let extension of filterLookupCodes('Extensions')
                          " [value]="extension.lookupValue">
                          {{ extension.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <!-- Conservatory Type Select Field -->
                    <div class="mb-1">
                      <label for="conservatoryType" class="form-label mb-0">Conservatory Type</label>
                      <select appHighlightRequired="true" class="form-select" id="conservatoryType"
                        [(ngModel)]="eeGeneralDetails.conservationType" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let property of filterLookupCodes(
                              'ConservatoryType'
                            )
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <!-- Habitable Room Count Input Field -->
                    <div class="mb-1">
                      <label class="form-label mb-0" for="habitableRoomCount">Habitable Room Count</label>
                      <input appHighlightRequired="true" class="form-control" id="habitableRoomCount" type="number"
                        min="1" max="99" [(ngModel)]="eeGeneralDetails.habitableRoomCount" name="habitableRoomCount"
                        #roomCount="ngModel" required [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      <!-- here, add error messages for room count-->
                      <div *ngIf="roomCount.errors && roomCount.dirty" class="error mt-1" style="color: red">
                        <div *ngIf="roomCount.errors.required">
                          Room count is required.
                        </div>
                        <div *ngIf="roomCount.errors.min">
                          Room count cannot be less than 1.
                        </div>
                        <div *ngIf="roomCount.errors.max">
                          Room count cannot be more than 99.
                        </div>
                      </div>
                    </div>

                    <!-- Heated Habitable Room Count Input Field -->
                    <div class="mb-1">
                      <label class="form-label mb-0" for="heatedRoomCount">Heated Habitable Room Count</label>
                      <select appHighlightRequired="true" class="form-select" id="heatedRoomCount"
                        [(ngModel)]="eeGeneralDetails.heatedRoomCount" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let number of getRoomCounts()" [value]="number">
                          {{ number }}
                        </option>
                      </select>
                    </div>

                    <!-- Total Fixed Light Outlets Input Field -->
                    <div class="mb-1">
                      <label class="form-label mb-0">Total Fixed Light Outlets</label>
                      <input appHighlightRequired="true" #lightCount="ngModel" id="totalFixedLightOutlets"
                        name="totalFixedLightOutlets" class="form-control" type="number" min="0" max="999"
                        [(ngModel)]="eeGeneralDetails.totalFixedLightOutlets" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                      <!-- here, add error messages for light outlets -->
                      <div *ngIf="lightCount.errors && lightCount.dirty" class="error mt-1" style="color: red">
                        <div *ngIf="lightCount.errors.min">
                          Total fixed light outlets cannot be a minus value.
                        </div>
                        <div *ngIf="lightCount.errors.max">
                          Total fixed light outlets cannot be more than 999.
                        </div>
                      </div>
                    </div>

                    <!-- Total Fixed LEL Outlets Input Field -->
                    <div class="mb-1">
                      <!-- old code -->
                      <!-- <label  class="form-label mb-0">Total Fixed LEL Outlets</label>
                      <input  class="form-control" type="number" min="0" [(ngModel)]="eeGeneralDetails.totalFixedLELBulbs" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}"> -->
                      <!-- here, add a select element instead of number input field allowing maximum value depending on fixed light outlets -->
                      <label class="form-label mb-0" for="
                    totalFixedLELOutlets">Total Fixed LEL Outlets</label>
                      <select appHighlightRequired="true" class="form-select" id="
                      totalFixedLELOutlets" [(ngModel)]="eeGeneralDetails.totalFixedLELOutlets" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let number of getLightCounts()" [value]="number">
                          {{ number }}
                        </option>
                      </select>
                    </div>

                    <!-- Total Fixed LED Outlets Input Field -->
                    <div class="mb-1 d-none">
                      <label for="totalFixedLEDOutlets" class="form-label mb-0">Total Fixed LED Outlets</label>
                      <input class="form-control" type="number" min="0" id="totalFixedLEDOutlets"
                        [(ngModel)]="eeGeneralDetails.totalFixedLEDBulbs" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>

                    <!-- Total Fixed CLF Outlets Input Field -->
                    <div class="mb-1 d-none">
                      <span class="form-label mb-0">Total Fixed CLF Outlets</span>
                      <input class="form-control" type="number" min="0"
                        [(ngModel)]="eeGeneralDetails.totalFixedCLFBulbs" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card mb-3" *ngIf="
                    eeGeneralDetails.propertyType ==
                      keyedLookUpCodes['PropertyType']['Flat'] ||
                    eeGeneralDetails.propertyType ==
                      keyedLookUpCodes['PropertyType']['Maisonette']
                  ">
                  <div class="card-header bg-blue-grey-400">
                    <!-- here, change it from Flat/Masionette to Position  -->
                    Flat/Masionette
                  </div>
                  <div class="card-body">
                    <!-- Flat Type Select Field -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <!-- here, change it from flat type to Position  -->
                        <label for="flatPosition" class="form-label mb-0">Flat Position</label>
                        <select appHighlightRequired="true" class="form-select" id="flatPosition"
                          [(ngModel)]="eeGeneralDetails.flatType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let flatlevel of filterLookupCodes('Flat Level')
                            " [value]="flatlevel.lookupValue">
                            {{ flatlevel.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Location In Block Select Field -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorLevel" class="form-label mb-0">Floor Level</label>
                        <select id="floorLevel" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeGeneralDetails.locationInBlock" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let flatLocation of filterLookupCodes(
                                'FlatLocation'
                              )
                            " [value]="flatLocation.lookupValue">
                            {{ flatLocation.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Corridor Type Select Field -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="corridorType" class="form-label mb-0">Corridor Type</label>
                        <select id="corridorType" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeGeneralDetails.corridorType" (ngModelChange)="onCorridorTypeChange()"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let corridor of filterLookupCodes(
                                'HeatlossCorridor'
                              )
                            " [value]="corridor.lookupValue">
                            {{ corridor.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <!-- Building part heat loss -->
                    <!-- here, not saving, not in API spec (never appeared in the xml) -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeGeneralDetails.corridorType ==
                        keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <div class="mb-1">
                        <label for="heatLossBuilding" class="form-label mb-0">Building Part Heat Loss Applied to</label>
                        <select id="heatLossBuilding" class="form-select"
                          [(ngModel)]="eeGeneralDetails.heatLossBuilding" [disabled]="!isEdit"
                          (change)="setBuildingHeatLoss()" [ngModelOptions]="{ standalone: true }">
                          <option *ngIf="eeGeneralDetails.heatLossBuilding === null" [value]="null">
                            {{ getDefaultOptionTextForHeatLoss() }} selected
                          </option>
                          <option *ngFor="let corridor of buildingParts" [value]="corridor.id">
                            {{ corridor.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Unheated Corridor Length Input Field (Conditional) -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeGeneralDetails.corridorType ==
                        keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <div class="mb-1">
                        <label for="unheatedCorridorLength" class="form-label mb-0">Unheated Corridor Length (m)</label>
                        <input id="unheatedCorridorLength" appHighlightRequired="true" class="form-control" type="text"
                          pattern="^\d*\.?\d{0,2}$" (input)="onCorridorChange($event.target.value)"
                          [(ngModel)]="eeGeneralDetails.unheatedCorridorLength" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" inputmode="decimal" placeholder="0.00" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card" *ngIf="
                    eeGeneralDetails.conservationType ==
                    keyedLookUpCodes['ConservatoryType']['Non-separated']
                  ">
                  <div class="card-header bg-blue-grey-400">Conservatory</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Double glazed"
                        [(ngModel)]="eeGeneralDetails.doubleGlazed" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          'modified-background-class':
                            hasAnActiveDataSet &&
                            eeGeneralDetails.doubleGlazed !==
                              eeGeneralDetailsForActiveDataSet.doubleGlazed
                        }" />
                      Double glazed
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="floorArea" class="form-label mb-0">Floor Area (&#13217;)</label>
                      <!-- here, add validation to Floor Area -->
                      <input appHighlightRequired="true" #floorArea="ngModel" class="form-control" name="floorArea"
                        type="number" min="1" max="999" required [(ngModel)]="eeGeneralDetails.floorArea"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          'modified-background-class':
                            hasAnActiveDataSet &&
                            eeGeneralDetails.floorArea !==
                              eeGeneralDetailsForActiveDataSet.floorArea
                        }" />
                      <!-- here, add error messages for floor area -->
                      <div *ngIf="floorArea.errors && floorArea.dirty" class="error mt-1" style="color: red">
                        <div *ngIf="floorArea.errors.required">
                          Floor area is required.
                        </div>
                        <div *ngIf="floorArea.errors.min">
                          Floor area cannot be less than 1 (&#13217;).
                        </div>
                        <div *ngIf="floorArea.errors.max">
                          Floor area cannot be more than 999 (&#13217;).
                        </div>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <!-- here, add validation to Glazed Perimeter -->
                      <label for="glazedPerimiter" class="form-label mb-0">Glazed Perimeter (m)</label>
                      <input appHighlightRequired="true" class="form-control" name="glazedPerimiter"
                        id="glazedPerimeter" type="number" min="1" max="999" required
                        [(ngModel)]="eeGeneralDetails.glazedPerimiter" #glazedPerimiter="ngModel" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          'modified-background-class':
                            hasAnActiveDataSet &&
                            eeGeneralDetails.glazedPerimiter !==
                              eeGeneralDetailsForActiveDataSet.glazedPerimiter
                        }" />
                      <!-- here, add error messages for glazed perimeter -->
                      <div *ngIf="glazedPerimiter.errors && glazedPerimiter.dirty" class="error mt-1"
                        style="color: red">
                        <div *ngIf="glazedPerimiter.errors.required">
                          Glazed Perimeter is required.
                        </div>
                        <div *ngIf="glazedPerimiter.errors.min">
                          Glazed Perimeter cannot be less than 1 (m).
                        </div>
                        <div *ngIf="glazedPerimiter.errors.max">
                          Glazed Perimeter cannot be more than 999 (m).
                        </div>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-3">
                        <label for="conservatoryHeight" class="form-label mb-0">Conservatory Height</label>
                        <select id="conservatoryHeight" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeGeneralDetails.conservatoryHeight" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'ConservatoryHeight'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="2">
        <!-- Openings Tab -->
        <a ngbNavLink (click)="onSelectTab(2)" role="button">
          Openings
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(2) === false ||
                  (isTabClicked(2) && !isOpeningsTabValid()),
                'bi bi-check-circle': isTabClicked(2) && isOpeningsTabValid(),
                'text-warning': isTabClicked(2) === false,
                'text-danger': isTabClicked(2) && !isOpeningsTabValid(),
                'text-success': isTabClicked(2) && isOpeningsTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header bg-blue-grey-400">Details</div>
                  <div class="card-body">
                    <form>
                      <div class="mb-1">
                        <label for="draughtProofing" class="form-label mb-0">Draughtproofing (%)</label>
                        <input appHighlightRequired="true" #draughtProofing="ngModel" id="draughtProofing"
                          class="form-control" type="number" min="0" max="100"
                          [(ngModel)]="eeOpeningDetails.draughtProofing" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- here, add error messages for Draughtproofing -->
                        <div *ngIf="
                            draughtProofing.errors && draughtProofing.dirty
                          " class="error mt-1" style="color: red">
                          <div *ngIf="draughtProofing.errors.min">
                            Draughtproofing cannot be minus %.
                          </div>
                          <div *ngIf="draughtProofing.errors.max">
                            Draughtproofing cannot be more than 100%.
                          </div>
                        </div>
                      </div>
                      <div class="mb-1">
                        <label for="externalDoors" class="form-label mb-0">External Doors</label>
                        <input appHighlightRequired="true" #externalDoors="ngModel" id="externalDoors"
                          class="form-control" type="number" min="0" max="20"
                          [(ngModel)]="eeOpeningDetails.externalDoors" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- here, add error messages for External Doors -->
                        <div *ngIf="externalDoors.errors && externalDoors.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="externalDoors.errors.min">
                            Number of external doors cannot be a minus value.
                          </div>
                          <div *ngIf="externalDoors.errors.max">
                            Number of external doors cannot be more than 20.
                          </div>
                        </div>
                      </div>
                      <div class="mb-1">
                        <label for="insulatedExternalDoors" class="form-label mb-0">Insulated External Doors</label>
                        <input appHighlightRequired="true" #insulatedExternalDoors="ngModel" id="insulatedExternalDoors"
                          class="form-control" type="number" min="0" max="20"
                          [(ngModel)]="eeOpeningDetails.insulatedExternalDoors" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- here, add error messages for Insulated External Doors -->
                        <div *ngIf="
                            insulatedExternalDoors.errors &&
                            insulatedExternalDoors.dirty
                          " class="error mt-1" style="color: red">
                          <div *ngIf="insulatedExternalDoors.errors.min">
                            Number of insulated external doors cannot be a minus
                            value.
                          </div>
                          <div *ngIf="insulatedExternalDoors.errors.max">
                            Number of insulated external doors cannot be more
                            than 20.
                          </div>
                        </div>
                      </div>
                      <div class="mb-1" *ngIf="eeOpeningDetails.insulatedExternalDoors > 0">
                        <label for="UValue" class="form-label mb-0">Door U-value</label>
                        <!-- here, add custom step so it will go up by 0.01 instead of whole numbers-->
                        <input required #doorUValue="ngModel" id="UValue" class="form-control" type="number" min="0.01"
                          max="3.0" step="0.01" [(ngModel)]="eeOpeningDetails.doorsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- here, add error messages for Door UValue-->
                        <div *ngIf="doorUValue.errors && doorUValue.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="doorUValue.errors.required">
                            Door UValue is required.
                          </div>
                          <div *ngIf="doorUValue.errors.min">
                            Door UValue cannot be less than 0.01.
                          </div>
                          <div *ngIf="doorUValue.errors.max">
                            Door UValue cannot be more than 3.0.
                          </div>
                        </div>
                      </div>
                      <div class="mb-1">
                        <label for="openFireplaces" class="form-label mb-0">Open Fireplaces</label>
                        <input appHighlightRequired="true" #openFireplaces="ngModel" id="openFireplaces"
                          class="form-control" type="number" min="0" max="99"
                          [(ngModel)]="eeOpeningDetails.openFireplaces" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- here, add error messages for Open Fireplaces -->
                        <div *ngIf="openFireplaces.errors && openFireplaces.dirty" class="error mt-1"
                          style="color: red">
                          <div *ngIf="openFireplaces.errors.min">
                            Number of open fireplaces cannot be a minus value.
                          </div>
                          <div *ngIf="openFireplaces.errors.max">
                            Number of open fireplaces cannot be more than 99.
                          </div>
                        </div>
                      </div>
                      <div class="mb-1">
                        <label for="ventilationType" class="form-label mb-0">Ventilation Type</label>
                        <select appHighlightRequired="true" id="ventilationType" class="form-select"
                          [(ngModel)]="eeOpeningDetails.ventilationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'VentilationType'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="form-check mb-1">
                        <input id="fixedAirConditioning" class="form-check-input" type="checkbox"
                          [(ngModel)]="eeOpeningDetails.fixedAirConditioning" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <label for="fixedAirConditioning" class="form-check-label">Fixed Air Conditioning</label>
                      </div>
                      <div class="mb-1 d-none">
                        <label for="draughtproofedDoorsCount" class="form-label mb-0">Draughtproofed doors</label>
                        <input id="draughtproofedDoorsCount" class="form-control" type="number" min="0" [(ngModel)]="
                            eeOpeningDetails.draughtproofedDoorsCount
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header bg-blue-grey-400">Windows</div>
                  <div class="card-body">
                    <!-- Coverage Select Field -->
                    <div class="mb-1">
                      <label class="form-label mb-0" for="GlazingCoverage">Coverage</label>
                      <select appHighlightRequired="true" class="form-select" id="GlazingCoverage"
                        (change)="onOpeningsChange()" [(ngModel)]="eeOpeningDetails.coverage" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let property of filterLookupCodes('GlazingCoverage')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <!-- Conditional Fields based on Coverage -->
                    <ng-container *ngIf="
                        keyedLookUpCodes['GlazingCoverage'] &&
                        (eeOpeningDetails.coverage ==
                          keyedLookUpCodes['GlazingCoverage']['Typical'] ||
                          eeOpeningDetails.coverage ==
                            keyedLookUpCodes['GlazingCoverage'][
                              'More than typical'
                            ] ||
                          eeOpeningDetails.coverage ==
                            keyedLookUpCodes['GlazingCoverage'][
                              'Less than typical'
                            ])
                      ">
                      <!-- Multi-glazing Field -->
                      <div class="mb-1">
                        <label class="form-label mb-0" for="multiGlazing">Multi-glazing (%)</label>
                        <input appHighlightRequired="true" class="form-control" #multiGlazing="ngModel"
                          id="multiGlazing" type="number" min="0" max="100" [(ngModel)]="eeOpeningDetails.multiGlazing"
                          (change)="setGlazingTypeArray()" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- Multi glazing value check -->
                        <div *ngIf="multiGlazing.errors && multiGlazing.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="multiGlazing.errors.min">
                            Multi-glazing cannot be minus %
                          </div>
                          <div *ngIf="multiGlazing.errors.max">
                            Multi-glazing cannot be more than 100%
                          </div>
                        </div>
                      </div>

                      <!-- Glazing Type Select Field -->
                      <div class="mb-1">
                        <label class="form-label mb-0" for="glazingType">Glazing Type</label>
                        <select appHighlightRequired="true" class="form-select" id="glazingType"
                          (change)="onOpeningsChange()" [(ngModel)]="eeOpeningDetails.glazingType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let lookupCode of glazingTypes" [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <!-- Conditional PVC Frames Checkbox -->
                      <div class="form-check mb-1" *ngIf="
                          eeOpeningDetails.glazingType ==
                            keyedLookUpCodes['Glazing Type'][
                              'Double glazed (before 2002)'
                            ] ||
                          eeOpeningDetails.glazingType ==
                            keyedLookUpCodes['Glazing Type'][
                              'Double glazed (before 2003)'
                            ] ||
                          eeOpeningDetails.glazingType ==
                            keyedLookUpCodes['Glazing Type'][
                              'Double glazed (unknown age)'
                            ]
                        ">
                        <input appHighlightRequired="true" class="form-check-input" type="checkbox"
                          [(ngModel)]="eeOpeningDetails.upvcFramed" [disabled]="!isEdit" aria-label="PVC Frames"
                          [ngModelOptions]="{ standalone: true }" />PVC Frames
                      </div>

                      <!-- Glazing Gap Select -->
                      <div class="mb-1" *ngIf="eeOpeningDetails.upvcFramed">
                        <label class="form-label mb-0" for="glazingGap">Glazing Gap</label>
                        <select appHighlightRequired="true" class="form-select" id="glazingGap"
                          [(ngModel)]="eeOpeningDetails.glazingGap" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes('GlazingGap')
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <!-- U-value and G-value Inputs -->
                      <div *ngIf="
                          eeOpeningDetails.glazingType ==
                            keyedLookUpCodes['Glazing Type'][
                              'Double glazed, data known'
                            ] ||
                          eeOpeningDetails.glazingType ==
                            keyedLookUpCodes['Glazing Type'][
                              'Triple glazed, data known'
                            ]
                        ">
                        <div class="mb-1">
                          <label class="form-label mb-0" for="UValue">U-value</label>
                          <input appHighlightRequired="true" class="form-control" id="UValue" type="number" min="0"
                            [(ngModel)]="eeOpeningDetails.UValue" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }" />
                        </div>

                        <div class="mb-1">
                          <label class="form-label mb-0" for="GValue">G-value</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="0" id="GValue"
                            [(ngModel)]="eeOpeningDetails.GValue" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }" />
                        </div>

                        <div class="mb-1">
                          <label class="form-label mb-0" for="windowTransmissionDataSource">Data source</label>
                          <select appHighlightRequired="true" class="form-select" id="windowTransmissionDataSource"
                            [(ngModel)]="
                              eeOpeningDetails.windowTransmissionDataSource
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="
                                let lookupCode of filterLookupCodes(
                                  'WindowTransmissionDataSource'
                                )
                              " [value]="lookupCode.lookupValue">
                              {{ lookupCode.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="3">
        <!-- Main Building Tab -->
        <a ngbNavLink (click)="onSelectTab(3)" role="button">
          Main Building
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(3) === false ||
                  (isTabClicked(3) && !isMainBuildingTabValid()),
                'bi bi-check-circle':
                  isTabClicked(3) && isMainBuildingTabValid(),
                'text-warning': isTabClicked(3) === false,
                'text-danger': isTabClicked(3) && !isMainBuildingTabValid(),
                'text-success': isTabClicked(3) && isMainBuildingTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row mb-2">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                  <div class="card-header bg-blue-grey-400">
                    Building Part Details
                  </div>
                  <div class="card-body">
                    <div class="col-md-6">
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label class="form-label mb-0" for="buildingPartAge">Building Part Age</label>
                          <select appHighlightRequired="true" class="form-select" id="buildingPartAge"
                            [(ngModel)]="eeBDMainBuilding.buildingPartAge" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="let property of constructionAgeList" [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                              {{ property.lookupValue }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400">
                        <button class="btn btn-primary me-2 mb-1" (click)="
                            openDimensionDetailsModal('eeBDMainBuilding')
                          ">
                          Dimensions
                          <span *ngIf="
                              !buildingPartDimensionsAreValid('eeBDMainBuilding')
                            " ngbTooltip="Some dimensions details are invalid">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                        </button>
                        <button *ngIf="
                            keyedLookUpCodes['GlazingCoverage'] &&
                            (eeOpeningDetails?.coverage ==
                              keyedLookUpCodes['GlazingCoverage'][
                                'Much more than typical'
                              ] ||
                              eeOpeningDetails?.coverage ==
                                keyedLookUpCodes['GlazingCoverage'][
                                  'Much less than typical'
                                ])
                          " class="btn btn-primary mb-1" (click)="
                            openEEOpeningsMeasurementWindowsModal(
                              eeOpeningDetails.id,
                              0
                            )
                          ">
                          Measured Windows
                          <span *ngIf="!isMeasuredWindowsValid()"
                            ngbTooltip=" Ensure to add a window for at least 1 building part">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                          <span *ngIf="
                              isMeasuredWindowsValid() &&
                              !hasWindowsForBuildingPart(0)
                            " ngbTooltip="Make sure that you added all the windows for Main Building">
                            <i class="bi bi-icon bi-exclamation-circle"></i>
                          </span>
                          <span *ngIf="
                              hasWindowsForBuildingPart(0) &&
                              !hasAreaForBuildingPart(0)
                            " ngbTooltip="Please fill in all the fields for Measured Windows">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox"
                          [(ngModel)]="showAdditionalWall.eeBDMainBuilding"
                          (change)="onAdditionalWallChangeMainBuilding()" [disabled]="
                            !isEdit ||
                            (showAdditionalWall.eeBDMainBuilding &&
                              shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() && getStoredHeatLoss('eeBDMainBuilding') == 0)
                          " [ngModelOptions]="{ standalone: true }" aria-label="Alternative Wall 1" />
                          <label class="form-check-label">Alternative Wall</label>
                        <span *ngIf="
                            !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() &&
                            !atLeast1BuildingPartHasAnAdditionalWall()
                          ">
                          <i class="icon icon-alert-circle s16 red-fg"></i>
                          <i ngbTooltip="At least 1 building part must have an alternative wall"
                            class="bi bi-icon bi-info-circle"></i>
                        </span>
                      </div>
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showRoofRoom.eeBDMainBuilding"
                          (change)="onRoofRoomChangeMainBuilding()" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" aria-label="Roof Room" />
                          <label class="form-check-label">Roof Room</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header bg-blue-grey-400">Walls</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="construction" class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.wallsConstruction" (change)="
                            onWallConstructionChange('eeBDMainBuilding')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDMainBuilding.wallThicknessMeasured" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" aria-label="Thickness Measured" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.wallThicknessMeasured">
                      <div class="mb-1">
                        <label for="wallThickness" class="form-label mb-0">Wall thickness (mm)</label>
                        <input appHighlightRequired="true" #wallThickness="ngModel" class="form-control" type="number"
                          min="50" max="1500" [(ngModel)]="eeBDMainBuilding.wallsWallThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            wallThickness.invalid &&
                            (wallThickness.dirty || wallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="wallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="wallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Insulation Type (Cavity Walls) -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.wallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="InsulationTypeOne" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Type for Non-Cavity Walls -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.wallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="insulationType" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.wallsInsulationType !== 4 &&
                        eeBDMainBuilding.wallsInsulationType !== 2 &&
                        eeBDMainBuilding.wallsInsulationType !== 5 &&
                        eeBDMainBuilding.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDMainBuilding.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDMainBuilding.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="insulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDMainBuilding.wallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulation" class="form-label mb-0">Measured Insulation</label>
                        <input class="form-control" type="number" min="0"
                          [(ngModel)]="eeBDMainBuilding.wallMeasuredInsulation" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulationLambda" class="form-label mb-0">Measured Insulation
                          Lambda</label>
                        <select class="form-select" [(ngModel)]="
                            eeBDMainBuilding.wallMeasuredInsulationLambda
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDMainBuilding.uValueknown"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" aria-label="U-Value known" />
                      <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.uValueknown">
                      <div class="mb-1">
                        <label for="uValueOne" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #uValueOne="ngModel" class="form-control" type="number"
                          min="0.01" max="2.5" [(ngModel)]="eeBDMainBuilding.wallsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            uValueOne.invalid &&
                            (uValueOne.dirty || uValueOne.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="uValueOne.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="uValueOne.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Dry Lined -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDMainBuilding.wallsDryLined"
                        [disabled]="
                          !isEdit ||
                          disableEditDryLined('eeBDMainBuilding', 'walls')
                        " [ngModelOptions]="{ standalone: true }" aria-label="Dry lined?" />
                      <label class=form-label>Dry lined?</label>
                    </div>
                    <!-- Party Wall Construction Main Building -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="partyWallConstruction" class="form-label mb-0">Party Wall Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.partyWallConstruction" [disabled]="
                            !isEdit ||
                            eeGeneralDetails.builtForm ==
                              keyedLookUpCodes['BuiltForm']['Detached'] ||
                            changePartyWallConstructionIfAllZero(
                              'eeBDMainBuilding'
                            )
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'PartyWallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <span *ngIf="
                          allPartyWallConstructionsNotApplicableIfNotDetached()
                        " ngbTooltip="Ensure to add a PW Construction and Length for at least 1 building part">
                        <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                      </span>
                      <span *ngIf="
                          !allPartyWallConstructionsNotApplicableIfNotDetached() &&
                          changePartyWallConstructionIfAllZero(
                            'eeBDMainBuilding'
                          ) &&
                          !isDetached()
                        " ngbTooltip="All Party Wall lengths are 0. 'Not Applicable' is automatically selected.">
                        <i class="bi bi-exclamation-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="showAdditionalWall.eeBDMainBuilding">
                <div class="card">
                  <div class="card-header">Alternative Wall</div>

                  <div class="card-body" fxLayout="column" fxLayoutGap="8px">
                    <!-- Alternative Wall -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="additionalWallWallArea" class="form-label mb-0">Area (m²)</label>
                        <input appHighlightRequired="true" #additionalWallWallArea="ngModel" id="additionalWallWallArea"
                          class="form-control" type="number" min="0.01" step="0.01" max="999"
                          [(ngModel)]="eeBDMainBuilding.additionalWallWallArea"
                          [readonly]="eeBDMainBuilding.shelteredWall" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- Area Validation -->
                        <div *ngIf="
                            additionalWallWallArea.invalid &&
                            (additionalWallWallArea.dirty ||
                              additionalWallWallArea.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="additionalWallWallArea.errors?.['min']">
                            Area cannot be less than 0.01.
                          </span>
                          <span *ngIf="additionalWallWallArea.errors?.['max']">
                            Area cannot be more than 999.
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Construction -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="additionalWallsConstruction" class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDMainBuilding.additionalWallsConstruction
                          " (change)="
                            onaAlternativeWallConstructionChange(
                              'eeBDMainBuilding'
                            )
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Thickness Measured -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="
                          eeBDMainBuilding.additionalWallThicknessMeasured
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <!-- Wall Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.additionalWallThicknessMeasured">
                      <div class="mb-1">
                        <label for="additionalWallsWallThickness" class="form-label mb-0">Wall thickness (mm)</label>
                        <input appHighlightRequired="true" #additionalWallsWallThickness="ngModel" class="form-control"
                          type="number" min="50" max="1500" [(ngModel)]="
                            eeBDMainBuilding.additionalWallsWallThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            additionalWallsWallThickness.invalid &&
                            (additionalWallsWallThickness.dirty ||
                              additionalWallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="additionalWallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="additionalWallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Insulation Type (Cavity Walls) -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.additionalWallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="InsulationTypeOne" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDMainBuilding.additionalWallsInsulationType
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Type (Non-Cavity Walls) -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.additionalWallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="InsulationTypeTwo" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDMainBuilding.additionalWallsInsulationType
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.additionalWallsInsulationType !== 4 &&
                        eeBDMainBuilding.additionalWallsInsulationType !== 2 &&
                        eeBDMainBuilding.additionalWallsInsulationType !== 5 &&
                        eeBDMainBuilding.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDMainBuilding.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDMainBuilding.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="insulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDMainBuilding.additionalWallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulation" class="form-label mb-0">Measured
                          Insulation</label>
                        <input class="form-control" type="number" min="0" [(ngModel)]="
                            eeBDMainBuilding.alternativeWall1MeasuredInsulation
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulationLambda" class="form-label mb-0">Measured
                          Insulation Lambda</label>
                        <select class="form-select" [(ngModel)]="
                            eeBDMainBuilding.alternativeWall1MeasuredInsulationLambda
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value Known -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDMainBuilding.additionalWallUValueKnown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value Input -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.additionalWallUValueKnown">
                      <div class="mb-1">
                        <label for="additionalWallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #additionalWallsUValue="ngModel" class="form-control"
                          type="number" min="0.01" max="2.5" [(ngModel)]="eeBDMainBuilding.additionalWallsUValue"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            additionalWallsUValue.invalid &&
                            (additionalWallsUValue.dirty ||
                              additionalWallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="additionalWallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="additionalWallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Dry Lined? -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDMainBuilding.additionalWallsDryLined" [disabled]="
                          !isEdit ||
                          disableEditDryLined(
                            'eeBDMainBuilding',
                            'additionalWalls'
                          )
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>

                    <!-- Sheltered Wall -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        (eeGeneralDetails.propertyType ==
                          keyedLookUpCodes['PropertyType']['Flat'] ||
                          eeGeneralDetails.propertyType ==
                            keyedLookUpCodes['PropertyType']['Maisonette']) &&
                        eeGeneralDetails.corridorType ==
                          keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDMainBuilding.shelteredWall"
                        [disabled]="
                          !isEdit ||
                          (showAdditionalWall.eeBDMainBuilding && getStoredHeatLoss('eeBDMainBuilding') == 0)
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Sheltered Wall</label>

                      <span *ngIf="
                          !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor()
                        " ngbTooltip="Must be true for exactly 1 building part">
                        <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header blue-grey-400">Floor</div>
                  <div class="card-body" fxLayout="column" fxLayoutGap="8px">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorHeatLossType" class="form-label mb-0">Heat loss type</label>
                        <select appHighlightRequired="true" id="floorHeatLossType" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.floorHeatLossType" (change)="onHeatLossTypeChange()"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorHeatloss')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorConstruction" class="form-label mb-0">Construction</label>
                        <select [appHighlightRequired]="eeBDMainBuilding.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] &&
                            eeBDMainBuilding.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] &&
                            eeBDMainBuilding.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" 
                            id="floorConstruction" class="form-select" [(ngModel)]="eeBDMainBuilding.floorConstruction" (change)="onFloorConstructionChange('eeBDMainBuilding')"
                            [disabled]="!isEdit ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] || 
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorConstruction')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorInsulationType" class="form-label mb-0">Insulation type</label>
                        <select [appHighlightRequired]="eeBDMainBuilding.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] &&
                            eeBDMainBuilding.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] &&
                            eeBDMainBuilding.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" id="floorInsulationType" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.floorInsulationType" [disabled]="!isEdit ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorInsulation')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.floorInsulationType == keyedLookUpCodes['FloorInsulation']['Retro-fitted']">
                      <div class="mb-1">
                        <label for="floorInsulationThickness" class="form-label mb-0">Insulation Thickness</label>
                        <select appHighlightRequired="true" id="floorInsulationThickness" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.floorInsulationThickness" [disabled]="!isEdit ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space'] ||
                            eeBDMainBuilding.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorInsulationThickness')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDMainBuilding.floorUValueKnown"
                        [disabled]="
                          !isEdit ||
                          eeBDMainBuilding.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Same dwelling below'
                            ] ||
                          eeBDMainBuilding.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Above a partially heated space'
                            ] ||
                          eeBDMainBuilding.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Another dwelling below'
                            ]
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.floorUValueKnown">
                      <div class="mb-1">
                        <label for="floorUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #eeBDMainBuildingfloorUValue="ngModel" id="floorUValue"
                          class="form-control" type="number" step="0.01" min="0.01" max="2.3"
                          [(ngModel)]="eeBDMainBuilding.floorUValue" [disabled]="
                            !isEdit ||
                            eeBDMainBuilding.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDMainBuilding.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space'
                              ] ||
                            eeBDMainBuilding.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }" />
                        <!-- Floor U-Value Validation -->
                        <div *ngIf="
                            eeBDMainBuildingfloorUValue.invalid &&
                            (eeBDMainBuildingfloorUValue.dirty ||
                              eeBDMainBuildingfloorUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDMainBuildingfloorUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDMainBuildingfloorUValue.errors?.['max']">
                            U-value must have a maximum of 2.3.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header blue-grey-400">Roof</div>
                  <div class="card-body" fxLayout="column" fxLayoutGap="8px">
                    <!-- Construction -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="roofConstruction" class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" id="roofConstruction" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.roofConstruction" (change)="
                            onRoofConstructionChange(
                              $event.target.value,
                              'eeBDMainBuilding'
                            )
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'RoofConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Type -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="roofInsulationType" class="form-label mb-0">Insulation type</label>
                        <select [appHighlightRequired]="
                            eeBDMainBuilding.roofConstruction !=
                              keyedLookUpCodes['RoofConstruction'][
                                'Same dwelling above'
                              ] &&
                            eeBDMainBuilding.roofConstruction !=
                              keyedLookUpCodes['RoofConstruction'][
                                'Another dwelling above'
                              ]
                          " id="roofInsulationType" id="roofInsulationType" class="form-select"
                          [(ngModel)]="eeBDMainBuilding.roofInsulationType" (change)="
                            setRoofInsulationThicknessArrays('eeBDMainBuilding')
                          " [disabled]="
                            !isEdit ||
                            eeBDMainBuilding.roofConstruction ==
                              keyedLookUpCodes['RoofConstruction'][
                                'Same dwelling above'
                              ] ||
                            eeBDMainBuilding.roofConstruction ==
                              keyedLookUpCodes['RoofConstruction'][
                                'Another dwelling above'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of roofInsulationTypesByBuildingPart.eeBDMainBuilding
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="roofInsulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select [appHighlightRequired]="
                            eeBDMainBuilding.roofConstruction !=
                              keyedLookUpCodes['RoofConstruction'][
                                'Same dwelling above'
                              ] &&
                            eeBDMainBuilding.roofConstruction !=
                              keyedLookUpCodes['RoofConstruction'][
                                'Another dwelling above'
                              ] &&
                            eeBDMainBuilding.roofInsulationType !=
                              keyedLookUpCodes['RoofInsulationLocation'][
                                'None'
                              ] &&
                            eeBDMainBuilding.roofInsulationType !=
                              keyedLookUpCodes['RoofInsulationLocation'][
                                'Unknown'
                              ]
                          " id="roofInsulationThickness" class="form-select"
                          [(ngModel)]="mainBuildingRoofInsulationThickness" [disabled]="
                            !isEdit ||
                            eeBDMainBuilding.roofInsulationType ==
                              keyedLookUpCodes['RoofInsulationLocation'][
                                'None'
                              ] ||
                            eeBDMainBuilding.roofInsulationType ==
                              keyedLookUpCodes['RoofInsulationLocation'][
                                'Unknown'
                              ] ||
                            eeBDMainBuilding.roofConstruction ==
                              keyedLookUpCodes['RoofConstruction'][
                                'Same dwelling above'
                              ] ||
                            eeBDMainBuilding.roofConstruction ==
                              keyedLookUpCodes['RoofConstruction'][
                                'Another dwelling above'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of roofInsulationThicknessesByBuildingPart.eeBDMainBuilding
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value Known -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDMainBuilding.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Same dwelling above'
                          ] &&
                        eeBDMainBuilding.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Another dwelling above'
                          ]
                      ">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDMainBuilding.roofUValueKnown"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.roofUValueKnown">
                      <div class="mb-1">
                        <label for="roofUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" id="roofUValue" class="form-control" type="number" min="0.05"
                          max="2.3" step="0.01" #eeBDMainBuildingroofUValue="ngModel"
                          [(ngModel)]="eeBDMainBuilding.roofUValue" [disabled]="
                            !isEdit || !eeBDMainBuilding.roofUValueKnown
                          " [ngModelOptions]="{ standalone: true }" />
                        <!-- Roof U-Value Validation -->
                        <div *ngIf="
                            eeBDMainBuildingroofUValue.invalid &&
                            (eeBDMainBuildingroofUValue.dirty ||
                              eeBDMainBuildingroofUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDMainBuildingroofUValue.errors?.['min']">
                            U-value must be at least 0.05.
                          </span>
                          <span *ngIf="eeBDMainBuildingroofUValue.errors?.['max']">
                            U-value must have a maximum of 2.3.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="showRoofRoom.eeBDMainBuilding">
                  <div class="card-header blue-grey-400">Roof Rooms</div>
                  <div class="card-body" fxLayout="column" fxLayoutGap="8px">
                    <!-- Area -->
                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsArea" class="form-label mb-0">Area (m²)</label>
                      <input appHighlightRequired="true" id="roofRoomsArea" #roofRoomsArea="ngModel"
                        class="form-control" type="number" min="1" max="999"
                        [(ngModel)]="eeBDMainBuilding.roofRoomsArea" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                      <div *ngIf="roofRoomsArea.errors && roofRoomsArea.dirty" class="error mt-1" style="color: red">
                        <div *ngIf="roofRoomsArea.errors.min">
                          Roof room area cannot be less than 1.
                        </div>
                        <div *ngIf="roofRoomsArea.errors.max">
                          Roof room area cannot exceed 999.
                        </div>
                      </div>
                    </div>

                    <!-- Age -->
                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsAge" class="form-label mb-0">Age</label>
                      <select appHighlightRequired="true" id="roofRoomsAge" class="form-select"
                        [(ngModel)]="eeBDMainBuilding.roofRoomsAge" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let age of constructionAgeList" [value]="age.lookupValue">
                          {{ age.lookUpItem }} {{ age.lookupValue }}
                        </option>
                      </select>
                    </div>

                    <!-- Insulation -->
                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsInsulation" class="form-label mb-0">Insulation</label>
                      <select appHighlightRequired="true" id="roofRoomsInsulation" class="form-select"
                        [(ngModel)]="eeBDMainBuilding.roofRoomsInsulation" (change)="
                          setRoofRoomsInsulationThicknessArrays(
                            'eeBDMainBuilding'
                          )
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let insulation of filterLookupCodes(
                              'RoofRoomInsulationType'
                            )
                          " [value]="insulation.lookupValue">
                          {{ insulation.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="thicknessAtCeiling">Thickness (at ceiling)</label>
                        <select id="thicknessAtCeiling" [appHighlightRequired]="eeBDMainBuilding.roofRoomsInsulation != keyedLookUpCodes['RoofRoomInsulationType']['As built'] &&
                            eeBDMainBuilding.roofRoomsInsulation != keyedLookUpCodes['RoofRoomInsulationType']['Unknown']" class="form-select" [(ngModel)]="eeBDMainBuilding.roofRoomsThickness" 
                            [disabled]="!isEdit || (eeBDMainBuilding.roofRoomsInsulation && (eeBDMainBuilding.roofRoomsInsulation === keyedLookUpCodes['RoofRoomInsulationType']['As built'] 
                            || eeBDMainBuilding.roofRoomsInsulation === keyedLookUpCodes['RoofRoomInsulationType']['Unknown']))" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let thickness of roofRoomsInsulationThicknessesByBuildingPart.eeBDMainBuilding" [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Roof Room connected"
                        [(ngModel)]="eeBDMainBuilding.roofRoomsAdjoining" [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Roof Room connected?</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="!eeBDMainBuilding.simplifiedMethod">
                      <button class="btn btn-primary" (click)="openEEBDMainBuildingExtendedDataModal(1)">
                        Extended Data<span *ngIf="!roofRoomExtendedDataValid('eeBDMainBuilding')">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400 d-none">
                      <label for="simplifiedMethod" class="form-check-label">Simplified method</label>
                      <input id="simplifiedMethod" class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDMainBuilding.simplifiedMethod" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="roofRoomsType" class="form-label mb-0">Roof Room Type</label>
                      <select id="roofRoomsType" class="form-select" [(ngModel)]="eeBDMainBuilding.roofRoomsType"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let property of filterLookupCodes('roofRoomsType')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="gableWall1Type" class="form-label mb-0">Gable Wall 1 Type</label>
                      <select id="gableWall1Type" class="form-select" [(ngModel)]="eeBDMainBuilding.gableWall1Type"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let property of filterLookupCodes('gableWall1Type')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="gableWall1Length" class="form-label mb-0">Gable Wall 1 Length</label>
                      <input id="gableWall1Length" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.gableWall1Length" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="gableWall1Height" class="form-label mb-0">Gable Wall 1 Height</label>
                      <input id="gableWall1Height" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.gableWall1Height" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="gableWall2Type" class="form-label mb-0">Gable Wall 2 Type</label>
                      <select id="gableWall2Type" class="form-select" [(ngModel)]="eeBDMainBuilding.gableWall2Type"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="
                            let property of filterLookupCodes('gableWall2Type')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="gableWall2Length" class="form-label mb-0">Gable Wall 2 Length</label>
                      <input id="gableWall2Length" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.gableWall2Length" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="gableWall2Height" class="form-label mb-0">Gable Wall 2 Height</label>
                      <input id="gableWall2Height" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.gableWall2Height" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="commonWall1Length" class="form-label mb-0">Common Wall 1 Length</label>
                      <input id="commonWall1Length" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.commonWall1Length" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="commonWall1Height" class="form-label mb-0">Common Wall 1 Height</label>
                      <input id="commonWall1Height" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.commonWall1Height" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="commonWall2Length" class="form-label mb-0">Common Wall 2 Length</label>
                      <input id="commonWall2Length" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.commonWall2Length" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400" *ngIf="eeBDMainBuilding.simplifiedMethod">
                      <label for="commonWall2Height" class="form-label mb-0">Common Wall 2 Height</label>
                      <input id="commonWall2Height" class="form-control" type="number" min="0"
                        [(ngModel)]="eeBDMainBuilding.commonWall2Height" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="4" *ngIf="showBuildingExtensions.extension1">
        <!-- Extension 1 Tab -->
        <a ngbNavLink (click)="onSelectTab(4)" role="button" *ngIf="showBuildingExtensions.extension1">
          Extension 1
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(4) === false ||
                  (isTabClicked(4) && !isExtension1TabValid()),
                'bi bi-check-circle': isTabClicked(4) && isExtension1TabValid(),
                'text-warning': isTabClicked(4) === false,
                'text-danger': isTabClicked(4) && !isExtension1TabValid(),
                'text-success': isTabClicked(4) && isExtension1TabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row mb-2">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <!-- Building Part Details card -->
                <div class="card">
                  <div class="card-header blue-grey-400">
                    Building Part Details
                  </div>
                  <div class="card-body">
                    <!-- Left Column -->
                    <div class="col-md-6">
                      <!-- Building Part Age -->
                      <div class="mb-1 mh-16 mv-8 w-400">
                        <label for="buildingPartAge" class="form-label mb-0">Building Part Age</label>
                        <select appHighlightRequired="true" id="buildingPartAge" class="form-select"
                          [(ngModel)]="eeBDEx1.buildingPartAge" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of constructionAgeList" [value]="property.lookupValue">
                            {{ property.lookUpItem }} {{ property.lookupValue }}
                          </option>
                        </select>
                      </div>

                      <!-- Buttons -->
                      <button class="btn btn-primary me-2" (click)="openDimensionDetailsModal('eeBDEx1')">
                        Dimensions
                        <span *ngIf="!buildingPartDimensionsAreValid('eeBDEx1')">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                      <button class="btn btn-primary" *ngIf="
                          keyedLookUpCodes['GlazingCoverage'] &&
                          (eeOpeningDetails.coverage ==
                            keyedLookUpCodes['GlazingCoverage'][
                              'Much more than typical'
                            ] ||
                            eeOpeningDetails.coverage ==
                              keyedLookUpCodes['GlazingCoverage'][
                                'Much less than typical'
                              ])
                        " (click)="
                          openEEOpeningsMeasurementWindowsModal(
                            eeOpeningDetails.id,
                            1
                          )
                        ">
                        Measured Windows
                        <span *ngIf="!isMeasuredWindowsValid()"
                          ngbTooltip=" Ensure to add a window for at least 1 building part">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                        <span *ngIf="
                            isMeasuredWindowsValid() &&
                            !hasWindowsForBuildingPart(1)
                          " ngbTooltip="Make sure that you added all the windows for Extension 1">
                          <i class="bi bi-icon bi-exclamation-circle"></i>
                        </span>
                        <span *ngIf="
                            hasWindowsForBuildingPart(1) &&
                            !hasAreaForBuildingPart(1)
                          " ngbTooltip="Please fill in all the fields for Measured Windows">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                    </div>

                    <!-- Right Column -->
                    <div class="col-md-6">
                      <!-- Alternative Wall 1 -->
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showAdditionalWall.eeBDEx1"
                          (change)="onAdditionalWallChange(2)" [disabled]="
                            !isEdit ||
                            (showAdditionalWall.eeBDEx1 &&
                              shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() && getStoredHeatLoss() == 1)
                          " [ngModelOptions]="{ standalone: true }" aria-label="Alternative Wall 1" />
                        <label class="form-check-label">Alternative Wall</label>
                        <span *ngIf="
                            !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() &&
                            !atLeast1BuildingPartHasAnAdditionalWall()
                          ">
                          <i class="icon icon-alert-circle s16 red-fg"></i>
                          <i ngbTooltip="At least 1 building part must have an alternative wall"
                            class="bi bi-icon bi-info-circle"></i>
                        </span>
                      </div>

                      <!-- Roof Room -->
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showRoofRoom.eeBDEx1"
                          aria-label="Roof Room" (change)="onRoofRoomChange(2)" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                          <label class="form-check-label">Roof Room</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header blue-grey-400">Walls</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="wallsConstruction" class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="eeBDEx1.wallsConstruction"
                          (change)="onWallConstructionChange('eeBDEx1')" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.wallThicknessMeasured"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx1.wallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx1WallsWallThickness" class="form-label mb-0">Wall thickness (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx1WallsWallThickness="ngModel" class="form-control"
                          type="number" min="50" max="1500" [(ngModel)]="eeBDEx1.wallsWallThickness"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx1WallsWallThickness.invalid &&
                            (eeBDEx1WallsWallThickness.dirty ||
                              eeBDEx1WallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx1WallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx1WallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Insulation type for Cavity walls -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.wallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="wallsInsulationType" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx1.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation type for Non-Cavity walls -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.wallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="property" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx1.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.wallsInsulationType !== 4 &&
                        eeBDEx1.wallsInsulationType !== 2 &&
                        eeBDEx1.wallsInsulationType !== 5 &&
                        eeBDEx1.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx1.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx1.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="wallsInsulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx1.wallsInsulationThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulation" class="form-label mb-0">Measured Insulation</label>
                        <input id="wallMeasuredInsulation" class="form-control" type="number" min="0"
                          [(ngModel)]="eeBDEx1.wallMeasuredInsulation" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulationLambda" class="form-label mb-0">Measured Insulation
                          Lambda</label>
                        <select class="form-select" [(ngModel)]="eeBDEx1.wallMeasuredInsulationLambda"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value known -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.uValueknown"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx1.uValueknown">
                      <div class="mb-1">
                        <label for="eeBDEx1WallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" class="form-control" #eeBDEx1WallsUValue="ngModel"
                          type="number" min="0.01" max="2.5" [(ngModel)]="eeBDEx1.wallsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx1WallsUValue.invalid &&
                            (eeBDEx1WallsUValue.dirty ||
                              eeBDEx1WallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx1WallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx1WallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Dry lined -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.wallsDryLined" [disabled]="
                          !isEdit || disableEditDryLined('eeBDEx1', 'walls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>

                    <!-- Party Wall Construction - Extension 1 -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="partyWallConstructionEx1" class="form-label mb-0">Party Wall Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx1.partyWallConstruction" [disabled]="
                            !isEdit ||
                            eeGeneralDetails.builtForm ==
                              keyedLookUpCodes['BuiltForm']['Detached'] ||
                            changePartyWallConstructionIfAllZero('eeBDEx1')
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'PartyWallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <span *ngIf="
                          allPartyWallConstructionsNotApplicableIfNotDetached()
                        " ngbTooltip="Ensure to add a PW Construction and Length for at least 1 building part">
                        <i class="bi bi-exclamation-circle text-danger"></i>
                      </span>
                      <span *ngIf="
                          !allPartyWallConstructionsNotApplicableIfNotDetached() &&
                          changePartyWallConstructionIfAllZero('eeBDEx1') &&
                          !isDetached()
                        " ngbTooltip="All Party Wall lengths are 0. 'Not Applicable' is automatically selected.">
                        <i class="bi bi-exclamation-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="showAdditionalWall.eeBDEx1">
                <div class="card">
                  <div class="card-header blue-grey-400">Alternative Wall</div>
                  <div class="card-body">
                    <!-- Extension 1 Alternative Wall -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx1AdditionalWallWallArea">Area (m<sup>2</sup>)</label>
                        <input appHighlightRequired="true" #eeBDEx1AdditionalWallWallArea="ngModel" class="form-control"
                          [readonly]="eeBDEx1.shelteredWall" [(ngModel)]="eeBDEx1.additionalWallWallArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" type="number" min="0.01"
                          step="0.01" max="999" />
                        <!-- Area Validation -->
                        <div *ngIf="
                            eeBDEx1AdditionalWallWallArea.invalid &&
                            (eeBDEx1AdditionalWallWallArea.dirty ||
                              eeBDEx1AdditionalWallWallArea.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx1AdditionalWallWallArea.errors?.['min']">
                            Area cannot be less than 0.01.
                          </span>
                          <span *ngIf="eeBDEx1AdditionalWallWallArea.errors?.['max']">
                            Area cannot be more than 999.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx1AdditionalWallsConstruction">Construction</label>
                        <select appHighlightRequired="true" class="form-select" id="eeBDEx1AdditionalWallsConstruction"
                          [(ngModel)]="eeBDEx1.additionalWallsConstruction" (change)="
                            onaAlternativeWallConstructionChange('eeBDEx1')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDEx1.additionalWallThicknessMeasured" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx1.additionalWallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx1AdditionalWallsWallThickness" class="form-label mb-0">Wall thickness
                          (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx1AdditionalWallsWallThickness="ngModel"
                          class="form-control" name="Wallthickness" type="number" min="50" max="1500"
                          [(ngModel)]="eeBDEx1.additionalWallsWallThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx1AdditionalWallsWallThickness.invalid &&
                            (eeBDEx1AdditionalWallsWallThickness.dirty ||
                              eeBDEx1AdditionalWallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx1AdditionalWallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx1AdditionalWallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.additionalWallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx1AdditionalWallsInsulationType">Insulation
                          type</label>
                        <select id="eeBDEx1AdditionalWallsInsulationType" appHighlightRequired="true"
                          class="form-select" [(ngModel)]="eeBDEx1.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.additionalWallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0" label="eeBDEx1AdditionalWallsInsulationType">Insulation
                          type</label>
                        <select id="eeBDEx1AdditionalWallsInsulationType" appHighlightRequired="true"
                          class="form-select" [(ngModel)]="eeBDEx1.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.additionalWallsInsulationType !== 4 &&
                        eeBDEx1.additionalWallsInsulationType !== 2 &&
                        eeBDEx1.addtionalWallsInsulationType !== 5 &&
                        eeBDEx1.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx1.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx1.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="eeBDEx1InsulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDEx1.additionalWallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulation" class="form-label mb-0">Measured
                          Insulation</label>
                        <input appHighlightRequired="true" class="form-control" type="number" min="0" [(ngModel)]="
                            eeBDEx1.alternativeWall1MeasuredInsulation
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulationLambda" class="form-label mb-0">Measured
                          Insulation Lambda</label>
                        <select class="form-select" [(ngModel)]="
                            eeBDEx1.alternativeWall1MeasuredInsulationLambda
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.additionalWallUValueKnown"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx1.additionalWallUValueKnown">
                      <div class="mb-1">
                        <label for="eeBDEx1AdditionalWallUValueKnown" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #eeBDEx1AdditionalWallUValueKnown="ngModel"
                          class="form-control" name="Uvalue" type="number" min="0.01" max="2.5"
                          [(ngModel)]="eeBDEx1.additionalWallsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx1AdditionalWallUValueKnown.invalid &&
                            (eeBDEx1AdditionalWallUValueKnown.dirty ||
                              eeBDEx1AdditionalWallUValueKnown.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx1AdditionalWallUValueKnown.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx1AdditionalWallUValueKnown.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.additionalWallsDryLined"
                        [disabled]="
                          !isEdit ||
                          disableEditDryLined('eeBDEx1', 'additionalWalls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        (eeGeneralDetails.propertyType ==
                          keyedLookUpCodes['PropertyType']['Flat'] ||
                          eeGeneralDetails.propertyType ==
                            keyedLookUpCodes['PropertyType']['Maisonette']) &&
                        eeGeneralDetails.corridorType ==
                          keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.shelteredWall" [disabled]="
                          !isEdit ||
                          (showAdditionalWall.eeBDEx1 && getStoredHeatLoss() == 1)
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Sheltered Wall</label>
                      <span *ngIf="
                          !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor()
                        " ngbTooltip="Must be true for exactly 1 building part">
                        <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header blue-grey-400">Floor</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="heatLossType">Heat loss type</label>
                        <select id="heatLossType" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx1.floorHeatLossType" [disabled]="!isEdit"
                          (change)="onHeatLossTypeChangeExtensions(1)" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('FloorHeatloss')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorConstruction" class="form-label mb-0">Construction</label>
                        <select [appHighlightRequired]="eeBDEx1.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] &&
                            eeBDEx1.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] &&
                            eeBDEx1.floorHeatLossType !=  keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" 
                            id="floorConstruction" class="form-select" [(ngModel)]="eeBDEx1.floorConstruction" (change)="onFloorConstructionChange('eeBDEx1')"
                          [disabled]="!isEdit ||
                            eeBDEx1.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDEx1.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] ||
                            eeBDEx1.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorConstruction')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorInsulationType" class="form-label mb-0">Insulation type</label>
                        <select [appHighlightRequired]="
                            eeBDEx1.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] &&
                            eeBDEx1.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] &&
                            eeBDEx1.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " id="floorInsulationType" class="form-select" [(ngModel)]="eeBDEx1.floorInsulationType"
                          [disabled]="
                            !isEdit ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorInsulation')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.floorInsulationType ==
                        keyedLookUpCodes['FloorInsulation']['Retro-fitted']
                      ">
                      <div class="mb-1">
                        <label for="floorInsulationThickness" class="form-label mb-0">Insulation Thickness</label>
                        <select appHighlightRequired="true" id="floorInsulationThickness" class="form-select"
                          [(ngModel)]="eeBDEx1.floorInsulationThickness" [disabled]="
                            !isEdit ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value Known -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx1.floorUValueKnown" [disabled]="
                          !isEdit ||
                          eeBDEx1.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Same dwelling below'
                            ] ||
                          eeBDEx1.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Above a partially heated space[commercial premises]'
                            ] ||
                          eeBDEx1.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Another dwelling below'
                            ]
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx1.floorUValueKnown">
                      <div class="mb-1">
                        <label for="floorUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" id="floorUValue" class="form-control" type="number"
                          step="0.01" min="0.01" max="2.3" #eeBDEx1floorUValue="ngModel"
                          [(ngModel)]="eeBDEx1.floorUValue" [disabled]="
                            !isEdit ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx1.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }" />
                        <!-- Extension 1 Floor U-Value Validation -->
                        <div *ngIf="
                            eeBDEx1floorUValue.invalid &&
                            (eeBDEx1floorUValue.dirty ||
                              eeBDEx1floorUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx1floorUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx1floorUValue.errors?.['max']">
                            U-value must have a maximum of 2.3.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Roof</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofConstruction" class="form-label mb-0">Construction</label>
                      <select appHighlightRequired="true" id="roofConstruction" class="form-select"
                        [(ngModel)]="eeBDEx1.roofConstruction" (change)="
                          onRoofConstructionChange(
                            $event.target.value,
                            'eeBDEx1'
                          )
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx1.roofConstruction !==
                              eeBDEx1ForActiveDataSet.roofConstruction
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes(
                              'RoofConstruction'
                            )
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationType" class="form-label mb-0">Insulation type</label>
                      <select [appHighlightRequired]="
                          eeBDEx1.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx1.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " id="roofInsulationType" class="form-select" [(ngModel)]="eeBDEx1.roofInsulationType"
                        (change)="setRoofInsulationThicknessArrays('eeBDEx1')" [disabled]="
                          !isEdit ||
                          eeBDEx1.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx1.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx1.roofInsulationType !==
                              eeBDEx1ForActiveDataSet.roofInsulationType
                        }">
                        <option *ngFor="
                            let property of roofInsulationTypesByBuildingPart.eeBDEx1
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationThickness" class="form-label mb-0">Insulation thickness</label>
                      <select [appHighlightRequired]="
                          eeBDEx1.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx1.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ] &&
                          eeBDEx1.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] &&
                          eeBDEx1.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ]
                        " class="form-select" [(ngModel)]="extension1RoofInsulationThickness" [disabled]="
                          !isEdit ||
                          eeBDEx1.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] ||
                          eeBDEx1.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ] ||
                          eeBDEx1.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx1.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx1.roofInsulationThickness !==
                              eeBDEx1ForActiveDataSet.roofInsulationThickness
                        }">
                        <option *ngFor="
                            let property of roofInsulationThicknessesByBuildingPart.eeBDEx1
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx1.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Same dwelling above'
                          ] &&
                        eeBDEx1.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Another dwelling above'
                          ]
                      ">
                      <input class="form-check-input" type="checkbox" id="eeBDEx1RoofUValueKnown"
                        aria-label="U-Value known" [(ngModel)]="eeBDEx1.roofUValueKnown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx1.roofUValueKnown !==
                              eeBDEx1ForActiveDataSet.roofUValueKnown
                        }" />
                      <label class="form-label mb-0" for="eeBDEx1RoofUValueKnown">U-Value known</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx1.roofUValueKnown">
                      <label for="roofUValue" class="form-label mb-0">U-value</label>
                      <input appHighlightRequired="true" id="roofUValue" class="form-control" name="Uvalue"
                        type="number" min="0.05" max="2.3" step="0.01" #eeBDEx1roofUValue="ngModel"
                        [(ngModel)]="eeBDEx1.roofUValue" [disabled]="!isEdit || !eeBDEx1.roofUValueKnown"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx1.roofUValue !==
                              eeBDEx1ForActiveDataSet.roofUValue
                        }" />
                      <!-- Extention 1 Roof U-Value Validation -->
                      <div *ngIf="
                          eeBDEx1roofUValue.invalid &&
                          (eeBDEx1roofUValue.dirty || eeBDEx1roofUValue.touched)
                        " class="alert p-0 m-0 text-danger">
                        <span *ngIf="eeBDEx1roofUValue.errors?.['min']">
                          U-value must be at least 0.05.
                        </span>
                        <span *ngIf="eeBDEx1roofUValue.errors?.['max']">
                          U-value must have a maximum of 2.3.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="showRoofRoom.eeBDEx1">
                  <!-- Extention 1 Roof room -->
                  <div class="card-header blue-grey-400">Roof Rooms</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="roofRoomsArea">Area (m²)</label>
                        <input appHighlightRequired="true" class="form-control" #roofRoomsArea="ngModel"
                          name="RoofRoomsArea" type="number" min="1" max="999" [(ngModel)]="eeBDEx1.roofRoomsArea"
                          [disabled]="!isEdit" />
                        <!-- Roof room validation -->
                        <div *ngIf="roofRoomsArea.errors && roofRoomsArea.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="roofRoomsArea.errors.min">
                            Roof room area cannot be less than 1.
                          </div>
                          <div *ngIf="roofRoomsArea.errors.max">
                            Roof room area cannot exceed 999.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsAge" class="form-label mb-0">Age</label>
                      <select appHighlightRequired="true" id="roofRoomsAge" class="form-select"
                        [(ngModel)]="eeBDEx1.roofRoomsAge" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let age of constructionAgeList" [value]="age.lookupValue">
                          {{ age.lookUpItem }} {{ age.lookupValue }}
                        </option>
                      </select>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx1RoofRoomsInsulation">Insulation</label>
                        <select id="eeBDEx1RoofRoomsInsulation" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx1.roofRoomsInsulation" (change)="
                            setRoofRoomsInsulationThicknessArrays('eeBDEx1')
                          " [disabled]="!isEdit">
                          <option *ngFor="
                              let insulation of filterLookupCodes(
                                'RoofRoomInsulationType'
                              )
                            " [value]="insulation.lookupValue">
                            {{ insulation.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx1RoofRoomsInsulation">Thickness (at ceiling)</label>
                        <select id="eeBDEx1RoofRoomsInsulation" [appHighlightRequired]="
                            eeBDEx1.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'As built'
                              ] &&
                            eeBDEx1.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'Unknown'
                              ]
                          " class="form-select" [(ngModel)]="eeBDEx1.roofRoomsThickness" [disabled]="
                            !isEdit ||
                            (eeBDEx1.roofRoomsInsulation &&
                              (eeBDEx1.roofRoomsInsulation ===
                                keyedLookUpCodes['RoofRoomInsulationType'][
                                  'As built'
                                ] ||
                                eeBDEx1.roofRoomsInsulation ===
                                  keyedLookUpCodes['RoofRoomInsulationType'][
                                    'Unknown'
                                  ]))
                          ">
                          <option *ngFor="
                              let thickness of roofRoomsInsulationThicknessesByBuildingPart.eeBDEx1
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Roof Room connected"
                        [(ngModel)]="eeBDEx1.roofRoomsAdjoining" [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Roof Room connected?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <button class="btn btn-primary" (click)="openEEBDEx1ExtendedDataModal(2)">
                        Extended Data<span *ngIf="!roofRoomExtendedDataValid('eeBDEx1')">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="5" *ngIf="showBuildingExtensions.extension2">
        <!-- Extension 2 Tab -->
        <a ngbNavLink (click)="onSelectTab(5)" role="button" *ngIf="showBuildingExtensions.extension2">
          Extension 2
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(5) === false ||
                  (isTabClicked(5) && !isExtension2TabValid()),
                'bi bi-check-circle': isTabClicked(5) && isExtension2TabValid(),
                'text-warning': isTabClicked(5) === false,
                'text-danger': isTabClicked(5) && !isExtension2TabValid(),
                'text-success': isTabClicked(5) && isExtension2TabValid()
              }"></i>
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row mb-3">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                  <div class="card-header blue-grey-400">
                    Building Part Details
                  </div>
                  <div class="card-body">
                    <div>
                      <div class="col-md-6">
                        <div class="mb-1 mh-16 mv-8 w-400">
                          <label for="buildingPartAge" class="form-label mb-0">Building Part Age</label>
                          <select appHighlightRequired="true" id="buildingPartAge" class="form-select"
                            [(ngModel)]="eeBDEx2.buildingPartAge" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="let property of constructionAgeList" [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                              {{ property.lookupValue }}
                            </option>
                          </select>
                        </div>
                        <div class="mh-16 mv-8 w-400">
                          <button class="btn btn-primary me-2" (click)="openDimensionDetailsModal('eeBDEx2')">
                            Dimensions
                            <span *ngIf="!buildingPartDimensionsAreValid('eeBDEx2')"
                              ngbTooltip="Some dimensions details are invalid">
                              <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                            </span>
                          </button>
                          <button class="btn btn-primary" *ngIf="
                              keyedLookUpCodes['GlazingCoverage'] &&
                              (eeOpeningDetails.coverage ==
                                keyedLookUpCodes['GlazingCoverage'][
                                  'Much more than typical'
                                ] ||
                                eeOpeningDetails.coverage ==
                                  keyedLookUpCodes['GlazingCoverage'][
                                    'Much less than typical'
                                  ])
                            " (click)="
                              openEEOpeningsMeasurementWindowsModal(
                                eeOpeningDetails.id,
                                2
                              )
                            ">
                            Measured Windows
                            <span *ngIf="!isMeasuredWindowsValid()"
                              ngbTooltip=" Ensure to add a window for at least 1 building part">
                              <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                            </span>
                            <span *ngIf="
                                isMeasuredWindowsValid() &&
                                !hasWindowsForBuildingPart(2)
                              " ngbTooltip="Make sure that you added all the windows for Extension 2">
                              <i class="bi bi-icon bi-exclamation-circle"></i>
                            </span>
                            <span *ngIf="
                                hasWindowsForBuildingPart(2) &&
                                !hasAreaForBuildingPart(2)
                              " ngbTooltip="Please fill in all the fields for Measured Windows">
                              <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div>
                        <!-- Alternative Wall 1 -->
                        <div class="mh-16 mv-8 w-400">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="showAdditionalWall.eeBDEx2"
                            (change)="onAdditionalWallChange(3)" [disabled]="
                              !isEdit ||
                              (showAdditionalWall.eeBDEx2 &&
                                shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() && getStoredHeatLoss() == 2)
                            " [ngModelOptions]="{ standalone: true }" aria-label="Alternative Wall 1" />
                            <label class="form-check-label">Alternative Wall</label>
                          <span *ngIf="
                              !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() &&
                              !atLeast1BuildingPartHasAnAdditionalWall()
                            ">
                            <i class="icon icon-alert-circle s16 red-fg"></i>
                            <i ngbTooltip="At least 1 building part must have an alternative wall"
                              class="bi bi-icon bi-info-circle"></i>
                          </span>
                        </div>
                        <div class="mh-16 mv-8 w-400">
                          <input class="form-check-input" type="checkbox" aria-label="Roof Room"
                            [(ngModel)]="showRoofRoom.eeBDEx2" (change)="onRoofRoomChange(3)" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }" />
                            <label class="form-check-label">Roof Room</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header blue-grey-400">Walls</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="eeBDEx2WallsConstruction" class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" id="eeBDEx2WallsConstruction" class="form-select"
                          [(ngModel)]="eeBDEx2.wallsConstruction" (change)="onWallConstructionChange('eeBDEx2')"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Thickness Measured"
                        [(ngModel)]="eeBDEx2.wallThicknessMeasured" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx2.wallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx2WallsWallThickness" class="form-label mb-0">Wall thickness (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx2WallsWallThickness="ngModel" class="form-control"
                          type="number" min="50" max="1500" [(ngModel)]="eeBDEx2.wallsWallThickness"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx2WallsWallThickness.invalid &&
                            (eeBDEx2WallsWallThickness.dirty ||
                              eeBDEx2WallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx2WallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx2WallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.wallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label for="eeBDEx2WallsInsulationType" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" id="eeBDEx2WallsInsulationType" class="form-select"
                          [(ngModel)]="eeBDEx2.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.wallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2WallsInsulationType">Insulation type</label>
                        <select id="eeBDEx2WallsInsulationType" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx2.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.wallsInsulationType !== 4 &&
                        eeBDEx2.wallsInsulationType !== 2 &&
                        eeBDEx2.wallsInsulationType !== 5 &&
                        eeBDEx2.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx2.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx2.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="eeBDEx2WallsInsulationThickness" class="form-label mb-0">Insulation
                          thickness</label>
                        <select appHighlightRequired="true" id="eeBDEx2WallsInsulationThickness" class="form-select"
                          [(ngModel)]="eeBDEx2.wallsInsulationThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="eeBDEx2WallMeasuredInsulation" class="form-label mb-0">Measured Insulation</label>
                        <input class="form-control" id="eeBDEx2WallMeasuredInsulation" type="number" min="0"
                          [(ngModel)]="eeBDEx2.wallMeasuredInsulation" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulationLambda" class="form-label mb-0">Measured Insulation
                          Lambda</label>
                        <select id="wallMeasuredInsulationLambda" class="form-select" [(ngModel)]="eeBDEx2.c"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="U-Value known"
                        [(ngModel)]="eeBDEx2.uValueknown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx2.uValueknown">
                      <div class="mb-1">
                        <label for="eeBDEx2WallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #eeBDEx2WallsUValue="ngModel" class="form-control"
                          type="number" min="0.01" max="2.5" [(ngModel)]="eeBDEx2.wallsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx2WallsUValue.invalid &&
                            (eeBDEx2WallsUValue.dirty ||
                              eeBDEx2WallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx2WallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx2WallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Dry lined?"
                        [(ngModel)]="eeBDEx2.wallsDryLined" [disabled]="
                          !isEdit || disableEditDryLined('eeBDEx2', 'walls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>
                    <!-- Party Wall Construction = Extension 2 -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="partyWallConstructionEx2" class="form-label mb-0">Party Wall Construction</label>
                        <select appHighlightRequired="true" id="partyWallConstructionEx2" class="form-select"
                          [(ngModel)]="eeBDEx2.partyWallConstruction" [disabled]="
                            !isEdit ||
                            eeGeneralDetails.builtForm ==
                              keyedLookUpCodes['BuiltForm']['Detached'] ||
                            changePartyWallConstructionIfAllZero('eeBDEx2')
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'PartyWallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <span *ngIf="
                          allPartyWallConstructionsNotApplicableIfNotDetached()
                        " ngbTooltip="Ensure to add a PW Construction and Length for at least 1 building part">
                        <i class="bi bi-exclamation-circle text-danger"></i>
                      </span>
                      <span *ngIf="
                          !allPartyWallConstructionsNotApplicableIfNotDetached() &&
                          changePartyWallConstructionIfAllZero('eeBDEx2') &&
                          !isDetached()
                        " ngbTooltip="All Party Wall lengths are 0. 'Not Applicable' is automatically selected.">
                        <i class="bi bi-exclamation-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="showAdditionalWall.eeBDEx2">
                <div class="card">
                  <div class="card-header">Alternative Wall</div>
                  <div class="card-body">
                    <!-- Extention 2 Alternative Wall  -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2additionalWallWallArea">Area (m<sup>2</sup>)</label>
                        <input appHighlightRequired="true" class="form-control" [readonly]="eeBDEx2.shelteredWall"
                          #eeBDEx2additionalWallWallArea="ngModel" [(ngModel)]="eeBDEx2.additionalWallWallArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" type="number" min="0.01"
                          step="0.01" max="999" />
                        <!-- Area Validation -->
                        <div *ngIf="
                            eeBDEx2additionalWallWallArea.invalid &&
                            (eeBDEx2additionalWallWallArea.dirty ||
                              eeBDEx2additionalWallWallArea.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx2additionalWallWallArea.errors?.['min']">
                            Area cannot be less than 0.01.
                          </span>
                          <span *ngIf="eeBDEx2additionalWallWallArea.errors?.['max']">
                            Area cannot be more than 999.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2AdditionalWallsConstruction">Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx2.additionalWallsConstruction" (change)="
                            onaAlternativeWallConstructionChange('eeBDEx2')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Thickness Measured"
                        [(ngModel)]="eeBDEx2.additionalWallThicknessMeasured" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx2.additionalWallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx2AdditionalWallsWallThickness" class="form-label mb-0">Wall thickness
                          (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx2AdditionalWallsWallThickness="ngModel"
                          class="form-control" type="number" min="50" max="1500"
                          [(ngModel)]="eeBDEx2.additionalWallsWallThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx2AdditionalWallsWallThickness.invalid &&
                            (eeBDEx2AdditionalWallsWallThickness.dirty ||
                              eeBDEx2AdditionalWallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx2AdditionalWallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx2AdditionalWallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.additionalWallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2AdditionalWallsInsulationType">Insulation
                          type</label>
                        <select id="eeBDEx2AdditionalWallsInsulationType" appHighlightRequired="true"
                          class="form-select" [(ngModel)]="eeBDEx2.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.additionalWallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2AdditionalWallsInsulationType">Insulation
                          type</label>
                        <select id="eeBDEx2AdditionalWallsInsulationType" appHighlightRequired="true"
                          class="form-select" [(ngModel)]="eeBDEx2.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.additionalWallsInsulationType !== 4 &&
                        eeBDEx2.additionalWallsInsulationType !== 2 &&
                        eeBDEx2.addtionalWallsInsulationType !== 5 &&
                        eeBDEx2.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx2.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx2.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="eeBDEx2InsulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select id="eeBDEx2InsulationThickness" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="
                            eeBDEx2.additionalWallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulation" class="form-label mb-0">Measured
                          Insulation</label>
                        <input id="alternativeWall1MeasuredInsulation" class="form-control" type="number" min="0"
                          [(ngModel)]="
                            eeBDEx2.alternativeWall1MeasuredInsulation
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulationLambda" class="form-label mb-0">Measured
                          Insulation Lambda</label>
                        <select id="alternativeWall1MeasuredInsulationLambda" class="form-select" [(ngModel)]="
                            eeBDEx2.alternativeWall1MeasuredInsulationLambda
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="U-Value known"
                        [(ngModel)]="eeBDEx2.additionalWallUValueKnown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx2.additionalWallUValueKnown">
                      <div class="mb-1">
                        <label for="eeBDEx2AdditionalWallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #eeBDEx2AdditionalWallsUValue="ngModel" class="form-control"
                          type="number" min="0.01" max="2.5" [(ngModel)]="eeBDEx2.additionalWallsUValue"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx2AdditionalWallsUValue.invalid &&
                            (eeBDEx2AdditionalWallsUValue.dirty ||
                              eeBDEx2AdditionalWallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx2AdditionalWallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx2AdditionalWallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Dry lined?"
                        [(ngModel)]="eeBDEx2.additionalWallsDryLined" [disabled]="
                          !isEdit ||
                          disableEditDryLined('eeBDEx2', 'additionalWalls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        (eeGeneralDetails.propertyType ==
                          keyedLookUpCodes['PropertyType']['Flat'] ||
                          eeGeneralDetails.propertyType ==
                            keyedLookUpCodes['PropertyType']['Maisonette']) &&
                        eeGeneralDetails.corridorType ==
                          keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <input class="form-check-input" type="checkbox" aria-label="Sheltered Wall"
                        [(ngModel)]="eeBDEx2.shelteredWall" [disabled]="
                          !isEdit ||
                          (showAdditionalWall.eeBDEx2 && getStoredHeatLoss() == 2)
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Sheltered Wall</label>

                      <span *ngIf="
                          !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor()
                        " ngbTooltip="Must be true for exactly 1 building part">
                        <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Floor</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2FloorHeatLossType">Heat loss type</label>
                        <select id="eeBDEx2FloorHeatLossType" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx2.floorHeatLossType" [disabled]="!isEdit"
                          (change)="onHeatLossTypeChangeExtensions(2)" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('FloorHeatloss')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorConstruction" class="form-label mb-0">Construction</label>
                        <select [appHighlightRequired]="eeBDEx2.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] &&
                            eeBDEx2.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] &&
                            eeBDEx2.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" 
                            id="floorConstruction" class="form-select" [(ngModel)]="eeBDEx2.floorConstruction" (change)="onFloorConstructionChange('eeBDEx2')"
                          [disabled]="!isEdit ||
                            eeBDEx2.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDEx2.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] ||
                            eeBDEx2.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below' ]" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorConstruction')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorInsulationType" class="form-label mb-0">Insulation type</label>
                        <select [appHighlightRequired]="
                            eeBDEx2.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] &&
                            eeBDEx2.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] &&
                            eeBDEx2.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " id="floorInsulationType" class="form-select" [(ngModel)]="eeBDEx2.floorInsulationType"
                          [disabled]="
                            !isEdit ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulation'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.floorInsulationType ==
                        keyedLookUpCodes['FloorInsulation']['Retro-fitted']
                      ">
                      <div class="mb-1">
                        <label for="floorInsulationThickn§ess" class="form-label mb-0">Insulation Thickness</label>
                        <select appHighlightRequired="true" id="floorInsulationThickness" class="form-select"
                          [(ngModel)]="eeBDEx2.floorInsulationThickness" [disabled]="
                            !isEdit ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value Known -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx2.floorUValueKnown" [disabled]="
                          !isEdit ||
                          eeBDEx2.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Same dwelling below'
                            ] ||
                          eeBDEx2.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Above a partially heated space[commercial premises]'
                            ] ||
                          eeBDEx2.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Another dwelling below'
                            ]
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx2.floorUValueKnown">
                      <div class="mb-1">
                        <label for="floorUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" id="floorUValue" class="form-control" type="number"
                          step="0.01" min="0.01" max="2.3" #eeBDEx2floorUValue="ngModel"
                          [(ngModel)]="eeBDEx2.floorUValue" [disabled]="
                            !isEdit ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx2.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }" />
                        <!-- Extension 2 Floor U-Value Validation -->
                        <div *ngIf="
                            eeBDEx2floorUValue.invalid &&
                            (eeBDEx2floorUValue.dirty ||
                              eeBDEx2floorUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx2floorUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx2floorUValue.errors?.['max']">
                            U-value must have a maximum of 2.3.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Roof</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofConstruction" class="form-label mb-0">Construction</label>
                      <select appHighlightRequired="true" id="roofConstruction" class="form-select"
                        [(ngModel)]="eeBDEx2.roofConstruction" (change)="
                          onRoofConstructionChange(
                            $event.target.value,
                            'eeBDEx2'
                          )
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx2.roofConstruction !==
                              eeBDEx2ForActiveDataSet.roofConstruction
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes(
                              'RoofConstruction'
                            )
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationType" class="form-label mb-0">Insulation type</label>
                      <select [appHighlightRequired]="
                          eeBDEx2.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx2.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " id="roofInsulationType" class="form-select" [(ngModel)]="eeBDEx2.roofInsulationType"
                        (change)="setRoofInsulationThicknessArrays('eeBDEx2')" [disabled]="
                          !isEdit ||
                          eeBDEx2.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx2.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx2.roofInsulationType !==
                              eeBDEx2ForActiveDataSet.roofInsulationType
                        }">
                        <option *ngFor="
                            let property of roofInsulationTypesByBuildingPart.eeBDEx2
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="eeBDEx2RoofInsulationThickness" class="form-label mb-0">Insulation thickness</label>
                      <select id="eeBDEx2RoofInsulationThickness" [appHighlightRequired]="
                          eeBDEx2.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx2.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ] &&
                          eeBDEx2.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] &&
                          eeBDEx2.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ]
                        " class="form-select" [(ngModel)]="extension2RoofInsulationThickness" [disabled]="
                          !isEdit ||
                          eeBDEx2.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] ||
                          eeBDEx2.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ] ||
                          eeBDEx2.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx2.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx2.roofInsulationThickness !==
                              eeBDEx2ForActiveDataSet.roofInsulationThickness
                        }">
                        <option *ngFor="
                            let property of roofInsulationThicknessesByBuildingPart.eeBDEx2
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx2.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Same dwelling above'
                          ] &&
                        eeBDEx2.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Another dwelling above'
                          ]
                      ">
                      <input class="form-check-input" type="checkbox" aria-label="U-Value known"
                        id="eeBDEx2RoofUValueKnown" [(ngModel)]="eeBDEx2.roofUValueKnown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx2.roofUValueKnown !==
                              eeBDEx2ForActiveDataSet.roofUValueKnown
                        }" />
                      <label class="form-label mb-0" for="eeBDEx2RoofUValueKnown">U-Value known</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx2.roofUValueKnown">
                      <label for="roofUValue" class="form-label mb-0">U-value</label>
                      <input appHighlightRequired="true" id="roofUValue" class="form-control" name="Uvalue"
                        type="number" min="0.05" max="2.3" step="0.01" #eeBDEx2roofUValue="ngModel"
                        [(ngModel)]="eeBDEx2.roofUValue" [disabled]="!isEdit || !eeBDEx2.roofUValueKnown"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx2.roofUValue !==
                              eeBDEx2ForActiveDataSet.roofUValue
                        }" />
                      <!-- Extention 2 Roof U-Value Validation -->
                      <div *ngIf="
                          eeBDEx2roofUValue.invalid &&
                          (eeBDEx2roofUValue.dirty || eeBDEx2roofUValue.touched)
                        " class="alert p-0 m-0 text-danger">
                        <span *ngIf="eeBDEx2roofUValue.errors?.['min']">
                          U-value must be at least 0.05.
                        </span>
                        <span *ngIf="eeBDEx2roofUValue.errors?.['max']">
                          U-value must have a maximum of 2.3.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="showRoofRoom.eeBDEx2">
                  <!-- Extention 2 Roof Room -->
                  <div class="card-header">Roof Rooms</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="roofRoomsArea">Area (m²)</label>
                        <input appHighlightRequired="true" class="form-control" type="number" min="1" max="999"
                          #roofRoomsArea="ngModel" name="RoofRoomsArea" [(ngModel)]="eeBDEx2.roofRoomsArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <!-- Roof room validation -->
                        <div *ngIf="roofRoomsArea.errors && roofRoomsArea.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="roofRoomsArea.errors.min">
                            Roof room area cannot be less than 1.
                          </div>
                          <div *ngIf="roofRoomsArea.errors.max">
                            Roof room area cannot exceed 999.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsAge" class="form-label mb-0">Age</label>
                      <select appHighlightRequired="true" id="roofRoomsAge" class="form-select"
                        [(ngModel)]="eeBDEx2.roofRoomsAge" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let age of constructionAgeList" [value]="age.lookupValue">
                          {{ age.lookUpItem }} {{ age.lookupValue }}
                        </option>
                      </select>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2RoofRoomsInsulation">Insulation</label>
                        <select appHighlightRequired="true" id="eeBDEx2RoofRoomsInsulation" class="form-select"
                          [(ngModel)]="eeBDEx2.roofRoomsInsulation" [disabled]="!isEdit" (change)="
                            setRoofRoomsInsulationThicknessArrays('eeBDEx2')
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let insulation of filterLookupCodes(
                                'RoofRoomInsulationType'
                              )
                            " [value]="insulation.lookupValue">
                            {{ insulation.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx2RoofRoomsInsulation">Thickness (at ceiling)</label>
                        <select id="eeBDEx2RoofRoomsInsulation" [appHighlightRequired]="
                            eeBDEx2.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'As built'
                              ] &&
                            eeBDEx2.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'Unknown'
                              ]
                          " class="form-select" [(ngModel)]="eeBDEx2.roofRoomsThickness" [disabled]="
                            !isEdit ||
                            (eeBDEx2.roofRoomsInsulation &&
                              (eeBDEx2.roofRoomsInsulation ===
                                keyedLookUpCodes['RoofRoomInsulationType'][
                                  'As built'
                                ] ||
                                eeBDEx2.roofRoomsInsulation ===
                                  keyedLookUpCodes['RoofRoomInsulationType'][
                                    'Unknown'
                                  ]))
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of roofRoomsInsulationThicknessesByBuildingPart.eeBDEx2
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Roof Room connected"
                        [(ngModel)]="eeBDEx2.roofRoomsAdjoining" [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Roof Room connected?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <button class="btn btn-primary" (click)="openEEBDEx2ExtendedDataModal(3)">
                        Extended Data<span *ngIf="!roofRoomExtendedDataValid('eeBDEx2')">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="6" *ngIf="showBuildingExtensions.extension3">
        <!-- Extension 3 Tab -->
        <a ngbNavLink (click)="onSelectTab(6)" role="button" *ngIf="showBuildingExtensions.extension3">
          Extension 3
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(6) === false ||
                  (isTabClicked(6) && !isExtension3TabValid()),
                'bi bi-check-circle': isTabClicked(6) && isExtension3TabValid(),
                'text-warning': isTabClicked(6) === false,
                'text-danger': isTabClicked(6) && !isExtension3TabValid(),
                'text-success': isTabClicked(6) && isExtension3TabValid()
              }"></i>
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row mb-3">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                  <div class="card-header">Building Part Details</div>
                  <div class="card-body">
                    <div class="col-md-6">
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="buildingPartAge" class="form-label mb-0">Building Part Age</label>
                          <select appHighlightRequired="true" id="buildingPartAge" class="form-select"
                            [(ngModel)]="eeBDEx3.buildingPartAge" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="let property of constructionAgeList" [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                              {{ property.lookupValue }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400">
                        <button class="btn btn-primary me-2" (click)="openDimensionDetailsModal('eeBDEx3')">
                          Dimensions
                          <i *ngIf="!buildingPartDimensionsAreValid('eeBDEx3')"
                            class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </button>
                        <button class="btn btn-primary" *ngIf="
                            keyedLookUpCodes['GlazingCoverage'] &&
                            (eeOpeningDetails.coverage ==
                              keyedLookUpCodes['GlazingCoverage'][
                                'Much more than typical'
                              ] ||
                              eeOpeningDetails.coverage ==
                                keyedLookUpCodes['GlazingCoverage'][
                                  'Much less than typical'
                                ])
                          " (click)="
                            openEEOpeningsMeasurementWindowsModal(
                              eeOpeningDetails.id,
                              3
                            )
                          ">
                          Measured Windows
                          <span *ngIf="!isMeasuredWindowsValid()"
                            ngbTooltip=" Ensure to add a window for at least 1 building part">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                          <span *ngIf="
                              isMeasuredWindowsValid() &&
                              !hasWindowsForBuildingPart(3)
                            " ngbTooltip="Make sure that you added all the windows for Extension 3">
                            <i class="bi bi-icon bi-exclamation-circle"></i>
                          </span>
                          <span *ngIf="
                              hasWindowsForBuildingPart(3) &&
                              !hasAreaForBuildingPart(3)
                            " ngbTooltip="Please fill in all the fields for Measured Windows">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                    <div>
                      <!-- Alternative Wall 1 -->
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showAdditionalWall.eeBDEx3"
                          (change)="onAdditionalWallChange(4)" [disabled]="
                            !isEdit ||
                            (showAdditionalWall.eeBDEx3 &&
                              shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() && getStoredHeatLoss() == 3)
                          " [ngModelOptions]="{ standalone: true }" aria-label="Alternative Wall 1" />
                          <label class="form-check-label">Alternative Wall</label>
                        <span *ngIf="
                            !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() &&
                            !atLeast1BuildingPartHasAnAdditionalWall()
                          ">
                          <i class="icon icon-alert-circle s16 red-fg"></i>
                          <i ngbTooltip="At least 1 building part must have an alternative wall"
                            class="bi bi-icon bi-info-circle"></i>
                        </span>
                      </div>

                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showRoofRoom.eeBDEx3"
                          (change)="onRoofRoomChange(4)" aria-label="Roof Room" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                          <label class="form-check-label">Roof Room</label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- The rest of the cards go here -->
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Walls</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0" for="eeBDEx3WallsConstruction">Construction</label>
                        <select id="eeBDEx3WallsConstruction" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.wallsConstruction" (change)="onWallConstructionChange('eeBDEx3')"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.wallThicknessMeasured"
                        aria-label="Thickness Measured" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx3.wallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx3WallsWallThickness" class="form-label mb-0">Wall thickness (mm)</label>
                        <input appHighlightRequired="true" class="form-control" #eeBDEx3WallsWallThickness="ngModel"
                          type="number" min="50" max="1500" [(ngModel)]="eeBDEx3.wallsWallThickness"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx3WallsWallThickness.invalid &&
                            (eeBDEx3WallsWallThickness.dirty ||
                              eeBDEx3WallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx3WallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx3WallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.wallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <!-- Insulation Type for Cavity Wall -->
                      <div class="mb-1">
                        <label for="eeBDEx3WallsInsulationType" class="form-label mb-0">Insulation type</label>
                        <select id="eeBDEx3WallsInsulationType" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let type of wallsInsulationTypes" [value]="type.lookupValue">
                            {{ type.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.wallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <!-- Insulation Type for Non-Cavity Wall -->
                      <div class="mb-1">
                        <label for="eeBDEx3WallsInsulationType" class="form-label mb-0">Insulation type</label>
                        <select id="eeBDEx3WallsInsulationType" appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let type of wallsInsulationTypesNoCavity" [value]="type.lookupValue">
                            {{ type.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.wallsInsulationType !== 4 &&
                        eeBDEx3.wallsInsulationType !== 2 &&
                        eeBDEx3.wallsInsulationType !== 5 &&
                        eeBDEx3.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx3.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx3.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="insulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDMainBuilding.wallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulation" class="form-label mb-0">Measured Insulation</label>
                        <input class="form-control" type="number" min="0" [(ngModel)]="eeBDEx3.wallMeasuredInsulation"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulationLambda" class="form-label mb-0">Measured Insulation
                          Lambda</label>
                        <select class="form-select" [(ngModel)]="eeBDEx3.wallMeasuredInsulationLambda"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.uValueknown"
                        aria-label="U-Value known" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx3.uValueknown">
                      <div class="mb-1">
                        <label for="eeBDEx3WallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" class="form-control" #eeBDEx3WallsUValue="ngModel"
                          type="number" min="0.01" max="2.5" [(ngModel)]="eeBDEx3.wallsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx3WallsUValue.invalid &&
                            (eeBDEx3WallsUValue.dirty ||
                              eeBDEx3WallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx3WallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx3WallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.wallsDryLined"
                        aria-label="Dry lined?" [disabled]="
                          !isEdit || disableEditDryLined('eeBDEx3', 'walls')
                        " />
                        <label class=form-label>Dry lined?</label>
                    </div>
                    <!-- Party Wall Construction - Extension 3-->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="partyWallConstructionEx3" class="form-label mb-0">Party Wall Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.partyWallConstruction" [disabled]="
                            !isEdit ||
                            eeGeneralDetails.builtForm ==
                              keyedLookUpCodes['BuiltForm']['Detached'] ||
                            changePartyWallConstructionIfAllZero('eeBDEx3')
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'PartyWallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <span *ngIf="
                          allPartyWallConstructionsNotApplicableIfNotDetached()
                        " ngbTooltip="Ensure to add a PW Construction and Length for at least 1 building part">
                        <i class="bi bi-exclamation-circle text-danger"></i>
                      </span>
                      <span *ngIf="
                          !allPartyWallConstructionsNotApplicableIfNotDetached() &&
                          changePartyWallConstructionIfAllZero('eeBDEx3') &&
                          !isDetached()
                        " ngbTooltip="All Party Wall lengths are 0. 'Not Applicable' is automatically selected.">
                        <i class="bi bi-exclamation-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="showAdditionalWall.eeBDEx3">
                <div class="card">
                  <div class="card-header">Alternative Wall</div>
                  <div class="card-body">
                    <!-- Extention 3 Alternative Wall -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Area (m<sup>2</sup>)</label>
                        <input appHighlightRequired="true" class="form-control" [readonly]="eeBDEx3.shelteredWall"
                          #eeBDEx3additionalWallWallArea="ngModel" [(ngModel)]="eeBDEx3.additionalWallWallArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" type="number" min="0.01"
                          step="0.01" max="999" />
                        <!-- Area Validation -->
                        <div *ngIf="
                            eeBDEx3additionalWallWallArea.invalid &&
                            (eeBDEx3additionalWallWallArea.dirty ||
                              eeBDEx3additionalWallWallArea.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx3additionalWallWallArea.errors?.['min']">
                            Area cannot be less than 0.01.
                          </span>
                          <span *ngIf="eeBDEx3additionalWallWallArea.errors?.['max']">
                            Area cannot be more than 999.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.additionalWallsConstruction" (change)="
                            onaAlternativeWallConstructionChange('eeBDEx3')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDEx3.additionalWallThicknessMeasured" aria-label="Thickness Measured"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx3.additionalWallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx3AdditionalWallsWallThickness" class="form-label mb-0">Wall thickness
                          (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx3AdditionalWallsWallThickness="ngModel"
                          class="form-control" type="number" min="50" max="1500"
                          [(ngModel)]="eeBDEx3.additionalWallsWallThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx3AdditionalWallsWallThickness.invalid &&
                            (eeBDEx3AdditionalWallsWallThickness.dirty ||
                              eeBDEx3AdditionalWallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx3AdditionalWallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx3AdditionalWallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.additionalWallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of wallsInsulationTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.additionalWallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.additionalWallsInsulationType !== 4 &&
                        eeBDEx3.additionalWallsInsulationType !== 2 &&
                        eeBDEx3.addtionalWallsInsulationType !== 5 &&
                        eeBDEx3.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx3.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx3.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="eeBDEx3InsulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDEx3.additionalWallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulation" class="form-label mb-0">Measured
                          Insulation</label>
                        <input class="form-control" type="number" min="0" [(ngModel)]="
                            eeBDEx3.alternativeWall1MeasuredInsulation
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulationLambda" class="form-label mb-0">Measured
                          Insulation Lambda</label>
                        <select class="form-select" [(ngModel)]="
                            eeBDEx3.alternativeWall1MeasuredInsulationLambda
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.additionalWallUValueKnown"
                        aria-label="U-Value known" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx3.additionalWallUValueKnown">
                      <div class="mb-1">
                        <label for="eeBDEx3AdditionalWallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" class="form-control" #eeBDEx3AdditionalWallsUValue="ngModel"
                          type="number" min="0.01" max="2.5" name="Uvalue" [(ngModel)]="eeBDEx3.additionalWallsUValue"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx3AdditionalWallsUValue.invalid &&
                            (eeBDEx3AdditionalWallsUValue.dirty ||
                              eeBDEx3AdditionalWallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx3AdditionalWallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx3AdditionalWallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.additionalWallsDryLined"
                        aria-label="Dry lined?" [disabled]="
                          !isEdit ||
                          disableEditDryLined('eeBDEx3', 'additionalWalls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        (eeGeneralDetails.propertyType ==
                          keyedLookUpCodes['PropertyType']['Flat'] ||
                          eeGeneralDetails.propertyType ==
                            keyedLookUpCodes['PropertyType']['Maisonette']) &&
                        eeGeneralDetails.corridorType ==
                          keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.shelteredWall"
                        aria-label="Sheltered Wall" [disabled]="
                          !isEdit ||
                          (showAdditionalWall.eeBDEx3 && getStoredHeatLoss() == 3)
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Sheltered Wall</label>

                      <span *ngIf="
                          !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor()
                        " ngbTooltip="Must be true for exactly 1 building part">
                        <i class="bi bi-icon bi-exclamation-triangle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Floor</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorHeatLossType" class="form-label mb-0">Heat loss type</label>
                        <select appHighlightRequired="true" id="floorHeatLossType" class="form-select"
                          [(ngModel)]="eeBDEx3.floorHeatLossType" [disabled]="!isEdit"
                          (change)="onHeatLossTypeChangeExtensions(3)" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('FloorHeatloss')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorConstruction" class="form-label mb-0">Construction</label>
                        <select [appHighlightRequired]="eeBDEx3.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] &&
                            eeBDEx3.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] &&
                            eeBDEx3.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" 
                          id="floorConstruction" class="form-select" [(ngModel)]="eeBDEx3.floorConstruction" (change)="onFloorConstructionChange('eeBDEx3')"
                          [disabled]="!isEdit ||
                            eeBDEx3.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDEx3.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] ||
                            eeBDEx3.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorConstruction')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorInsulationType" class="form-label mb-0">Insulation type</label>
                        <select [appHighlightRequired]="
                            eeBDEx3.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] &&
                            eeBDEx3.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] &&
                            eeBDEx3.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " id="floorInsulationType" class="form-select" [(ngModel)]="eeBDEx3.floorInsulationType"
                          [disabled]="
                            !isEdit ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulation'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.floorInsulationType ==
                        keyedLookUpCodes['FloorInsulation']['Retro-fitted']
                      ">
                      <div class="mb-1">
                        <label for="floorInsulationThickness" class="form-label mb-0">Insulation Thickness</label>
                        <select appHighlightRequired="true" id="floorInsulationThickness" class="form-select"
                          [(ngModel)]="eeBDEx3.floorInsulationThickness" [disabled]="
                            !isEdit ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value Known -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx3.floorUValueKnown" [disabled]="
                          !isEdit ||
                          eeBDEx3.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Same dwelling below'
                            ] ||
                          eeBDEx3.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Above a partially heated space[commercial premises]'
                            ] ||
                          eeBDEx3.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Another dwelling below'
                            ]
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx3.floorUValueKnown">
                      <div class="mb-1">
                        <label for="floorUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" id="floorUValue" class="form-control" type="number"
                          min="0.01" max="2.3" step="0.01" #eeBDEx3floorUValue="ngModel"
                          [(ngModel)]="eeBDEx3.floorUValue" [disabled]="
                            !isEdit ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx3.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }" />
                        <!-- Extension 3 Floor U-Value Validation -->
                        <div *ngIf="
                            eeBDEx3floorUValue.invalid &&
                            (eeBDEx3floorUValue.dirty ||
                              eeBDEx3floorUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx3floorUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx3floorUValue.errors?.['max']">
                            U-value must have a maximum of 2.3.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="card">
                  <div class="card-header">Roof</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofConstruction" class="form-label mb-0">Construction</label>
                      <select appHighlightRequired="true" id="roofConstruction" class="form-select"
                        [(ngModel)]="eeBDEx3.roofConstruction" (change)="
                          onRoofConstructionChange(
                            $event.target.value,
                            'eeBDEx3'
                          )
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx3.roofConstruction !==
                              eeBDEx3ForActiveDataSet.roofConstruction
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes(
                              'RoofConstruction'
                            )
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationType" class="form-label mb-0">Insulation type</label>
                      <select [appHighlightRequired]="
                          eeBDEx3.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx3.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " id="roofInsulationType" class="form-select" [(ngModel)]="eeBDEx3.roofInsulationType"
                        (change)="setRoofInsulationThicknessArrays('eeBDEx3')" [disabled]="
                          !isEdit ||
                          eeBDEx3.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx3.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx3.roofInsulationType !==
                              eeBDEx3ForActiveDataSet.roofInsulationType
                        }">
                        <option *ngFor="
                            let property of roofInsulationTypesByBuildingPart.eeBDEx3
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationThickness" class="form-label mb-0">Insulation thickness</label>
                      <select [appHighlightRequired]="
                          eeBDEx3.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx3.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ] &&
                          eeBDEx3.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] &&
                          eeBDEx3.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ]
                        " id="roofInsulationThickness" class="form-select"
                        [(ngModel)]="extension3RoofInsulationThickness" [disabled]="
                          !isEdit ||
                          eeBDEx3.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] ||
                          eeBDEx3.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ] ||
                          eeBDEx3.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx3.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx3.roofInsulationThickness !==
                              eeBDEx3ForActiveDataSet.roofInsulationThickness
                        }">
                        <option *ngFor="
                            let property of roofInsulationThicknessesByBuildingPart.eeBDEx3
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx3.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Same dwelling above'
                          ] &&
                        eeBDEx3.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Another dwelling above'
                          ]
                      ">
                      <input class="form-check-input" type="checkbox" aria-label="U-Value known"
                        [(ngModel)]="eeBDEx3.roofUValueKnown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx3.roofUValueKnown !==
                              eeBDEx3ForActiveDataSet.roofUValueKnown
                        }" />
                      <label class="form-label mb-0">U-Value known</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx3.roofUValueKnown">
                      <label for="roofUValue" class="form-label mb-0">U-value</label>
                      <input appHighlightRequired="true" id="roofUValue" class="form-control" name="Uvalue"
                        type="number" min="0.05" max="2.3" step="0.01" #eeBDEx3roofUValue="ngModel"
                        [(ngModel)]="eeBDEx3.roofUValue" [disabled]="!isEdit || !eeBDEx3.roofUValueKnown"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx3.roofUValue !==
                              eeBDEx3ForActiveDataSet.roofUValue
                        }" />
                      <!-- Extention 3 Roof U-Value Validation -->
                      <div *ngIf="
                          eeBDEx3roofUValue.invalid &&
                          (eeBDEx3roofUValue.dirty || eeBDEx3roofUValue.touched)
                        " class="alert p-0 m-0 text-danger">
                        <span *ngIf="eeBDEx3roofUValue.errors?.['min']">
                          U-value must be at least 0.05.
                        </span>
                        <span *ngIf="eeBDEx3roofUValue.errors?.['max']">
                          U-value must have a maximum of 2.3.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="showRoofRoom.eeBDEx3">
                  <!-- Extention 3 Roof Room -->
                  <div class="card-header">Roof Rooms</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Area (m²)</label>
                        <input appHighlightRequired="true" class="form-control" #roofRoomsArea="ngModel"
                          name="RoofRoomsArea" type="number" min="1" max="999" [(ngModel)]="eeBDEx3.roofRoomsArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <!-- Roof room validation -->
                        <div *ngIf="roofRoomsArea.errors && roofRoomsArea.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="roofRoomsArea.errors.min">
                            Roof room area cannot be less than 1.
                          </div>
                          <div *ngIf="roofRoomsArea.errors.max">
                            Roof room area cannot exceed 999.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsAge" class="form-label mb-0">Age</label>
                      <select appHighlightRequired="true" id="roofRoomsAge" class="form-select"
                        [(ngModel)]="eeBDEx3.roofRoomsAge" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let age of constructionAgeList" [value]="age.lookupValue">
                          {{ age.lookUpItem }} {{ age.lookupValue }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Insulation</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx3.roofRoomsInsulation" (change)="
                            setRoofRoomsInsulationThicknessArrays('eeBDEx3')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let insulation of filterLookupCodes(
                                'RoofRoomInsulationType'
                              )
                            " [value]="insulation.lookupValue">
                            {{ insulation.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Thickness (at ceiling)</label>
                        <select [appHighlightRequired]="
                            eeBDEx3.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'As built'
                              ] &&
                            eeBDEx3.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'Unknown'
                              ]
                          " class="form-select" [(ngModel)]="eeBDEx3.roofRoomsThickness" [disabled]="
                            !isEdit ||
                            (eeBDEx3.roofRoomsInsulation &&
                              (eeBDEx3.roofRoomsInsulation ===
                                keyedLookUpCodes['RoofRoomInsulationType'][
                                  'As built'
                                ] ||
                                eeBDEx3.roofRoomsInsulation ===
                                  keyedLookUpCodes['RoofRoomInsulationType'][
                                    'Unknown'
                                  ]))
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of roofRoomsInsulationThicknessesByBuildingPart.eeBDEx3
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Roof Room connected"
                        [(ngModel)]="eeBDEx3.roofRoomsAdjoining" [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Roof Room connected?</label>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <button class="btn btn-primary" (click)="openEEBDEx3ExtendedDataModal(4)">
                        Extended Data<span *ngIf="!roofRoomExtendedDataValid('eeBDEx3')">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="7" *ngIf="showBuildingExtensions.extension4">
        <!-- Extension 4 Tab -->
        <a ngbNavLink (click)="onSelectTab(7)" role="button" *ngIf="showBuildingExtensions.extension4">
          Extension 4
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(7) === false ||
                  (isTabClicked(7) && !isExtension4TabValid()),
                'bi bi-check-circle': isTabClicked(7) && isExtension4TabValid(),
                'text-warning': isTabClicked(7) === false,
                'text-danger': isTabClicked(7) && !isExtension4TabValid(),
                'text-success': isTabClicked(7) && isExtension4TabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                  <div class="card-header">Building Part Details</div>
                  <div class="card-body">
                    <div class="col-md-6">
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="buildingPartAge" class="form-label mb-0">Building Part Age</label>
                          <select appHighlightRequired="true" id="buildingPartAge" class="form-select"
                            [(ngModel)]="eeBDEx4.buildingPartAge" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="let property of constructionAgeList" [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                              {{ property.lookupValue }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400">
                        <button class="btn btn-primary me-2" (click)="openDimensionDetailsModal('eeBDEx4')">
                          Dimensions
                          <i *ngIf="!buildingPartDimensionsAreValid('eeBDEx4')"
                            class="icon icon-alert-circle s16 red-fg"></i>
                        </button>
                        <button *ngIf="
                            keyedLookUpCodes['GlazingCoverage'] &&
                            (eeOpeningDetails.coverage ==
                              keyedLookUpCodes['GlazingCoverage'][
                                'Much more than typical'
                              ] ||
                              eeOpeningDetails.coverage ==
                                keyedLookUpCodes['GlazingCoverage'][
                                  'Much less than typical'
                                ])
                          " class="btn btn-primary" (click)="
                            openEEOpeningsMeasurementWindowsModal(
                              eeOpeningDetails.id,
                              4
                            )
                          ">
                          Measured Windows
                          <span *ngIf="!isMeasuredWindowsValid()"
                            ngbTooltip=" Ensure to add a window for at least 1 building part">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                          <span *ngIf="
                              isMeasuredWindowsValid() &&
                              !hasWindowsForBuildingPart(4)
                            " ngbTooltip="Make sure that you added all the windows for Extension 4">
                            <i class="bi bi-icon bi-exclamation-circle"></i>
                          </span>
                          <span *ngIf="
                              hasWindowsForBuildingPart(4) &&
                              !hasAreaForBuildingPart(4)
                            " ngbTooltip="Please fill in all the fields for Measured Windows">
                            <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                    <div>
                      <!-- Alternative Wall 1 -->
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showAdditionalWall.eeBDEx4"
                          (change)="onAdditionalWallChange(5)" [disabled]="
                            !isEdit ||
                            (showAdditionalWall.eeBDEx4 &&
                              shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() && getStoredHeatLoss() == 4)
                          " [ngModelOptions]="{ standalone: true }" aria-label="Alternative Wall 1" />
                          <label class="form-check-label">Alternative Wall</label>
                        <span *ngIf="
                            !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() &&
                            !atLeast1BuildingPartHasAnAdditionalWall()
                          ">
                          <i class="icon icon-alert-circle s16 red-fg"></i>
                          <i ngbTooltip="At least 1 building part must have an alternative wall"
                            class="bi bi-icon bi-info-circle"></i>
                        </span>
                      </div>

                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="showRoofRoom.eeBDEx4"
                          (change)="onRoofRoomChange(5)" aria-label="Roof Room" [disabled]="!isEdit" />
                          <label class="form-check-label">Roof Room</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="card">
                  <div class="card-header">Walls</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="wallsConstruction" class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="eeBDEx4.wallsConstruction"
                          (change)="onWallConstructionChange('eeBDEx4')" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.wallThicknessMeasured"
                        aria-label="Thickness Measured" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx4.wallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx4WallsWallThickness" class="form-label mb-0">Wall thickness (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx4WallsWallThickness="ngModel" class="form-control"
                          type="number" min="50" max="1500" [(ngModel)]="eeBDEx4.wallsWallThickness"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx4WallsWallThickness.invalid &&
                            (eeBDEx4WallsWallThickness.dirty ||
                              eeBDEx4WallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx4WallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx4WallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.wallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <!-- Insulation Type for Cavity Wall -->
                      <div class="mb-1">
                        <label for="wallsInsulationType" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let type of wallsInsulationTypes" [value]="type.lookupValue">
                            {{ type.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.wallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <!-- Insulation Type for Non-Cavity Wall -->
                      <div class="mb-1">
                        <label for="wallsInsulationType" class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.wallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let type of wallsInsulationTypesNoCavity" [value]="type.lookupValue">
                            {{ type.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.wallsInsulationType !== 4 &&
                        eeBDEx4.wallsInsulationType !== 2 &&
                        eeBDEx4.wallsInsulationType !== 5 &&
                        eeBDEx4.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx4.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx4.wallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="insulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.wallsInsulationThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulation" class="form-label mb-0">Measured Insulation</label>
                        <input id="wallMeasuredInsulation" class="form-control" type="number" min="0"
                          [(ngModel)]="eeBDEx4.wallMeasuredInsulation" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="wallMeasuredInsulationLambda" class="form-label mb-0">Measured Insulation
                          Lambda</label>
                        <select class="form-select" [(ngModel)]="eeBDEx4.wallMeasuredInsulationLambda"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.uValueknown"
                        aria-label="U-Value known" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx4.uValueknown">
                      <div class="mb-1">
                        <label for="eeBDEx4WallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #eeBDEx4WallsUValue="ngModel" class="form-control"
                          type="number" min="0.01" max="2.5" [(ngModel)]="eeBDEx4.wallsUValue" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx4WallsUValue.invalid &&
                            (eeBDEx4WallsUValue.dirty ||
                              eeBDEx4WallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx4WallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx4WallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.wallsDryLined"
                        aria-label="Dry lined?" [disabled]="
                          !isEdit || disableEditDryLined('eeBDEx4', 'walls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>
                    <!-- Party Wall Construction - Extension 4 -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="partyWallConstructionEx4" class="form-label mb-0">Party Wall Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.partyWallConstruction" [disabled]="
                            !isEdit ||
                            eeGeneralDetails.builtForm ==
                              keyedLookUpCodes['BuiltForm']['Detached'] ||
                            changePartyWallConstructionIfAllZero('eeBDEx4')
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'PartyWallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>

                      <span *ngIf="
                          allPartyWallConstructionsNotApplicableIfNotDetached()
                        " ngbTooltip="Ensure to add a PW Construction and Length for at least 1 building part">
                        <i class="bi bi-exclamation-circle text-danger"></i>
                      </span>
                      <span *ngIf="
                          !allPartyWallConstructionsNotApplicableIfNotDetached() &&
                          changePartyWallConstructionIfAllZero('eeBDEx4') &&
                          !isDetached()
                        " ngbTooltip="All Party Wall lengths are 0. 'Not Applicable' is automatically selected.">
                        <i class="bi bi-exclamation-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="showAdditionalWall.eeBDEx4">
                <div class="card">
                  <div class="card-header">Alternative Wall</div>
                  <div class="card-body">
                    <!-- Extension 4 Alternative Wall -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Area (m<sup>2</sup>)</label>
                        <input appHighlightRequired="true" class="form-control" [readonly]="eeBDEx4.shelteredWall"
                          #eeBDEx4additionalWallWallArea="ngModel" [(ngModel)]="eeBDEx4.additionalWallWallArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" type="number" min="0.01"
                          step="0.01" max="999" />
                        <!-- Roof room validation -->
                        <div *ngIf="
                            eeBDEx4additionalWallWallArea.invalid &&
                            (eeBDEx4additionalWallWallArea.dirty ||
                              eeBDEx4additionalWallWallArea.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx4additionalWallWallArea.errors?.['min']">
                            Area cannot be less than 0.01.
                          </span>
                          <span *ngIf="eeBDEx4additionalWallWallArea.errors?.['max']">
                            Area cannot be more than 999.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Construction</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.additionalWallsConstruction" (change)="
                            onaAlternativeWallConstructionChange('eeBDEx4')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'WallConstruction'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeBDEx4.additionalWallThicknessMeasured" aria-label="Thickness Measured"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Thickness Measured</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx4.additionalWallThicknessMeasured">
                      <div class="mb-1">
                        <label for="eeBDEx4AdditionalWallsWallThickness" class="form-label mb-0">Wall thickness
                          (mm)</label>
                        <input appHighlightRequired="true" #eeBDEx4AdditionalWallsWallThickness="ngModel"
                          class="form-control" type="number" min="50" max="1500"
                          [(ngModel)]="eeBDEx4.additionalWallsWallThickness" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx4AdditionalWallsWallThickness.invalid &&
                            (eeBDEx4AdditionalWallsWallThickness.dirty ||
                              eeBDEx4AdditionalWallsWallThickness.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx4AdditionalWallsWallThickness.errors?.['min']">
                            Wall thickness must have at least 50 mm.
                          </span>
                          <span *ngIf="eeBDEx4AdditionalWallsWallThickness.errors?.['max']">
                            Wall thickness must have a maximum of 1500mm.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.additionalWallsConstruction ==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0">Insulation type</label>
                        <select class="form-select" [(ngModel)]="eeBDEx4.additionalWallsInsulationType"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option appHighlightRequired="true" *ngFor="let property of wallsInsulationTypes"
                            [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.additionalWallsConstruction !==
                        keyedLookUpCodes['WallConstruction']['Cavity']
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0">Insulation type</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.additionalWallsInsulationType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of wallsInsulationTypesNoCavity
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.additionalWallsInsulationType !== 4 &&
                        eeBDEx4.additionalWallsInsulationType !== 2 &&
                        eeBDEx4.addtionalWallsInsulationType !== 5 &&
                        eeBDEx4.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['As built'] &&
                        eeBDEx4.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Filled cavity'] &&
                        eeBDEx4.additionalWallsInsulationType !==
                          keyedLookUpCodes['WallInsulation']['Unknown']
                      ">
                      <div class="mb-1">
                        <label for="eeBDEx4InsulationThickness" class="form-label mb-0">Insulation thickness</label>
                        <select appHighlightRequired="true" class="form-select" [(ngModel)]="
                            eeBDEx4.additionalWallsInsulationThickness
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of filterLookupCodes(
                                'WallInsulationThickness'
                              )
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulation" class="form-label mb-0">Measured
                          Insulation</label>
                        <input class="form-control" type="number" min="0" [(ngModel)]="
                            eeBDEx4.alternativeWall1MeasuredInsulation
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="alternativeWall1MeasuredInsulationLambda" class="form-label mb-0">Measured
                          Insulation Lambda</label>
                        <select class="form-select" [(ngModel)]="
                            eeBDEx4.alternativeWall1MeasuredInsulationLambda
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let lookupCode of filterLookupCodes(
                                'wallMeasuredInsulationLambda'
                              )
                            " [value]="lookupCode.lookupValue">
                            {{ lookupCode.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.additionalWallUValueKnown"
                        aria-label="U-Value known" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx4.additionalWallUValueKnown">
                      <div class="mb-1">
                        <label for="eeBDEx4AdditionalWallsUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" #eeBDEx4AdditionalWallsUValue="ngModel" class="form-control"
                          type="number" min="0.01" max="2.5" name="Uvalue" [(ngModel)]="eeBDEx4.additionalWallsUValue"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <div *ngIf="
                            eeBDEx4AdditionalWallsUValue.invalid &&
                            (eeBDEx4AdditionalWallsUValue.dirty ||
                              eeBDEx4AdditionalWallsUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx4AdditionalWallsUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx4AdditionalWallsUValue.errors?.['max']">
                            U-value must have a maximum of 2.5.
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.additionalWallsDryLined"
                        aria-label="Dry lined?" [disabled]="
                          !isEdit ||
                          disableEditDryLined('eeBDEx4', 'additionalWalls')
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Dry lined?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400" *ngIf="
                        (eeGeneralDetails.propertyType ==
                          keyedLookUpCodes['PropertyType']['Flat'] ||
                          eeGeneralDetails.propertyType ==
                            keyedLookUpCodes['PropertyType']['Maisonette']) &&
                        eeGeneralDetails.corridorType ==
                          keyedLookUpCodes['HeatlossCorridor']['Unheated']
                      ">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.shelteredWall"
                        aria-label="Sheltered Wall" [disabled]="
                          !isEdit ||
                          (showAdditionalWall.eeBDEx4 && getStoredHeatLoss() == 4)
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Sheltered Wall</label>

                      <span *ngIf="
                          !shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor()
                        " ngbTooltip="Must be true for exactly 1 building part">
                        <i class="bi bi-icon bi-exclamation-triangle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Floor</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorHeatLossType" class="form-label mb-0">Heat loss type</label>
                        <select appHighlightRequired="true" id="floorHeatLossType" class="form-select"
                          [(ngModel)]="eeBDEx4.floorHeatLossType" [disabled]="!isEdit"
                          (change)="onHeatLossTypeChangeExtensions(4)" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('FloorHeatloss')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorConstruction" class="form-label mb-0">Construction</label>
                        <select [appHighlightRequired]="eeBDEx4.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] &&
                            eeBDEx4.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] &&
                            eeBDEx4.floorHeatLossType != keyedLookUpCodes['FloorHeatloss']['Another dwelling below']"
                          id="floorConstruction" class="form-select" [(ngModel)]="eeBDEx4.floorConstruction" (change)="onFloorConstructionChange('eeBDEx4')"
                          [disabled]="!isEdit ||
                            eeBDEx4.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
                            eeBDEx4.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] ||
                            eeBDEx4.floorHeatLossType == keyedLookUpCodes['FloorHeatloss']['Another dwelling below']" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('FloorConstruction')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="floorInsulationType" class="form-label mb-0">Insulation type</label>
                        <select [appHighlightRequired]="
                            eeBDEx4.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] &&
                            eeBDEx4.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] &&
                            eeBDEx4.floorHeatLossType !=
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " id="floorInsulationType" class="form-select" [(ngModel)]="eeBDEx4.floorInsulationType"
                          [disabled]="
                            !isEdit ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulation'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Insulation Thickness -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.floorInsulationType ==
                        keyedLookUpCodes['FloorInsulation']['Retro-fitted']
                      ">
                      <div class="mb-1">
                        <label for="floorInsulationThickness" class="form-label mb-0">Insulation Thickness</label>
                        <select appHighlightRequired="true" id="floorInsulationThickness" class="form-select"
                          [(ngModel)]="eeBDEx4.floorInsulationThickness" [disabled]="
                            !isEdit ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'FloorInsulationThickness'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- U-Value Known -->
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeBDEx4.floorUValueKnown" [disabled]="
                          !isEdit ||
                          eeBDEx4.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Same dwelling below'
                            ] ||
                          eeBDEx4.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Above a partially heated space[commercial premises]'
                            ] ||
                          eeBDEx4.floorHeatLossType ==
                            keyedLookUpCodes['FloorHeatloss'][
                              'Another dwelling below'
                            ]
                        " [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">U-Value known</label>
                    </div>

                    <!-- U-Value -->
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx4.floorUValueKnown">
                      <div class="mb-1">
                        <label for="floorUValue" class="form-label mb-0">U-value</label>
                        <input appHighlightRequired="true" id="floorUValue" class="form-control" type="number"
                          min="0.01" max="2.3" step="0.01" #eeBDEx4floorUValue="ngModel"
                          [(ngModel)]="eeBDEx4.floorUValue" [disabled]="
                            !isEdit ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Same dwelling below'
                              ] ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Above a partially heated space[commercial premises]'
                              ] ||
                            eeBDEx4.floorHeatLossType ==
                              keyedLookUpCodes['FloorHeatloss'][
                                'Another dwelling below'
                              ]
                          " [ngModelOptions]="{ standalone: true }" />
                        <!-- Extension 3 Floor U-Value Validation -->
                        <div *ngIf="
                            eeBDEx4floorUValue.invalid &&
                            (eeBDEx4floorUValue.dirty ||
                              eeBDEx4floorUValue.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeBDEx4floorUValue.errors?.['min']">
                            U-value must have at least 0.01.
                          </span>
                          <span *ngIf="eeBDEx4floorUValue.errors?.['max']">
                            U-value must have a maximum of 2.3.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header">Roof</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofConstruction" class="form-label mb-0">Construction</label>
                      <select appHighlightRequired="true" id="roofConstruction" class="form-select"
                        [(ngModel)]="eeBDEx4.roofConstruction" (change)="
                          onRoofConstructionChange(
                            $event.target.value,
                            'eeBDEx4'
                          )
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx4.roofConstruction !==
                              eeBDEx4ForActiveDataSet.roofConstruction
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes(
                              'RoofConstruction'
                            )
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationType" class="form-label mb-0">Insulation type</label>
                      <select [appHighlightRequired]="
                          eeBDEx4.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx4.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " id="roofInsulationType" class="form-select" [(ngModel)]="eeBDEx4.roofInsulationType"
                        (change)="setRoofInsulationThicknessArrays('eeBDEx4')" [disabled]="
                          !isEdit ||
                          eeBDEx4.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx4.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx4.roofInsulationType !==
                              eeBDEx4ForActiveDataSet.roofInsulationType
                        }">
                        <option *ngFor="
                            let property of roofInsulationTypesByBuildingPart.eeBDEx4
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="roofInsulationThickness" class="form-label mb-0">Insulation thickness</label>
                      <select [appHighlightRequired]="
                          eeBDEx4.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] &&
                          eeBDEx4.roofConstruction !=
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ] &&
                          eeBDEx4.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] &&
                          eeBDEx4.roofInsulationType !=
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ]
                        " id="roofInsulationThickness" class="form-select"
                        [(ngModel)]="extension4RoofInsulationThickness" [disabled]="
                          !isEdit ||
                          eeBDEx4.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'None'
                            ] ||
                          eeBDEx4.roofInsulationType ==
                            keyedLookUpCodes['RoofInsulationLocation'][
                              'Unknown'
                            ] ||
                          eeBDEx4.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Same dwelling above'
                            ] ||
                          eeBDEx4.roofConstruction ==
                            keyedLookUpCodes['RoofConstruction'][
                              'Another dwelling above'
                            ]
                        " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx4.roofInsulationThickness !==
                              eeBDEx4ForActiveDataSet.roofInsulationThickness
                        }">
                        <option *ngFor="
                            let property of roofInsulationThicknessesByBuildingPart.eeBDEx4
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeBDEx4.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Same dwelling above'
                          ] &&
                        eeBDEx4.roofConstruction !==
                          keyedLookUpCodes['RoofConstruction'][
                            'Another dwelling above'
                          ]
                      ">
                      <input class="form-check-input" type="checkbox" aria-label="U-Value known"
                        [(ngModel)]="eeBDEx4.roofUValueKnown" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx4.roofUValueKnown !==
                              eeBDEx4ForActiveDataSet.roofUValueKnown
                        }" />
                      <label class="form-label mb-0">U-Value known</label>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="eeBDEx4.roofUValueKnown">
                      <label for="roofUValue" class="form-label mb-0">U-value</label>
                      <input appHighlightRequired="true" id="roofUValue" class="form-control" name="Uvalue"
                        type="number" min="0.05" max="2.3" step="0.01" #eeBDEx4roofUValue="ngModel"
                        [(ngModel)]="eeBDEx4.roofUValue" [disabled]="!isEdit || !eeBDEx4.roofUValueKnown"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          '{{modifiedBackgroundClass}}':
                            hasAnActiveDataSet &&
                            eeBDEx4.roofUValue !==
                              eeBDEx4ForActiveDataSet.roofUValue
                        }" />
                      <!-- Extention 4 Roof U-Value Validation -->
                      <div *ngIf="
                          eeBDEx4roofUValue.invalid &&
                          (eeBDEx4roofUValue.dirty || eeBDEx4roofUValue.touched)
                        " class="alert p-0 m-0 text-danger">
                        <span *ngIf="eeBDEx4roofUValue.errors?.['min']">
                          U-value must be at least 0.05.
                        </span>
                        <span *ngIf="eeBDEx4roofUValue.errors?.['max']">
                          U-value must have a maximum of 2.3.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="showRoofRoom.eeBDEx4">
                  <!-- Extention 4 Roof Room -->
                  <div class="card-header">Roof Rooms</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Area (m²)</label>
                        <input appHighlightRequired="true" class="form-control" #roofRoomsArea="ngModel"
                          name="RoofRoomsArea" type="number" min="1" max="999" [(ngModel)]="eeBDEx4.roofRoomsArea"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <!-- Roof room validation -->
                        <div *ngIf="roofRoomsArea.errors && roofRoomsArea.dirty" class="error mt-1" style="color: red">
                          <div *ngIf="roofRoomsArea.errors.min">
                            Roof room area cannot be less than 1.
                          </div>
                          <div *ngIf="roofRoomsArea.errors.max">
                            Roof room area cannot exceed 999.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mb-1 mh-16 mv-8 w-400">
                      <label for="roofRoomsAge" class="form-label mb-0">Age</label>
                      <select appHighlightRequired="true" id="roofRoomsAge" class="form-select"
                        [(ngModel)]="eeBDEx4.roofRoomsAge" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let age of constructionAgeList" [value]="age.lookupValue">
                          {{ age.lookUpItem }} {{ age.lookupValue }}
                        </option>
                      </select>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Insulation</label>
                        <select appHighlightRequired="true" class="form-select"
                          [(ngModel)]="eeBDEx4.roofRoomsInsulation" (change)="
                            setRoofRoomsInsulationThicknessArrays('eeBDEx4')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let insulation of filterLookupCodes(
                                'RoofRoomInsulationType'
                              )
                            " [value]="insulation.lookupValue">
                            {{ insulation.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label class="form-label mb-0">Thickness (at ceiling)</label>
                        <select [appHighlightRequired]="
                            eeBDEx4.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'As built'
                              ] &&
                            eeBDEx4.roofRoomsInsulation !=
                              keyedLookUpCodes['RoofRoomInsulationType'][
                                'Unknown'
                              ]
                          " class="form-select" [(ngModel)]="eeBDEx4.roofRoomsThickness" [disabled]="
                            !isEdit ||
                            (eeBDEx4.roofRoomsInsulation &&
                              (eeBDEx4.roofRoomsInsulation ==
                                keyedLookUpCodes['RoofRoomInsulationType'][
                                  'As built'
                                ] ||
                                eeBDEx4.roofRoomsInsulation ==
                                  keyedLookUpCodes['RoofRoomInsulationType'][
                                    'Unknown'
                                  ]))
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let thickness of roofRoomsInsulationThicknessesByBuildingPart.eeBDEx4
                            " [value]="thickness.lookupValue">
                            {{ thickness.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" aria-label="Roof Room connected"
                        [(ngModel)]="eeBDEx4.roofRoomsAdjoining" [ngModelOptions]="{ standalone: true }" />
                      <label class=form-label>Roof Room connected?</label>
                    </div>

                    <div class="mh-16 mv-8 w-400">
                      <button class="btn btn-primary" (click)="openEEBDEx4ExtendedDataModal(5)">
                        Extended Data<span *ngIf="!roofRoomExtendedDataValid('eeBDEx4')">
                          <i class="bi bi-icon bi-exclamation-circle text-danger"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="8">
        <!-- Heating Tab -->
        <a ngbNavLink (click)="onSelectTab(8)" role="button">
          Heating
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(8) === false ||
                  (isTabClicked(8) && !isHeatingTabValid()),
                'bi bi-check-circle': isTabClicked(8) && isHeatingTabValid(),
                'text-warning': isTabClicked(8) === false,
                'text-danger': isTabClicked(8) && !isHeatingTabValid(),
                'text-success': isTabClicked(8) && isHeatingTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header" color="primary">Heating details</div>
                  <div class="card-body">
                    <div fxLayoutWrap>
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="eeHeating.mainGasAvailable"
                          (change)="handleFuelType()" aria-label="Mains gas available" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label>Mains gas available</label>
                      </div>

                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="secondaryHeating"
                          (change)="onSecondaryHeatingChange()" aria-label="Secondary heating" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label>Secondary heating</label>
                      </div>

                      <div class="mh-16 mv-8 w-400 d-none">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="eeHeating.smartGasMeterPresent"
                          aria-label="Secondary heating" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label>Smart gas meter present?</label>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <input class="form-check-input" type="checkbox"
                          [(ngModel)]="eeHeating.smartElectricityMeterPresent" aria-label="Secondary heating"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label> Smart electricity meter present?</label>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <input class="form-check-input" type="checkbox"
                          [(ngModel)]="eeHeating.exportCapableMeterPresent" aria-label="Secondary heating"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label> Export capable meter</label>
                      </div>

                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="electricityMeter" class="form-label mb-0">Electricity Meter</label>
                          <select appHighlightRequired="true" id="electricMeter" class="form-select"
                            [(ngModel)]="eeHeating.electricMeter" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }" (change)="onEeHeatingChange()">
                            <option *ngFor="
                                let property of filterLookupCodes(
                                  'ElectricityMeter'
                                )
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystems" class="form-label mb-0">Main systems</label>
                          <select id="mainSystems" class="form-select" [(ngModel)]="mainSystems"
                            (change)="onEeHeatingChange()" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="let property of heatingMainSystems" [value]="property">
                              {{ property }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="mainSystems && mainSystems !== 'None installed'">
                  <div class="card-header">Main system 1</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="mainSystem1HeatingProportion" class="form-label mb-0">Heating Proportion (%)</label>
                        <input id="mainSystem1HeatingProportion" class="form-control" name="HeatingProportion"
                          type="number" min="1" max="100" [(ngModel)]="eeHeating.mainSystem1HeatingProportion"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div class="mb-1">
                      <input class="form-check-input" id="mainSystem1CommunityHeating" type="checkbox"
                        (change)="onCommunityHeatingChange()" [(ngModel)]="mainSystem1CommunityHeating"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      <label for="mainSystem1CommunityHeating" class="form-label mb-0 ms-1">Is Community
                        Heating?</label>
                    </div>

                    <!-- Fuel -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="mainSystem1Fuel" class="form-label mb-0">Fuel</label>
                        <select appHighlightRequired="true" id="mainSystem1Fuel" class="form-select"
                          [(ngModel)]="eeHeating.mainSystem1Fuel" (change)="
                            onEeHeatingChange(); onHeatingReset('mainSystem1')
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of heatingFuelsBySystem.mainSystem1
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="mb-1">
                      <label for="mainSystem1SystemType" class="form-label mb-0">Data Source</label>
                      <select appHighlightRequired="true" id="mainSystem1SystemType" class="form-select"
                        [(ngModel)]="eeHeating.mainSystem1SystemType" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let property of primarySystemTypes" [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeHeating.mainSystem1SystemType ==
                        keyedLookUpCodes['PrimarySystemType']['Database']
                      ">
                      <button class="btn btn-primary" (click)="openPcdbDataSelectorModal('mainSystem1')"
                        [disabled]="!isEdit || !eeHeating.mainSystem1Fuel" [ngModelOptions]="{ standalone: true }">
                        Select<span *ngIf="eeHeating.mainSystem1Fuel"
                          ngbTooltip="Please select a system from the database">
                          <i class="bi bi-icon bi-info-circle"></i>
                        </span>
                      </button>
                    </div>

                    <!-- Category -->
                    <div class="mb-1" *ngIf="
                        eeHeating.mainSystem1SystemType !==
                        keyedLookUpCodes['PrimarySystemType']['Database']
                      ">
                      <label for="mainSystem1SystemSubType" class="form-label mb-0">Category</label>
                      <select appHighlightRequired="true" id="mainSystem1SystemSubType" class="form-select"
                        [(ngModel)]="eeHeating.mainSystem1SystemSubType" (change)="onEeHeatingChange()" [disabled]="
                          !isEdit ||
                          eeHeating.mainSystem1SystemType ==
                            keyedLookUpCodes['PrimarySystemType']['Database']
                        " [ngModelOptions]="{ standalone: true }">
                        <option></option>
                        <option *ngFor="
                            let heatingType of heatingMainSystemCategoriesByFuel.mainSystem1
                          " [value]="heatingType.lookupValue">
                          {{ heatingType.lookUpItem }}
                        </option>
                      </select>
                    </div>

                    <!-- Conditionally rendered section for when mainSystem1SystemType is 'Database' -->
                    <div *ngIf="
                        eeHeating.mainSystem1SystemType ==
                        keyedLookUpCodes['PrimarySystemType']['Database']
                      ">
                      <!-- Index -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-3">
                          <label for="mainSystem1PCDFId" class="form-label">Index</label>
                          <input id="mainSystem1PCDFId" class="form-control" name="Index"
                            [(ngModel)]="eeHeating.mainSystem1PCDFId" [disabled]="true"
                            [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>

                      <!-- Manufacturer -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-3">
                          <label for="mainSystem1PCDFManufacturer" class="form-label">Manufacturer</label>
                          <input id="mainSystem1PCDFManufacturer" class="form-control" name="Manufacturer"
                            [(ngModel)]="eeHeating.mainSystem1PCDFManufacturer" [disabled]="true"
                            [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>

                      <!-- Model -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-3">
                          <label class="form-label">Model</label>
                          <input class="form-control" name="Model" [(ngModel)]="eeHeating.mainSystem1PCDFModel"
                            [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>

                      <!-- Qualifier -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-3">
                          <label class="form-label">Qualifier</label>
                          <input class="form-control" name="Qualifier" [(ngModel)]="eeHeating.mainSystem1PCDFQualifier"
                            [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>
                      <!-- GC Number -->
                      <div class="mh-16 mv-8 w-400" *ngIf="
                          eeHeating.mainSystem1Fuel == 26 ||
                          eeHeating.mainSystem1Fuel ==
                            keyedLookUpCodes['HeatingFuel']['Bulk LPG'] ||
                          eeHeating.mainSystem1Fuel ==
                            keyedLookUpCodes['HeatingFuel']['Bottled LPG']
                        ">
                        <div class="mb-3">
                          <label class="form-label">GC Number</label>
                          <input class="form-control" name="Qualifier" [(ngModel)]="eeHeating.mainSystem1PCDFBoilerId"
                            [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>
                    </div>

                    <!-- System Type -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeHeating.mainSystem1SystemType !==
                        keyedLookUpCodes['PrimarySystemType']['Database']
                      ">
                      <div class="mb-1">
                        <label for="mainSystem1System" class="form-label mb-0">System Type</label>
                        <select appHighlightRequired="true" id="mainSystem1System" class="form-select"
                          [(ngModel)]="eeHeating.mainSystem1System" (change)="onEeHeatingChange()" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option></option>
                          <option *ngFor="
                              let heatingSystem of heatingSystemTypesBySystem.mainSystem1
                            " [value]="heatingSystem.lookupValue">
                            {{ heatingSystem.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1" *ngIf="
                          eeHeating.mainSystem1System ===
                            keyedLookUpCodes['HeatingSystem'][
                              'High-heat retention storage heater'
                            ] &&
                          eeHeating.mainSystem1SystemSubType ===
                            keyedLookUpCodes['HeatingType'][
                              'Electric storage systems'
                            ] &&
                          eeHeating.mainSystem1Fuel ===
                            keyedLookUpCodes['HeatingFuel']['Electricity']
                        ">
                        <app-pcdb-data-table-view [items]="resultMain1" [hhrshsystem]="'mainSystem1'"
                          [mainSystem1StorageHeaters]="
                            eeHeating.mainSystem1StorageHeaters
                          " (onSelectData)="dataSelectForMain1($event)"></app-pcdb-data-table-view>
                      </div>
                    </div>

                    <!-- Controls -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="mainSystem1Controls" class="form-label mb-0">Controls</label>
                        <select appHighlightRequired="true" id="mainSystem1Controls" class="form-select"
                          [(ngModel)]="eeHeating.mainSystem1Controls" (change)="onEeHeatingChange()"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option></option>
                          <option *ngFor="
                              let property of heatingControlsBySystem.mainSystem1
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1" *ngIf="
                          eeHeating.mainSystem1SystemType !==
                            keyedLookUpCodes['PrimarySystemType']['Database'] &&
                          eeHeating.mainSystem1SystemSubType ===
                            keyedLookUpCodes['HeatingType'][
                              'Heat pump with radiators or underfloor heating'
                            ] &&
                          eeHeating.mainSystem1Controls ===
                            keyedLookUpCodes['HeatingControls'][
                              '(TTZC) by device in database'
                            ]
                        ">
                        <app-pcdb-manual-controls-table (onSelectData)="
                            dataSelectHeatingControlsForMain1($event)
                          "></app-pcdb-manual-controls-table>
                      </div>
                    </div>

                    <!-- Weather Compensation -->
                    <div class="mh-16 mv-8 w-400" *ngIf="!mainSystem1CommunityHeating">
                      <input class="form-check-input" type="checkbox"
                        [(ngModel)]="eeHeating.mainSystem1WeatherCompensation" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Weather Compensation</label>
                      <div class="mb-1" *ngIf="
                          eeHeating.mainSystem1SystemType !==
                            keyedLookUpCodes['PrimarySystemType']['Database'] &&
                          eeHeating.mainSystem1SystemSubType ===
                            keyedLookUpCodes['HeatingType'][
                              'Heat pump with radiators or underfloor heating'
                            ] &&
                          eeHeating.mainSystem1Controls ===
                            keyedLookUpCodes['HeatingControls'][
                              '(TTZC) by device in database'
                            ] &&
                          eeHeating.mainSystem1WeatherCompensation
                        ">
                        <app-pcdb-manual-weather-compensation (onSelectData)="
                            dataSelectWeatherCompensationForMain1($event)
                          "></app-pcdb-manual-weather-compensation>
                      </div>
                    </div>

                    <!-- Flue Type -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeHeating.mainSystem1Fuel !==
                          keyedLookUpCodes['HeatingFuel']['Electricity'] &&
                        !mainSystem1CommunityHeating
                      ">
                      <div class="mb-1">
                        <label id="flueType" class="form-label mb-0">Flue Type</label>
                        <select appHighlightRequired="true" id="mainSystem1FlueType" class="form-select"
                          [(ngModel)]="eeHeating.mainSystem1FlueType" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option></option>
                          <option *ngFor="
                              let property of heatingFlueTypesBySystem.mainSystem1
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Fan Assisted -->
                    <div class="mh-16 mv-8 w-400" *ngIf="
                        eeHeating.mainSystem1Fuel !==
                          keyedLookUpCodes['HeatingFuel']['Electricity'] &&
                        !mainSystem1CommunityHeating
                      ">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeHeating.mainSystem1FanAssisted"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>Fan Assisted</label>
                    </div>

                    <!-- Emitters -->
                    <div class="mh-16 mv-8 w-400" *ngIf="!mainSystem1CommunityHeating">
                      <div class="mb-1">
                        <label for="mainSystem1Emitter" class="form-label mb-0">Emitters</label>
                        <select [appHighlightRequired]="
                            isEdit &&
                            (eeHeating.mainSystem1SystemType ===
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] ||
                              ((eeHeating.mainSystem1Fuel !==
                                keyedLookUpCodes['HeatingFuel'][
                                  'Electricity'
                                ] ||
                                eeHeating.mainSystem1SystemSubType !==
                                  keyedLookUpCodes['HeatingType'][
                                    'Electric storage systems'
                                  ]) &&
                                (eeHeating.mainSystem1SystemSubType === '145' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '146' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '147' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '248' ||
                                  eeHeating.mainSystem1SystemSubType === '8' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '149' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '249' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '251' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '373' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '148' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '240' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '253' ||
                                  eeHeating.mainSystem1SystemSubType === '')))
                          " id="mainSystem1Emitter" class="form-select" [(ngModel)]="eeHeating.mainSystem1Emitter"
                          [disabled]="
                            !isEdit ||
                            (eeHeating.mainSystem1SystemType !==
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] &&
                              ((eeHeating.mainSystem1Fuel ===
                                keyedLookUpCodes['HeatingFuel'][
                                  'Electricity'
                                ] &&
                                eeHeating.mainSystem1SystemSubType ===
                                  keyedLookUpCodes['HeatingType'][
                                    'Electric storage systems'
                                  ]) ||
                                (eeHeating.mainSystem1SystemSubType !== '145' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '146' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '147' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '248' &&
                                  eeHeating.mainSystem1SystemSubType !== '8' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '149' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '249' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '251' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '373' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '148' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '240' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '253' &&
                                  eeHeating.mainSystem1SystemSubType !== '')))
                          " [ngModelOptions]="{ standalone: true }">
                          <option></option>
                          <option *ngFor="
                              let property of filterLookupCodes('EmitterType')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Pump Age -->
                    <div class="mh-16 mv-8 w-400" *ngIf="!mainSystem1CommunityHeating">
                      <div class="mb-1">
                        <label for="mainSystem1PumpAge" class="form-label mb-0">Pump Age</label>
                        <select [appHighlightRequired]="
                            isEdit &&
                            (eeHeating.mainSystem1SystemType ===
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] ||
                              (!(
                                eeHeating.mainSystem1Fuel ===
                                  keyedLookUpCodes['HeatingFuel'][
                                    'Electricity'
                                  ] &&
                                eeHeating.mainSystem1SystemSubType ===
                                  keyedLookUpCodes['HeatingType'][
                                    'Electric storage systems'
                                  ]
                              ) &&
                                (eeHeating.mainSystem1SystemSubType === '145' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '146' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '147' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '248' ||
                                  eeHeating.mainSystem1SystemSubType === '')))
                          " id="mainSystem1PumpAge" class="form-select" [(ngModel)]="eeHeating.mainSystem1PumpAge"
                          [disabled]="
                            !isEdit ||
                            (eeHeating.mainSystem1SystemType !=
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] &&
                              ((eeHeating.mainSystem1Fuel ===
                                keyedLookUpCodes['HeatingFuel'][
                                  'Electricity'
                                ] &&
                                eeHeating.mainSystem1SystemSubType ===
                                  keyedLookUpCodes['HeatingType'][
                                    'Electric storage systems'
                                  ]) ||
                                (eeHeating.mainSystem1SystemSubType !== '145' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '146' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '147' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '248' &&
                                  eeHeating.mainSystem1SystemSubType !== '')))
                          " [ngModelOptions]="{ standalone: true }">
                          <option></option>
                          <option *ngFor="
                              let property of filterLookupCodes('PumpAge')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Flow Temp -->
                    <div class="mh-16 mv-8 w-400" *ngIf="!mainSystem1CommunityHeating">
                      <div class="mb-1">
                        <label for="mainSystem1FlowTemp" class="form-label mb-0">Flow Temp</label>
                        <select [appHighlightRequired]="
                            isEdit &&
                            (eeHeating.mainSystem1SystemType ===
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] ||
                              (!(
                                eeHeating.mainSystem1Fuel ===
                                  keyedLookUpCodes['HeatingFuel'][
                                    'Electricity'
                                  ] &&
                                eeHeating.mainSystem1SystemSubType ===
                                  keyedLookUpCodes['HeatingType'][
                                    'Electric storage systems'
                                  ]
                              ) &&
                                (eeHeating.mainSystem1SystemSubType === '145' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '146' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '147' ||
                                  eeHeating.mainSystem1SystemSubType ===
                                    '248' ||
                                  eeHeating.mainSystem1SystemSubType === '')))
                          " id="mainSystem1FlowTemp" class="form-select" [(ngModel)]="eeHeating.mainSystem1FlowTemp"
                          [disabled]="
                            !isEdit ||
                            (eeHeating.mainSystem1SystemType !=
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] &&
                              ((eeHeating.mainSystem1Fuel ===
                                keyedLookUpCodes['HeatingFuel'][
                                  'Electricity'
                                ] &&
                                eeHeating.mainSystem1SystemSubType ===
                                  keyedLookUpCodes['HeatingType'][
                                    'Electric storage systems'
                                  ]) ||
                                (eeHeating.mainSystem1SystemSubType !== '145' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '146' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '147' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '248' &&
                                  eeHeating.mainSystem1SystemSubType !==
                                    '253' &&
                                  eeHeating.mainSystem1SystemSubType !== '')))
                          " [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('FlowTemp')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- MCS Installed -->
                    <div class="mh-16 mv-8 w-400" *ngIf="!mainSystem1CommunityHeating">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeHeating.mainSystem1MCSInstalled"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class=form-label>MCS Installed</label>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label id="temperatureZone" for="mainSystem1HeatingTTZCIndex" class="form-label mb-0">The ID of
                          the time and temperature zone
                          control</label>
                        <input id="mainSystem1HeatingTTZCIndex" class="form-control" name="mainSystem1HeatingTTZCIndex"
                          [(ngModel)]="eeHeating.mainSystem1HeatingTTZCIndex" [disabled]="true"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label id="heatingBoiler" for="mainSystem1HeatingBoilerIgnition" class="form-label mb-0">The
                          heating boiler ignition</label>
                        <select id="mainSystem1HeatingBoilerIgnition" class="form-select" [(ngModel)]="
                            eeHeating.mainSystem1HeatingBoilerIgnition
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes(
                                'HeatingBoilerIgnition'
                              )
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label id="Controller" for="mainSystem1HeatingCompensatingControlIndex"
                          class="form-label mb-0">Controller</label>
                        <input id="mainSystem1HeatingCompensatingControlIndex" class="form-control"
                          name="mainSystem1HeatingCompensatingControlIndex" [(ngModel)]="
                            eeHeating.mainSystem1HeatingCompensatingControlIndex
                          " [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label id="noHeaters" for="mainSystem1HighHeatStorageHeaterIndex" class="form-label mb-0">The
                          index number of the heater</label>
                        <input id="mainSystem1HighHeatStorageHeaterIndex" class="form-control"
                          name="mainSystem1HighHeatStorageHeaterIndex" [(ngModel)]="
                            eeHeating.mainSystem1HighHeatStorageHeaterIndex
                          " [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label id="storageHeaters" for="mainSystem1HighHeatStorageHeaterCount"
                          class="form-label mb-0">The number of storage heaters</label>
                        <input id="mainSystem1HighHeatStorageHeaterCount" class="form-control" type="number"
                          name="mainSystem1HighHeatStorageHeaterCount" [(ngModel)]="
                            eeHeating.mainSystem1HighHeatStorageHeaterCount
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="
                            eeHeating.mainSystem1HighHeatStorageHeaterPresent
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        Whether heater is high heat retention type
                      </div>
                    </div>
                  </div>
                  <!-- End of main system 1 card body -->
                </div>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card" *ngIf="
                    mainSystems &&
                    mainSystems !== 'None installed' &&
                    mainSystems !== '1 Main system'
                  ">
                  <div class="card-header" color="blue-grey-400">
                    Main System 2
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Heating Proportion -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2HeatingProportion" class="form-label mb-0">Heating Proportion
                            (%)</label>
                          <input appHighlightRequired="true" id="mainSystem2HeatingProportion" class="form-control"
                            name="HeatingProportion" type="number" min="0" max="100"
                            [(ngModel)]="eeHeating.mainSystem2HeatingProportion" #mainSystem2HeatingProportion="ngModel"
                            [disabled]="
                              !isEdit ||
                              mainSystems === '1 Main system + 1 DHW only'
                            " [ngModelOptions]="{ standalone: true }" (change)="updateMainSystem1Proportion()" />
                          <div *ngIf="
                              mainSystem2HeatingProportion.errors &&
                              mainSystem2HeatingProportion.dirty
                            " class="error mt-1" style="color: red">
                            <div *ngIf="
                                mainSystem2HeatingProportion.errors.required
                              ">
                              Room count is required.
                            </div>
                            <div *ngIf="mainSystem2HeatingProportion.errors.min">
                              Room count cannot be less than 1.
                            </div>
                            <div *ngIf="mainSystem2HeatingProportion.errors.max">
                              Room count cannot be more than 100.
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Fuel -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label id="mainSystem2Fuel" class="form-label mb-0">Fuel</label>
                          <select appHighlightRequired="true" id="mainSystem2Fuel" class="form-select"
                            [(ngModel)]="eeHeating.mainSystem2Fuel" (change)="
                              onEeHeatingChange(); onHeatingReset('mainSystem2')
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="
                                let property of heatingFuelsBySystem.mainSystem2
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- Data Source -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2SystemType" class="form-label mb-0">Data Source</label>
                          <select appHighlightRequired="true" id="mainSystem2SystemType" class="form-select"
                            [(ngModel)]="eeHeating.mainSystem2SystemType" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="
                                let property of filterLookupCodes(
                                  'PrimarySystemType'
                                )
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- PCDB Data Selector Modal Trigger -->
                      <div class="mh-16 mv-8 w-400" *ngIf="
                          eeHeating.mainSystem2SystemType ==
                          keyedLookUpCodes['PrimarySystemType']['Database']
                        ">
                        <button class="btn btn-primary" (click)="openPcdbDataSelectorModal('mainSystem2')"
                          [disabled]="!isEdit || !eeHeating.mainSystem2Fuel" [ngModelOptions]="{ standalone: true }">
                          Select
                        </button>
                      </div>

                      <!-- Category -->
                      <div class="mh-16 mv-8 w-400" *ngIf="
                          eeHeating.mainSystem2SystemType !==
                          keyedLookUpCodes['PrimarySystemType']['Database']
                        ">
                        <div class="mb-1">
                          <label for="mainSystem2SystemSubType" class="form-label mb-0">Category</label>
                          <select appHighlightRequired="true" id="mainSystem2SystemSubType" class="form-select"
                            [(ngModel)]="eeHeating.mainSystem2SystemSubType" (change)="onEeHeatingChange()" [disabled]="
                              !isEdit ||
                              eeHeating.mainSystem2SystemType ==
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ]
                            " [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let heatingType of heatingMainSystemCategoriesByFuel.mainSystem2
                              " [value]="heatingType.lookupValue">
                              {{ heatingType.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Index, Manufacturer, Model, and Qualifier for PCDB Data -->
                      <div *ngIf="
                          eeHeating.mainSystem2SystemType ==
                          keyedLookUpCodes['PrimarySystemType']['Database']
                        ">
                        <div class="mh-16 mv-8 w-400">
                          <div class="mb-1">
                            <label for="mainSystem2PCDFId" class="form-label mb-0">Index</label>
                            <input id="mainSystem2PCDFId" class="form-control" name="Index"
                              [(ngModel)]="eeHeating.mainSystem2PCDFId" disabled
                              [ngModelOptions]="{ standalone: true }" />
                          </div>
                        </div>

                        <div class="mh-16 mv-8 w-400">
                          <div class="mb-1">
                            <label for="mainSystem2PCDFManufacturer" class="form-label mb-0">Manufacturer</label>
                            <input id="mainSystem2PCDFManufacturer" class="form-control" name="Manufacturer"
                              [(ngModel)]="
                                eeHeating.mainSystem2PCDFManufacturer
                              " disabled [ngModelOptions]="{ standalone: true }" />
                          </div>
                        </div>

                        <div class="mh-16 mv-8 w-400">
                          <div class="mb-1">
                            <label for="mainSystem2PCDFModel" class="form-label mb-0">Model</label>
                            <input id="mainSystem2PCDFModel" class="form-control" name="Model"
                              [(ngModel)]="eeHeating.mainSystem2PCDFModel" disabled
                              [ngModelOptions]="{ standalone: true }" />
                          </div>
                        </div>

                        <div class="mh-16 mv-8 w-400">
                          <div class="mb-1">
                            <label for="mainSystem2PCDFQualifier" class="form-label mb-0">Qualifier</label>
                            <input id="mainSystem2PCDFQualifier" class="form-control" name="Qualifier"
                              [(ngModel)]="eeHeating.mainSystem2PCDFQualifier" disabled
                              [ngModelOptions]="{ standalone: true }" />
                          </div>
                        </div>
                      </div>
                      <!-- GC Number -->
                      <div class="mh-16 mv-8 w-400" *ngIf="
                          eeHeating.mainSystem2Fuel == 26 ||
                          eeHeating.mainSystem2Fuel ==
                            keyedLookUpCodes['HeatingFuel']['Bulk LPG'] ||
                          eeHeating.mainSystem2Fuel ==
                            keyedLookUpCodes['HeatingFuel']['Bottled LPG']
                        ">
                        <div class="mb-3">
                          <label class="form-label">GC Number</label>
                          <input class="form-control" name="Qualifier" [(ngModel)]="eeHeating.mainSystem2PCDFBoilerId"
                            [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>

                      <!-- System Type -->
                      <div *ngIf="
                          eeHeating.mainSystem2SystemType !==
                          keyedLookUpCodes['PrimarySystemType']['Database']
                        " class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2System" class="form-label mb-0">System type</label>
                          <select appHighlightRequired="true" id="mainSystem2System" class="form-select"
                            [(ngModel)]="eeHeating.mainSystem2System" (change)="onEeHeatingChange()"
                            [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let heatingSystem of heatingSystemTypesBySystem.mainSystem2
                              " [value]="heatingSystem.lookupValue">
                              {{ heatingSystem.lookUpItem }}
                            </option>
                          </select>
                        </div>
                        <div class="mb-1" *ngIf="
                            eeHeating.mainSystem2System ===
                              keyedLookUpCodes['HeatingSystem'][
                                'High-heat retention storage heater'
                              ] &&
                            eeHeating.mainSystem2SystemSubType ===
                              keyedLookUpCodes['HeatingType'][
                                'Electric storage systems'
                              ] &&
                            eeHeating.mainSystem2Fuel ===
                              keyedLookUpCodes['HeatingFuel']['Electricity']
                          ">
                          <app-pcdb-data-table-view [items]="resultMain2" [hhrshsystem]="'mainSystem2'"
                            [mainSystem2StorageHeaters]="
                              eeHeating.mainSystem2StorageHeaters
                            " (onSelectData)="dataSelectForMain2($event)"></app-pcdb-data-table-view>
                        </div>
                      </div>

                      <!-- Controls -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2Controls" class="form-label mb-0">Controls</label>
                          <select appHighlightRequired="true" id="mainSystem2Controls" class="form-select"
                            [(ngModel)]="eeHeating.mainSystem2Controls" (change)="onEeHeatingChange()"
                            [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let property of heatingControlsBySystem.mainSystem2
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                        <div class="mb-1" *ngIf="
                            eeHeating.mainSystem2SystemType !==
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] &&
                            eeHeating.mainSystem2SystemSubType ===
                              keyedLookUpCodes['HeatingType'][
                                'Heat pump with radiators or underfloor heating'
                              ] &&
                            eeHeating.mainSystem2Controls ===
                              keyedLookUpCodes['HeatingControls'][
                                '(TTZC) by device in database'
                              ]
                          ">
                          <app-pcdb-manual-controls-table (onSelectData)="
                              dataSelectHeatingControlsForMain2($event)
                            "></app-pcdb-manual-controls-table>
                        </div>
                      </div>

                      <!-- Weather Compensation -->
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox"
                          [(ngModel)]="eeHeating.mainSystem2WeatherCompensation" aria-label="Weather compensation"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label>Weather compensation</label>
                        <div class="mb-1" *ngIf="
                            eeHeating.mainSystem2SystemType !==
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] &&
                            eeHeating.mainSystem2SystemSubType ===
                              keyedLookUpCodes['HeatingType'][
                                'Heat pump with radiators or underfloor heating'
                              ] &&
                            eeHeating.mainSystem2Controls ===
                              keyedLookUpCodes['HeatingControls'][
                                '(TTZC) by device in database'
                              ] &&
                            eeHeating.mainSystem2WeatherCompensation
                          ">
                          <app-pcdb-manual-weather-compensation (onSelectData)="
                              dataSelectWeatherCompensationForMain2($event)
                            "></app-pcdb-manual-weather-compensation>
                        </div>
                      </div>

                      <!-- Flue Type -->
                      <div *ngIf="
                          eeHeating.mainSystem2Fuel !==
                          keyedLookUpCodes['HeatingFuel']['Electricity']
                        " class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2FlueType" class="form-label mb-0">Flue type</label>
                          <select appHighlightRequired="true" class="form-select"
                            [(ngModel)]="eeHeating.mainSystem2FlueType" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let property of heatingFlueTypesBySystem.mainSystem2
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Fan Assisted -->
                      <div *ngIf="
                          eeHeating.mainSystem2Fuel !==
                          keyedLookUpCodes['HeatingFuel']['Electricity']
                        " class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="eeHeating.mainSystem2FanAssisted"
                          aria-label="Fan assisted" [ngModelOptions]="{ standalone: true }" [disabled]="
                            !isEdit ||
                            eeHeating.mainSystem2SystemType ==
                              keyedLookUpCodes['PrimarySystemType'][
                                'Database'
                              ] ||
                            eeHeating.mainSystem2System ==
                              keyedLookUpCodes['HeatingSystem'][
                                'Gas fire, closed fronted, fan assisted'
                              ]
                          " />
                          <label class=form-label>Fan assisted</label>
                      </div>

                      <!-- Emitters -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2Emitter" class="form-label mb-0">Emitters</label>
                          <select [appHighlightRequired]="
                              isEdit &&
                              (eeHeating.mainSystem2SystemType ===
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ] ||
                                ((eeHeating.mainSystem2Fuel !==
                                  keyedLookUpCodes['HeatingFuel'][
                                    'Electricity'
                                  ] ||
                                  eeHeating.mainSystem2SystemSubType !==
                                    keyedLookUpCodes['HeatingType'][
                                      'Electric storage systems'
                                    ]) &&
                                  (eeHeating.mainSystem2SystemSubType ===
                                    '145' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '146' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '147' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '248' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '8' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '149' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '249' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '251' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '373' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '148' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '240' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '253' ||
                                    eeHeating.mainSystem2SystemSubType === '')))
                            " id="mainSystem2Emitter" class="form-select" [(ngModel)]="eeHeating.mainSystem2Emitter"
                            [disabled]="
                              !isEdit ||
                              (eeHeating.mainSystem2SystemType !==
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ] &&
                                ((eeHeating.mainSystem2Fuel ===
                                  keyedLookUpCodes['HeatingFuel'][
                                    'Electricity'
                                  ] &&
                                  eeHeating.mainSystem2SystemSubType ===
                                    keyedLookUpCodes['HeatingType'][
                                      'Electric storage systems'
                                    ]) ||
                                  (eeHeating.mainSystem2SystemSubType !==
                                    '145' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '146' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '147' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '248' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '8' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '149' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '249' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '251' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '373' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '148' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '240' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '253' &&
                                    eeHeating.mainSystem2SystemSubType !== '')))
                            " [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let property of filterLookupCodes('EmitterType')
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Pump Age -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2PumpAge" class="form-label mb-0">Pump age</label>
                          <select [appHighlightRequired]="
                              isEdit &&
                              (eeHeating.mainSystem2SystemType ===
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ] ||
                                (!(
                                  eeHeating.mainSystem2Fuel ===
                                    keyedLookUpCodes['HeatingFuel'][
                                      'Electricity'
                                    ] &&
                                  eeHeating.mainSystem2SystemSubType ===
                                    keyedLookUpCodes['HeatingType'][
                                      'Electric storage systems'
                                    ]
                                ) &&
                                  (eeHeating.mainSystem2SystemSubType ===
                                    '145' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '146' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '147' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '248' ||
                                    eeHeating.mainSystem2SystemSubType === '')))
                            " id="mainSystem2PumpAge" class="form-select" [(ngModel)]="eeHeating.mainSystem2PumpAge"
                            [disabled]="
                              !isEdit ||
                              (eeHeating.mainSystem2SystemType !==
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ] &&
                                ((eeHeating.mainSystem2Fuel ===
                                  keyedLookUpCodes['HeatingFuel'][
                                    'Electricity'
                                  ] &&
                                  eeHeating.mainSystem2SystemSubType ===
                                    keyedLookUpCodes['HeatingType'][
                                      'Electric storage systems'
                                    ]) ||
                                  (eeHeating.mainSystem2SystemSubType !==
                                    '145' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '146' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '147' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '248' &&
                                    eeHeating.mainSystem2SystemSubType !== '')))
                            " [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let property of filterLookupCodes('PumpAge')
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Flow Temp -->
                      <div class="mh-16 mv-8 w-400">
                        <div class="mb-1">
                          <label for="mainSystem2FlowTemp" class="form-label mb-0">Flow temp</label>
                          <select [appHighlightRequired]="
                              isEdit &&
                              (eeHeating.mainSystem2SystemType ===
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ] ||
                                (!(
                                  eeHeating.mainSystem2Fuel ===
                                    keyedLookUpCodes['HeatingFuel'][
                                      'Electricity'
                                    ] &&
                                  eeHeating.mainSystem2SystemSubType ===
                                    keyedLookUpCodes['HeatingType'][
                                      'Electric storage systems'
                                    ]
                                ) &&
                                  (eeHeating.mainSystem2SystemSubType ===
                                    '145' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '146' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '147' ||
                                    eeHeating.mainSystem2SystemSubType ===
                                      '248' ||
                                    eeHeating.mainSystem2SystemSubType === '')))
                            " id="mainSystem2FlowTemp" class="form-select" [(ngModel)]="eeHeating.mainSystem2FlowTemp"
                            [disabled]="
                              !isEdit ||
                              (eeHeating.mainSystem2SystemType !==
                                keyedLookUpCodes['PrimarySystemType'][
                                  'Database'
                                ] &&
                                ((eeHeating.mainSystem2Fuel ===
                                  keyedLookUpCodes['HeatingFuel'][
                                    'Electricity'
                                  ] &&
                                  eeHeating.mainSystem2SystemSubType ===
                                    keyedLookUpCodes['HeatingType'][
                                      'Electric storage systems'
                                    ]) ||
                                  (eeHeating.mainSystem2SystemSubType !==
                                    '145' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '146' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '147' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '248' &&
                                    eeHeating.mainSystem2SystemSubType !==
                                      '253' &&
                                    eeHeating.mainSystem2SystemSubType !== '')))
                            " [ngModelOptions]="{ standalone: true }">
                            <option></option>
                            <option *ngFor="
                                let property of filterLookupCodes('FlowTemp')
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- MCS Installed -->
                      <div class="mh-16 mv-8 w-400">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="eeHeating.mainSystem2MCSInstalled"
                          aria-label="MCS installed" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          <label class=form-label>MCS installed</label>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <div class="mb-1">
                          <label for="mainSystem2HeatingTTZCIndex" class="form-label mb-0">The ID of the time and
                            temperature zone
                            control</label>
                          <input class="form-control" name="mainSystem2HeatingTTZCIndex"
                            [(ngModel)]="eeHeating.mainSystem2HeatingTTZCIndex" [disabled]="true"
                            [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <div class="mb-1">
                          <label for="mainSystem2HeatingBoilerIgnition" class="form-label mb-0">The heating boiler
                            ignition</label>
                          <select id="mainSystem2HeatingBoilerIgnition" class="form-select" [(ngModel)]="
                              eeHeating.mainSystem2HeatingBoilerIgnition
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                            <option *ngFor="
                                let property of filterLookupCodes(
                                  'HeatingBoilerIgnition'
                                )
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <div class="mb-1">
                          <label for="mainSystem2HeatingCompensatingControlIndex"
                            class="form-label mb-0">Controller</label>
                          <input id="mainSystem2HeatingCompensatingControlIndex" class="form-control"
                            name="mainSystem2HeatingCompensatingControlIndex" [(ngModel)]="
                              eeHeating.mainSystem2HeatingCompensatingControlIndex
                            " [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <div class="mb-1">
                          <label for="mainSystem2HighHeatStorageHeaterIndex" class="form-label mb-0">The index number of
                            the heater</label>
                          <input id="mainSystem2HighHeatStorageHeaterIndex" class="form-control"
                            name="mainSystem2HighHeatStorageHeaterIndex" [(ngModel)]="
                              eeHeating.mainSystem2HighHeatStorageHeaterIndex
                            " [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <div class="mb-1">
                          <label for="mainSystem2HighHeatStorageHeaterCount" class="form-label mb-0">The number of
                            storage heaters</label>
                          <input id="mainSystem2HighHeatStorageHeaterCount" class="form-control" type="number"
                            name="mainSystem2HighHeatStorageHeaterCount" [(ngModel)]="
                              eeHeating.mainSystem2HighHeatStorageHeaterCount
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        </div>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <div class="mb-1">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="
                              eeHeating.mainSystem2HighHeatStorageHeaterPresent
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          Whether heater is high heat retention type
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-8 col-md-12 col-sm-12 mb-2" >
                <div class="card" *ngIf="secondaryHeating">
                  <div class="card-header">Secondary Heating</div>
                  <div class="card-body">
                    <div class="mb-1">
                      <label class="form-label mb-0">Fuel</label>
                      <select appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeHeating.secoundaryHeatingFuel" (change)="
                          onSecoundaryHeatingFuelChange($event.target.value)
                        " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let fuel of secondaryHeatingFuels" [value]="fuel.lookupValue">
                          {{ fuel.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1">
                      <label class="form-label mb-0">System</label>
                      <select appHighlightRequired="true" class="form-select"
                        [(ngModel)]="eeHeating.secoundaryHeatingSystem" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let system of secoundaryHeatingSystems" [value]="system.lookupValue">
                          {{ system.lookUpItem }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="9">
        <!-- Water Heating Tab -->
        <a ngbNavLink (click)="onSelectTab(9)" role="button">
          Water Heating
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(9) === false ||
                  (isTabClicked(9) && !isWaterHeatingTabValid()),
                'bi bi-check-circle':
                  isTabClicked(9) && isWaterHeatingTabValid(),
                'text-warning': isTabClicked(9) === false,
                'text-danger': isTabClicked(9) && !isWaterHeatingTabValid(),
                'text-success': isTabClicked(9) && isWaterHeatingTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <!-- Water Heating Card -->
                <div class="card">
                  <div class="card-header">Water Heating</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label for="waterHeatingSystem" class="form-label mb-0">System</label>
                      <select appHighlightRequired="true" id="waterHeatingSystem"
                        [(ngModel)]="eeHeating.waterHeatingSystem" class="form-select"
                        (change)="onSystemChange($event.target.value)" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }">
                        <option></option>
                        <option *ngFor="let type of waterHeatingTypes" [value]="type.lookupValue">
                          {{ type.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <label for="waterHeatingFuel" class="form-label mb-0">Fuel</label>
                      <select [appHighlightRequired]="
                          eeHeating.waterHeatingSystem != '999'
                        " id="waterHeatingFuel" [(ngModel)]="eeHeating.waterHeatingFuel" class="form-select"
                        [disabled]="
                          !isEdit ||
                          eeHeating.waterHeatingSystem ==
                            keyedLookUpCodes['WaterHeatingType']['None']
                        " [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let fuel of waterHeatingFuels" [value]="fuel.lookupValue">
                          {{ fuel.lookUpItem }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2" *ngIf="showWaterHeatingCylinderCard()">
                <!-- Cylinder Card -->
                <div class="card">
                  <div class="card-header bg-blue-grey-400">Cylinder</div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <label for="cylinderDetailsSize" class="form-label mb-0">Size</label>
                      <select appHighlightRequired="true" id="cylinderDetailsSize" [(ngModel)]="eeHeating.cylinderDetailsSize" class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                        <option *ngFor="let property of filterLookupCodes('CylinderSize')" [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none" *ngIf="eeHeating.cylinderDetailsSize === keyedLookUpCodes['CylinderSize']['Exact cylinder volume known']">
                      <label for="cylinderDetailsSizeMeasured" class="form-label mb-0">Measured HWC volume</label>
                      <input id="cylinderDetailsSizeMeasured" class="form-control" type="number" [(ngModel)]="eeHeating.cylinderDetailsSizeMeasured" aria-label="Measured HWC volume" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div *ngIf="eeHeating.cylinderDetailsSize !== keyedLookUpCodes['CylinderSize']['No access'] && eeHeating.cylinderDetailsSize !== keyedLookUpCodes['CylinderSize']['No cylinder']">
                      <div class="mh-16 mv-8 w-400" *ngIf="!cylinderDetailsDeclaredHeatLossSelected">
                        <label for="cylinderDetailsInsulation" class="form-label mb-0">Insulation</label>
                        <select appHighlightRequired="true" id="cylinderDetailsInsulation" [(ngModel)]="eeHeating.cylinderDetailsInsulation" class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('CylinderInsulationType')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mh-16 mv-8 w-400" *ngIf="!cylinderDetailsDeclaredHeatLossSelected && eeHeating.cylinderDetailsInsulation !== '0'">
                        <label for="cylinderDetailsThickness" class="form-label mb-0">Thickness</label>
                        <select appHighlightRequired="true" id="cylinderDetailsThickness" [(ngModel)]="eeHeating.cylinderDetailsThickness" class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of filterLookupCodes('CylinderInsulationThickness')" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mh-16 mv-8 w-400" *ngIf="
                          eeHeating.waterHeatingSystem ==
                          keyedLookUpCodes['WaterHeatingType'][
                            'Electric immersion'
                          ]
                        ">
                        <label for="cylinderDetailsImmersion" class="form-label mb-0">Immersion</label>
                        <select appHighlightRequired="true" id="cylinderDetailsImmersion"
                          [(ngModel)]="eeHeating.cylinderDetailsImmersion" class="form-select" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let property of immersionTypes" [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mh-16 mv-8 w-400 d-none">
                        <input class="form-check-input" type="checkbox"
                          [(ngModel)]="cylinderDetailsDeclaredHeatLossSelected" aria-label="Cylinder stat"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label for="cylinderDetailsDeclaredHeatLoss" class="form-label mb-0">Declared cylinder heat
                          loss</label>
                        <input id="cylinderDetailsDeclaredHeatLoss" class="form-control" type="number" [(ngModel)]="
                            eeHeating.cylinderDetailsDeclaredHeatLoss
                          " aria-label="Measured HWC volume" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <div class="mh-16 mv-8 w-400">
                        <input id="cylinderDetailsStart" class="form-check-input" type="checkbox"
                          [(ngModel)]="eeHeating.cylinderDetailsStart" aria-label="Cylinder stat" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <label for="cylinderDetailsStart" class="form-label mb-0 ms-1">Cylinder stat</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <!-- Bath and Shower Card -->
                <div class="card">
                  <div class="card-header bg-blue-grey-400">
                    Bath and shower
                  </div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1 d-none">
                        <label for="bathCount" class="form-label mb-0">Number of baths in dwelling</label>
                        <input class="form-control" type="number" name="bathCount" [(ngModel)]="eeHeating.bathCount"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <div class="mb-1">
                        <label for="bathAndShowerRoomsWithBathAndOrNonMixerShower" class="form-label mb-0">
                          Number of rooms with bath and/or shower
                        </label>
                        <input [class.highlight-required]="
                            !isValidBathAndShowerRoomsCount()
                          " class="form-control" type="number" name="bathAndShowerRoomsWithBathAndOrNonMixerShower"
                          min="0" max="99" #eeHeatingbathAndShowerRoomsWithBathAndOrNonMixerShower="ngModel"
                          [(ngModel)]="
                            eeHeating.bathAndShowerRoomsWithBathAndOrNonMixerShower
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <!-- Bath and Shower Bath and/or Shower Validation -->
                        <div *ngIf="
                            eeHeatingbathAndShowerRoomsWithBathAndOrNonMixerShower.invalid &&
                            (eeHeatingbathAndShowerRoomsWithBathAndOrNonMixerShower.dirty ||
                              eeHeatingbathAndShowerRoomsWithBathAndOrNonMixerShower.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeHeatingbathAndShowerRoomsWithBathAndOrNonMixerShower.errors?.['min']">
                            Value must be at least 0.
                          </span>
                          <span *ngIf="eeHeatingbathAndShowerRoomsWithBathAndOrNonMixerShower.errors?.['max']">
                            Value must have a maximum of 99.
                          </span>
                        </div>
                        <div *ngIf="!isValidBathAndShowerRoomsCount()" class="text-danger small mt-1">
                          Total should be at least the number of rooms with
                          mixer showers.
                        </div>
                      </div>
                      <div class="mb-1">
                        <label for="bathAndShowerRoomsWithMixerShowerNoBath" class="form-label mb-0">
                          Number of rooms with mixer shower and no bath
                        </label>
                        <input appHighlightRequired="true" class="form-control" type="number"
                          name="bathAndShowerRoomsWithMixerShowerNoBath" min="0" max="99"
                          #eeHeatingbathAndShowerRoomsWithMixerShowerNoBath="ngModel" [(ngModel)]="
                            eeHeating.bathAndShowerRoomsWithMixerShowerNoBath
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <!-- Bath and Shower Mixer Shower and no Bath Validation -->
                        <div *ngIf="
                            eeHeatingbathAndShowerRoomsWithMixerShowerNoBath.invalid &&
                            (eeHeatingbathAndShowerRoomsWithMixerShowerNoBath.dirty ||
                              eeHeatingbathAndShowerRoomsWithMixerShowerNoBath.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeHeatingbathAndShowerRoomsWithMixerShowerNoBath.errors?.['min']">
                            Value must be at least 0.
                          </span>
                          <span *ngIf="eeHeatingbathAndShowerRoomsWithMixerShowerNoBath.errors?.['max']">
                            Value must have a maximum of 99.
                          </span>
                        </div>
                      </div>
                      <div class="mb-1">
                        <label for="bathAndShowerRoomsWithMixerShowerAndBath" class="form-label mb-0">
                          Number of rooms with mixer shower and bath
                        </label>
                        <input appHighlightRequired="true" class="form-control" type="number"
                          name="bathAndShowerRoomsWithMixerShowerAndBath" min="0" max="99"
                          #eeHeatingbathAndShowerRoomsWithMixerShowerAndBath="ngModel" [(ngModel)]="
                            eeHeating.bathAndShowerRoomsWithMixerShowerAndBath
                          " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <!-- Bath and Shower Mixer Shower and Bath Validation -->
                        <div *ngIf="
                            eeHeatingbathAndShowerRoomsWithMixerShowerAndBath.invalid &&
                            (eeHeatingbathAndShowerRoomsWithMixerShowerAndBath.dirty ||
                              eeHeatingbathAndShowerRoomsWithMixerShowerAndBath.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeHeatingbathAndShowerRoomsWithMixerShowerAndBath.errors?.['min']">
                            Value must be at least 0.
                          </span>
                          <span *ngIf="eeHeatingbathAndShowerRoomsWithMixerShowerAndBath.errors?.['max']">
                            Value must have a maximum of 99.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <button class="btn btn-primary" (click)="openShowerProfileModal('eeHeating')">
                        Shower Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="10">
        <!-- Renewables Tab -->
        <a ngbNavLink (click)="onSelectTab(10)" role="button">
          Renewables
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(10) === false ||
                  (isTabClicked(10) && !isRenewablesTabValid()),
                'bi bi-check-circle':
                  isTabClicked(10) && isRenewablesTabValid(),
                'text-warning': isTabClicked(10) === false,
                'text-danger': isTabClicked(10) && !isRenewablesTabValid(),
                'text-success': isTabClicked(10) && isRenewablesTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header bg-blue-grey-400">PV System</div>
                  <div class="card-body">
                    <!-- PV Configuration -->
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="pVConfiguration" class="form-label mb-0">PV Configuration</label>
                        <select id="pvConfiguration" [(ngModel)]="eeRR.pvConfiguration" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let configuration of pvConfigurationsOptions
                            " [value]="configuration.value">
                            {{ configuration.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400 d-none">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeRR.pvDiverterPresent"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      PV Diverter Present
                    </div>
                    <!-- pvBatteryCount -->
                    <div class="mh-16 mv-8 w-400 d-none">
                      <div class="mb-1">
                        <label for="pvBatteryCount" class="form-label mb-0">Number of batteries</label>
                        <select id="pvBatteryCount" (change)="onChange($event)" [(ngModel)]="eeRR.pvBatteryCount"
                          class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="let option of pvNumberOfBatteries" [value]="option">
                            {{ option }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div *ngIf="pvBatteryCapacity >= 1 && pvBatteryCapacity <= 4">
                      <div class="mb-1">
                        <label for="pvBatteryCapacity1" class="form-label mb-0">kWh</label>
                        <input id="pvBatteryCapacity1" class="form-control" name="pvBatteryCapacity1" type="number"
                          min="0" [(ngModel)]="eeRR.pvBatteryCapacity1" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div *ngIf="pvBatteryCapacity >= 2 && pvBatteryCapacity <= 4">
                      <div class="mb-1">
                        <label for="pvBatteryCapacity2" class="form-label mb-0">kWh</label>
                        <input id="pvBatteryCapacity2" class="form-control" name="pvBatteryCapacity2" type="number"
                          min="0" [(ngModel)]="eeRR.pvBatteryCapacity2" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div *ngIf="pvBatteryCapacity >= 3 && pvBatteryCapacity <= 4">
                      <div class="mb-1">
                        <label for="pvBatteryCapacity3" class="form-label mb-0">kWh</label>
                        <input id="pvBatteryCapacity3" class="form-control" name="pvBatteryCapacity3" type="number"
                          min="0" [(ngModel)]="eeRR.pvBatteryCapacity3" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div *ngIf="pvBatteryCapacity === 4">
                      <div class="mb-1">
                        <label for="pvBatteryCapacity4" class="form-label mb-0">kWh</label>
                        <input id="pvBatteryCapacity4" class="form-control" name="pvBatteryCapacity4" type="number"
                          min="0" [(ngModel)]="eeRR.pvBatteryCapacity4" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>

                    <!-- Additional fields based on PV Configuration -->
                    <div *ngIf="
                        eeRR.pvConfiguration ==
                        keyedPVConfigurationsOptions[
                          'PV system (roof coverage only)'
                        ]
                      ">
                      <div class="mb-1">
                        <label class="form-label mb-0">Percentage of roof covered</label>
                        <input appHighlightRequired="true" class="form-control" name="PercentageOfRoofCovered"
                          type="number" min="0" max="100" [(ngModel)]="eeRR.percentageOfRoofCovered"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <div class="mb-1">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="eeRR.pvConnectedToMeter"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Connected to meter</label>
                      </div>
                    </div>
                    <div *ngIf="
                        eeRR.pvConfiguration ==
                          keyedPVConfigurationsOptions[
                            '1 PV Array (kWp known)'
                          ] ||
                        eeRR.pvConfiguration ==
                          keyedPVConfigurationsOptions[
                            '2 PV Arrays (kWp known)'
                          ] ||
                        eeRR.pvConfiguration ==
                          keyedPVConfigurationsOptions[
                            '3 PV Arrays (kWp known)'
                          ]
                      ">
                      <div>Array-1</div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Pitch</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array1Pitch" class="form-select"
                          [disabled]="!isEdit" (change)="setRenewablesArrayOrientations('array1')"
                          [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('VerticalPitch')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Orientation</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array1Orientation" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of renewablesOrientationsByArray.array1
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Overshading</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array1Overshading" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }">
                          <option *ngFor="
                              let property of filterLookupCodes('Overshading')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">kWp</label>
                        <input appHighlightRequired="true" class="form-control" type="number" min="0.2" max="15.0"
                          step="0.1" #eeRRarray1KWP="ngModel" [(ngModel)]="eeRR.array1KWP" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                        <!-- Array 1 kWp Validation -->
                        <div *ngIf="
                            eeRRarray1KWP.invalid &&
                            (eeRRarray1KWP.dirty || eeRRarray1KWP.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeRRarray1KWP.errors?.['min']">
                            kWp must be at least 0.2.
                          </span>
                          <span *ngIf="eeRRarray1KWP.errors?.['max']">
                            kWp must have a maximum of 15.0.
                          </span>
                        </div>
                      </div>
                      <div class="mb-1">
                        <input class="form-check-input" type="checkbox" aria-label="Connected to meter"
                          [(ngModel)]="eeRR.array1ConnectedToMeter" [trueValue]="true" [falseValue]="false"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                          <label class="form-label">Connected to meter</label>
                      </div>
                    </div>

                    <div *ngIf="
                        eeRR.pvConfiguration ==
                          keyedPVConfigurationsOptions[
                            '2 PV Arrays (kWp known)'
                          ] ||
                        eeRR.pvConfiguration ==
                          keyedPVConfigurationsOptions[
                            '3 PV Arrays (kWp known)'
                          ]
                      ">
                      <div>Array-2</div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Pitch</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array2Pitch" class="form-select"
                          [disabled]="!isEdit" (change)="setRenewablesArrayOrientations('array2')"
                          [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array2Pitch !==
                                eeRRForActiveDataSet.array2Pitch
                          }">
                          <option *ngFor="
                              let property of filterLookupCodes('VerticalPitch')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Orientation</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array2Orientation" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array2Orientation !==
                                eeRRForActiveDataSet.array2Orientation
                          }">
                          <option *ngFor="
                              let property of renewablesOrientationsByArray.array2
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Overshading</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array2Overshading" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array2Overshading !==
                                eeRRForActiveDataSet.array2Overshading
                          }">
                          <option *ngFor="
                              let property of filterLookupCodes('Overshading')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">kWp</label>
                        <input appHighlightRequired="true" class="form-control" type="number" min="0.2" max="15.0"
                          step="0.1" #eeRRarray2KWP="ngModel" [(ngModel)]="eeRR.array2KWP" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array2KWP !== eeRRForActiveDataSet.array2KWP
                          }" />
                        <!-- Array 2 kWp Validation -->
                        <div *ngIf="
                            eeRRarray2KWP.invalid &&
                            (eeRRarray2KWP.dirty || eeRRarray2KWP.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeRRarray2KWP.errors?.['min']">
                            kWp must be at least 0.2.
                          </span>
                          <span *ngIf="eeRRarray2KWP.errors?.['max']">
                            kWp must have a maximum of 15.0.
                          </span>
                        </div>
                      </div>
                      <div class="mb-1">
                        <input class="form-check-input" type="checkbox" aria-label="Connected to meter"
                          [(ngModel)]="eeRR.array2ConnectedToMeter" [trueValue]="true" [falseValue]="false"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array2ConnectedToMeter !==
                                eeRRForActiveDataSet.array2ConnectedToMeter
                          }" />
                          <label class="form-label">Connected to meter</label>
                      </div>
                    </div>

                    <div *ngIf="
                        eeRR.pvConfiguration ==
                        keyedPVConfigurationsOptions['3 PV Arrays (kWp known)']
                      ">
                      <div>Array-3</div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Pitch</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array3Pitch" class="form-select"
                          [disabled]="!isEdit" (change)="setRenewablesArrayOrientations('array3')"
                          [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array3Pitch !==
                                eeRRForActiveDataSet.array3Pitch
                          }">
                          <option *ngFor="
                              let property of filterLookupCodes('VerticalPitch')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Orientation</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array3Orientation" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array3Orientation !==
                                eeRRForActiveDataSet.array3Orientation
                          }">
                          <option *ngFor="
                              let property of renewablesOrientationsByArray.array3
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">Overshading</label>
                        <select appHighlightRequired="true" [(ngModel)]="eeRR.array3Overshading" class="form-select"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array3Overshading !==
                                eeRRForActiveDataSet.array3Overshading
                          }">
                          <option *ngFor="
                              let property of filterLookupCodes('Overshading')
                            " [value]="property.lookupValue">
                            {{ property.lookUpItem }}
                          </option>
                        </select>
                      </div>
                      <div class="mb-1">
                        <label class="form-label mb-0">kWp</label>
                        <input appHighlightRequired="true" class="form-control" type="number" min="0.2" max="15.0"
                          step="0.1" #eeRRarray3KWP="ngModel" [(ngModel)]="eeRR.array3KWP" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array3KWP !== eeRRForActiveDataSet.array3KWP
                          }" />
                        <!-- Array 3 kWp Validation -->
                        <div *ngIf="
                            eeRRarray3KWP.invalid &&
                            (eeRRarray3KWP.dirty || eeRRarray3KWP.touched)
                          " class="alert p-0 m-0 text-danger">
                          <span *ngIf="eeRRarray3KWP.errors?.['min']">
                            kWp must be at least 0.2.
                          </span>
                          <span *ngIf="eeRRarray3KWP.errors?.['max']">
                            kWp must have a maximum of 15.0.
                          </span>
                        </div>
                      </div>
                      <div class="mb-1">
                        <input class="form-check-input" type="checkbox" aria-label="Connected to meter"
                          [(ngModel)]="eeRR.array3ConnectedToMeter" [trueValue]="true" [falseValue]="false"
                          [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                            modifiedBackgroundClass:
                              hasAnActiveDataSet &&
                              eeRR.array3ConnectedToMeter !==
                                eeRRForActiveDataSet.array3ConnectedToMeter
                          }" />
                          <label class="form-label">Connected to meter</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                    Solar Water Heating
                  </div>
                  <div class="card-body">
                    <div class="mb-1">
                      <label for="swhConfiguration" class="form-label mb-0">SWH Configuration</label>
                      <select appHighlightRequired="true" id="swhConfiguration" [(ngModel)]="eeRR.swhConfiguration"
                        (change)="setRenewablesSWHDefaults()" class="form-select" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.swhConfiguration !==
                              eeRRForActiveDataSet.swhConfiguration
                        }">
                        <option *ngFor="let configuration of swhConfigurations" [value]="configuration.value">
                          {{ configuration.name }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1" *ngIf="
                        eeRR.swhConfiguration ==
                        keyedSWHConfigurations[
                          'Solar water heating (details known)'
                        ]
                      ">
                      <label class="form-label mb-0">Pitch</label>
                      <select appHighlightRequired="true" [(ngModel)]="eeRR.solarWaterHeaterPitch" class="form-select"
                        (change)="setRenewablesSWHOrientations()" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.solarWaterHeaterPitch !==
                              eeRRForActiveDataSet.solarWaterHeaterPitch
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes('VerticalPitch')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1" *ngIf="
                        eeRR.swhConfiguration ==
                        keyedSWHConfigurations[
                          'Solar water heating (details known)'
                        ]
                      ">
                      <label class="form-label mb-0">Orientation</label>
                      <select appHighlightRequired="true" [(ngModel)]="eeRR.solarWaterHeaterOrientation"
                        class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.solarWaterHeaterOrientation !==
                              eeRRForActiveDataSet.solarWaterHeaterOrientation
                        }">
                        <option *ngFor="let property of renewablesSwhOrientations" [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1" *ngIf="
                        eeRR.swhConfiguration ==
                        keyedSWHConfigurations[
                          'Solar water heating (details known)'
                        ]
                      ">
                      <label class="form-label mb-0">Overshading</label>
                      <select appHighlightRequired="true" [(ngModel)]="eeRR.solarWaterHeaterOvershading"
                        class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.solarWaterHeaterOvershading !==
                              eeRRForActiveDataSet.solarWaterHeaterOvershading
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes('Overshading')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1" *ngIf="
                        eeRR.swhConfiguration ==
                        keyedSWHConfigurations[
                          'Solar water heating (details known)'
                        ]
                      ">
                      <label class="form-label mb-0">Shower types</label>
                      <select appHighlightRequired="true" [(ngModel)]="eeRR.solarWaterHeaterShowerTypes"
                        class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.solarWaterHeaterShowerTypes !==
                              eeRRForActiveDataSet.solarWaterHeaterShowerTypes
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes('ShowerType')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1" *ngIf="
                        eeRR.swhConfiguration ==
                        keyedSWHConfigurations[
                          'Solar water heating (details known)'
                        ]
                      ">
                      <label class="form-label mb-0">Solar circulating pump</label>
                      <select appHighlightRequired="true" [(ngModel)]="eeRR.solarWaterHeaterCirculatingPump"
                        class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.solarWaterHeaterCirculatingPump !==
                              eeRRForActiveDataSet.solarWaterHeaterCirculatingPump
                        }">
                        <option *ngFor="
                            let property of filterLookupCodes('SolarPump')
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="col" *ngIf="
                        eeRR.swhConfiguration ==
                        keyedSWHConfigurations[
                          'Solar water heating (details known)'
                        ]
                      ">
                      <div class="col mb-10">
                        <hr />
                        <p><span>Collector Details</span></p>
                        <div class="mb-1">
                          <label class="form-label mb-0">Collector type</label>
                          <select appHighlightRequired="true" [(ngModel)]="eeRR.solarWaterHeaterCollectorType"
                            class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterCollectorType !==
                                  eeRRForActiveDataSet.solarWaterHeaterCollectorType
                            }">
                            <option *ngFor="
                                let property of filterLookupCodes(
                                  'CollectorType'
                                )
                              " [value]="property.lookupValue">
                              {{ property.lookUpItem }}
                            </option>
                          </select>
                        </div>
                        <div class="mb-1">
                          <label class="form-label mb-0">Area of panel (m<sup>2</sup>)</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="0.5" max="10.0"
                            step="0.1" #eeRRsolarWaterHeaterAreaOfPanel="ngModel"
                            [(ngModel)]="eeRR.solarWaterHeaterAreaOfPanel" [disabled]="!isEdit"
                            [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterAreaOfPanel !==
                                  eeRRForActiveDataSet.solarWaterHeaterAreaOfPanel
                            }" />
                          <!-- Collector Details Panel area Validation -->
                          <div *ngIf="
                              eeRRsolarWaterHeaterAreaOfPanel.invalid &&
                              (eeRRsolarWaterHeaterAreaOfPanel.dirty ||
                                eeRRsolarWaterHeaterAreaOfPanel.touched)
                            " class="alert p-0 m-0 text-danger">
                            <span *ngIf="eeRRsolarWaterHeaterAreaOfPanel.errors?.['min']">
                              Panel area must be at least 0.5.
                            </span>
                            <span *ngIf="eeRRsolarWaterHeaterAreaOfPanel.errors?.['max']">
                              Panel area must have a maximum of 10.0.
                            </span>
                          </div>
                        </div>
                        <div class="mb-1">
                          <label class="form-label mb-0">Zero loss efficiency</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="30" max="90"
                            step="0.1" #eeRRsolarWaterHeaterZeroLossEfficiency="ngModel" [(ngModel)]="
                              eeRR.solarWaterHeaterZeroLossEfficiency
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterZeroLossEfficiency !==
                                  eeRRForActiveDataSet.solarWaterHeaterZeroLossEfficiency
                            }" />
                          <!-- Collector Details Loss Efficiency Validation -->
                          <div *ngIf="
                              eeRRsolarWaterHeaterZeroLossEfficiency.invalid &&
                              (eeRRsolarWaterHeaterZeroLossEfficiency.dirty ||
                                eeRRsolarWaterHeaterZeroLossEfficiency.touched)
                            " class="alert p-0 m-0 text-danger">
                            <span *ngIf="eeRRsolarWaterHeaterZeroLossEfficiency.errors?.['min']">
                              Efficiency must be at least 30.
                            </span>
                            <span *ngIf="eeRRsolarWaterHeaterZeroLossEfficiency.errors?.['max']">
                              Efficiency have a maximum of 90.
                            </span>
                          </div>
                        </div>
                        <div class="mb-1">
                          <label class="form-label mb-0">Linear heat loss coefficient</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="0.5" max="20.0"
                            step="0.1" #eeRRsolarWaterHeaterLinearHeatLossCoefficient="ngModel" [(ngModel)]="
                              eeRR.solarWaterHeaterLinearHeatLossCoefficient
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterLinearHeatLossCoefficient !==
                                  eeRRForActiveDataSet.solarWaterHeaterLinearHeatLossCoefficient
                            }" />
                          <!-- Collector Details Heat Loss Coefficient -->
                          <div *ngIf="
                              eeRRsolarWaterHeaterLinearHeatLossCoefficient.invalid &&
                              (eeRRsolarWaterHeaterLinearHeatLossCoefficient.dirty ||
                                eeRRsolarWaterHeaterLinearHeatLossCoefficient.touched)
                            " class="alert p-0 m-0 text-danger">
                            <span *ngIf="eeRRsolarWaterHeaterLinearHeatLossCoefficient.errors?.['min']">
                              Loss Coefficient must be at least 0.5.
                            </span>
                            <span *ngIf="eeRRsolarWaterHeaterLinearHeatLossCoefficient.errors?.['max']">
                              Loss Coefficient must have a maximum of 20.0.
                            </span>
                          </div>
                        </div>
                        <div class="mb-1">
                          <label class="form-label mb-0">2nd order heat loss coefficient</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="0" max="0.1"
                            step="0.01" #eeRRsolarWaterHeatersecoundaryHeatLossCoefficient="ngModel" [(ngModel)]="
                              eeRR.solarWaterHeatersecoundaryHeatLossCoefficient
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterSecoundaryHeatLossCoefficient !==
                                  eeRRForActiveDataSet.solarWaterHeaterSecoundaryHeatLossCoefficient
                            }" />
                          <!-- Collector Details 2nd order heat loss Validation -->
                          <div *ngIf="
                              eeRRsolarWaterHeatersecoundaryHeatLossCoefficient.invalid &&
                              (eeRRsolarWaterHeatersecoundaryHeatLossCoefficient.dirty ||
                                eeRRsolarWaterHeatersecoundaryHeatLossCoefficient.touched)
                            " class="alert p-0 m-0 text-danger">
                            <span *ngIf="eeRRsolarWaterHeatersecoundaryHeatLossCoefficient.errors?.['min']">
                              2nd order heat loss must be at least 0.
                            </span>
                            <span *ngIf="eeRRsolarWaterHeatersecoundaryHeatLossCoefficient.errors?.['max']">
                              2nd order heat loss must have a maximum of 0.1.
                            </span>
                          </div>
                        </div>
                        <!-- This had to be removed as Heat Loss is not an input for SWH -->
                        <!-- <div class="mb-1">
                                  <label  class="form-label mb-0">Heat loss rate</label>
                                  <input  class="form-control" type="number" min="0" [(ngModel)]="eeRR.solarWaterHeatLossRate" [disabled]="!isEdit" [ngModelOptions]="{standalone: true}" [ngClass]="{'modifiedBackgroundClass': hasAnActiveDataSet && eeRR.solarWaterHeatLossRate !== eeRRForActiveDataSet.solarWaterHeatLossRate}" />
                              </div> -->
                        <div class="mb-1">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="
                              eeRR.solarWaterHeaterStoreVolumeDetailsKnown
                            " [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterStoreVolumeDetailsKnown !==
                                  eeRRForActiveDataSet.solarWaterHeaterStoreVolumeDetailsKnown
                            }" aria-label="Store details known" />
                            <label class=form-label>Store details known</label>
                        </div>
                      </div>

                      <div class="col" *ngIf="eeRR.solarWaterHeaterStoreVolumeDetailsKnown">
                        <div>Store Details</div>
                        <div class="mb-1">
                          <label class="form-label mb-0">Dedicated solar volume (I)</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="0" max="500"
                            #eeRRsolarWaterHeaterDedicatedSolarVolume="ngModel" [(ngModel)]="
                              eeRR.solarWaterHeaterDedicatedSolarVolume
                            " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterDedicatedSolarVolume !==
                                  eeRRForActiveDataSet.solarWaterHeaterDedicatedSolarVolume
                            }" />
                          <!-- Store Details Solar volume -->
                          <div *ngIf="
                              eeRRsolarWaterHeaterDedicatedSolarVolume.invalid &&
                              (eeRRsolarWaterHeaterDedicatedSolarVolume.dirty ||
                                eeRRsolarWaterHeaterDedicatedSolarVolume.touched)
                            " class="alert p-0 m-0 text-danger">
                            <span *ngIf="eeRRsolarWaterHeaterDedicatedSolarVolume.errors?.['min']">
                              Solar volume must be at least 0.
                            </span>
                            <span *ngIf="eeRRsolarWaterHeaterDedicatedSolarVolume.errors?.['max']">
                              Solar volume must have a maximum of 500.
                            </span>
                          </div>
                        </div>
                        <div class="mb-1">
                          <label class="form-label mb-0">Total cylinder volume (I)</label>
                          <input appHighlightRequired="true" class="form-control" type="number" min="0.01" max="500.0"
                            step="0.01" #eeRRsolarWaterHeaterTotalCylenderVolume="ngModel" [(ngModel)]="
                              eeRR.solarWaterHeaterTotalCylenderVolume
                            " [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.solarWaterHeaterTotalCylenderVolume !==
                                  eeRRForActiveDataSet.solarWaterHeaterTotalCylenderVolume
                            }" />
                          <!-- Store Details Cylinder volume Validation -->
                          <div *ngIf="
                              eeRRsolarWaterHeaterTotalCylenderVolume.invalid &&
                              (eeRRsolarWaterHeaterTotalCylenderVolume.dirty ||
                                eeRRsolarWaterHeaterTotalCylenderVolume.touched)
                            " class="alert p-0 m-0 text-danger">
                            <span *ngIf="eeRRsolarWaterHeaterTotalCylenderVolume.errors?.['min']">
                              Cylinder volume must be at least 0.01.
                            </span>
                            <span *ngIf="eeRRsolarWaterHeaterTotalCylenderVolume.errors?.['max']">
                              Cylinder volume must have a maximum of 500.
                            </span>
                          </div>
                        </div>
                        <div class="mb-1">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="eeRR.combinedCylinder"
                            [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                              modifiedBackgroundClass:
                                hasAnActiveDataSet &&
                                eeRR.combinedCylinder !==
                                  eeRRForActiveDataSet.combinedCylinder
                            }" aria-label="Combined cylinder" />
                          Combined cylinder
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2">
                <div class="card">
                  <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                    Wind Turbines
                  </div>
                  <div class="card-body">
                    <div class="mb-1">
                      <label for="numberOfTurbines" class="form-label mb-0">Number Of Turbines</label>
                      <select appHighlightRequired="true" id="numberOfTurbines" [(ngModel)]="eeRR.numberOfTurbines"
                        (change)="renewablesNumberOfTurbinesChanged()" class="form-select" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.numberOfTurbines !==
                              eeRRForActiveDataSet.numberOfTurbines
                        }">
                        <option *ngFor="
                            let property of lookUpCodesByDataItem[
                              'WindTurbines'
                            ]
                          " [value]="property.lookupValue">
                          {{ property.lookUpItem }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-1" *ngIf="
                        eeRR.numberOfTurbines &&
                        eeRR.numberOfTurbines !=
                          keyedLookUpCodes['WindTurbines']['None']
                      ">
                      <label class="form-label mb-0">Details known?</label>
                      <input class="form-check-input" type="checkbox" [(ngModel)]="windTurbinesDetailsKnown"
                        (change)="onWindTurbinesDetailsKnownChange()" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            windTurbinesDetailsKnown !==
                              eeRRForActiveDataSet.windTurbinesDetailsKnown
                        }" aria-label="Details known?" />
                    </div>
                    <div class="mb-1" *ngIf="windTurbinesDetailsKnown">
                      <label class="form-label mb-0">Rotor diameter (m)</label>
                      <input appHighlightRequired="true" class="form-control" type="number" min="1-0" max="5.0"
                        step="0.1" #eeRRrotorDiameter="ngModel" [(ngModel)]="eeRR.rotorDiameter" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.rotorDiameter !==
                              eeRRForActiveDataSet.rotorDiameter
                        }" name="Rotor diameter (m)" />
                      <!-- Wind turbines Rotor diameter Validation -->
                      <div *ngIf="
                          eeRRrotorDiameter.invalid &&
                          (eeRRrotorDiameter.dirty || eeRRrotorDiameter.touched)
                        " class="alert p-0 m-0 text-danger">
                        <span *ngIf="eeRRrotorDiameter.errors?.['min']">
                          Rotor diameter must be at least 1.0.
                        </span>
                        <span *ngIf="eeRRrotorDiameter.errors?.['max']">
                          Rotor diameter must have a maximum of 5.0.
                        </span>
                      </div>
                    </div>
                    <div class="mb-1" *ngIf="windTurbinesDetailsKnown">
                      <label class="form-label mb-0">Hub height (m)</label>
                      <input appHighlightRequired="true" class="form-control" type="number" min="1.0" max="12.0"
                        step="0.1" #eeRRhubHeight="ngModel" [(ngModel)]="eeRR.hubHeight" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.hubHeight !== eeRRForActiveDataSet.hubHeight
                        }" name="Hub height (m)" />
                      <!-- Wind turbines Hub height Validation -->
                      <div *ngIf="
                          eeRRhubHeight.invalid &&
                          (eeRRhubHeight.dirty || eeRRhubHeight.touched)
                        " class="alert p-0 m-0 text-danger">
                        <span *ngIf="eeRRhubHeight.errors?.['min']">
                          Hub height must be at least 1.0.
                        </span>
                        <span *ngIf="eeRRhubHeight.errors?.['max']">
                          Hub height must have a maximum of 12.0.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2 d-none">
                <div class="card">
                  <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                    Small-scale Hydro Generation
                  </div>
                  <div class="card-body">
                    <div class="mh-16 mv-8 w-400">
                      <div class="mb-1">
                        <label for="hydroAnnualGenerationTotal" class="form-label mb-0">Annual generation (kWh)</label>
                        <input id="hydroAnnualGenerationTotal" class="form-control" type="number" min="0"
                          [(ngModel)]="eeRR.hydroAnnualGenerationTotal" [disabled]="!isEdit"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                    </div>
                    <div class="mh-16 mv-8 w-400">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="eeRR.hydroConnectedToMeter"
                        [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" />
                        <label class="form-label">Connected to meter</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 mb-2 d-none">
                <app-rdsap-appendix></app-rdsap-appendix>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="11">
        <!-- Recovery Tab -->
        <a ngbNavLink (click)="onSelectTab(11)" role="button">
          Recovery
          <span>
            <i [ngClass]="{
                'bi bi-exclamation-circle':
                  isTabClicked(11) === false ||
                  (isTabClicked(11) && !isRecoveryTabValid()),
                'bi bi-check-circle': isTabClicked(11) && isRecoveryTabValid(),
                'text-warning': isTabClicked(11) === false,
                'text-danger': isTabClicked(11) && !isRecoveryTabValid(),
                'text-success': isTabClicked(11) && isRecoveryTabValid()
              }"></i>
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="container-fluid">
            <div class="mb-3">
              <div class="col-lg-8 col-md-8 col-sm-8">
                <div class="card">
                  <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                    Recovery systems
                  </div>
                  <div class="card-body d-flex gap-2 row">
                    <div class="mh-16 mv-8 w-400 col-lg-6 col-md-6 col-sm-6">
                      <label class="form-label">Flue gas heat recovery</label>
                      <select [(ngModel)]="eeRR.fghrHeatingSystem1ID" class="form-select" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            eeRR.fghrHeatingSystem1ID !==
                              eeRRForActiveDataSet.fghrHeatingSystem1ID
                        }">
                        <option *ngFor="let option of flueGasHeatRecoveryOptions" [value]="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                    <div class="mh-16 mv-8 w-400 col-lg-6 col-md-6 col-sm-6">
                      <label class="form-label">Waste water heat recovery</label>
                      <select [(ngModel)]="wasteWaterHeatRecovery" class="form-select" [disabled]="!isEdit"
                        [ngModelOptions]="{ standalone: true }" [ngClass]="{
                          modifiedBackgroundClass:
                            hasAnActiveDataSet &&
                            wasteWaterHeatRecovery !==
                              eeRRForActiveDataSet.wasteWaterHeatRecovery
                        }">
                        <option *ngFor="let option of wasteWaterHeatRecoveryOptions" [value]="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex gap-2 mb-3">
              <div class="card col-lg-5 col-md-4 col-sm-12" *ngIf="
                  eeRR.fghrHeatingSystem1ID === 'Main system 1 only' ||
                  eeRR.fghrHeatingSystem1ID === 'Main systems 1 and 2'
                ">
                <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                  FGHRS (Main system 1)
                </div>
                <div class="card-body">
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label mb-0">ID</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.fghrHeatingSystem1ID" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrHeatingSystem1ID !==
                            eeRRForActiveDataSet.fghrHeatingSystem1ID
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label for="fghrsHeatngSystem1Make" class="form-label mb-0">Make</label>
                    <input id="fghrsHeatngSystem1Make" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatngSystem1Make" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatngSystem1Make !==
                            eeRRForActiveDataSet.fghrsHeatngSystem1Make
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label for="fghrsHeatngSystem1Model" class="form-label mb-0">Model</label>
                    <input id="fghrsHeatngSystem1Model" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatngSystem1Model" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatngSystem1Model !==
                            eeRRForActiveDataSet.fghrsHeatngSystem1Model
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label for="fghrsHeatngSystem1Efficiency" class="form-label mb-0">Efficiency</label>
                    <input id="fghrsHeatngSystem1Efficiency" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatngSystem1Efficiency" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatngSystem1Efficiency !==
                            eeRRForActiveDataSet.fghrsHeatngSystem1Efficiency
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem1PvKwp" class="form-label">kWp</label>
                    <input id="fghrsHeatingSystem1PvKwp" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatingSystem1PvKwp" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem1PvKwp !==
                            eeRRForActiveDataSet.fghrsHeatingSystem1PvKwp
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem1PvPitch" class="form-label">Pitch</label>
                    <select id="fghrsHeatingSystem1PvPitch" [(ngModel)]="eeRR.fghrsHeatingSystem1PvPitch"
                      class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem1PvPitch !==
                            eeRRForActiveDataSet.fghrsHeatingSystem1PvPitch
                      }">
                      <option *ngFor="
                          let property of filterLookupCodes(
                            'fghrsHeatingSystem1PvPitch'
                          )
                        " [value]="property.lookupValue">
                        {{ property.lookUpItem }}
                      </option>
                    </select>
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem1PvOrientation" class="form-label">Orientation</label>
                    <select id="fghrsHeatingSystem1PvOrientation" [(ngModel)]="eeRR.fghrsHeatingSystem1PvOrientation"
                      class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem1PvOrientation !==
                            eeRRForActiveDataSet.fghrsHeatingSystem1PvOrientation
                      }">
                      <option *ngFor="
                          let property of filterLookupCodes(
                            'fghrsHeatingSystem1PvOrientation'
                          )
                        " [value]="property.lookupValue">
                        {{ property.lookUpItem }}
                      </option>
                    </select>
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem1PvOvershading" class="form-label">Overshading</label>
                    <select id="fghrsHeatingSystem1PvOvershading" [(ngModel)]="eeRR.fghrsHeatingSystem1PvOvershading"
                      class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem1PvOvershading !==
                            eeRRForActiveDataSet.fghrsHeatingSystem1PvOvershading
                      }">
                      <option *ngFor="
                          let property of filterLookupCodes(
                            'fghrsHeatingSystem1PvOvershading'
                          )
                        " [value]="property.lookupValue">
                        {{ property.lookUpItem }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card col-lg-4 col-md-4 col-sm-12" *ngIf="
                  eeRR.fghrHeatingSystem1ID === 'Main system 2 only' ||
                  eeRR.fghrHeatingSystem1ID === 'Main systems 1 and 2'
                ">
                <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                  FGHRS (Main system 2)
                </div>
                <div class="card-body">
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">ID</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.fghrsHeatingSystem2ID"
                      [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem2ID !==
                            eeRRForActiveDataSet.fghrsHeatingSystem2ID
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label for="fghrsHeatngSystem2Make" class="form-label mb-0">Make</label>
                    <input id="fghrsHeatngSystem2Make" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatngSystem2Make" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatngSystem2Make !==
                            eeRRForActiveDataSet.fghrsHeatngSystem2Make
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label for="fghrsHeatngSystem2Model" class="form-label mb-0">Model</label>
                    <input id="fghrsHeatngSystem2Model" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatngSystem2Model" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatngSystem2Model !==
                            eeRRForActiveDataSet.fghrsHeatngSystem2Model
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label for="fghrsHeatngSystem2Efficiency" class="form-label mb-0">Efficiency</label>
                    <input id="fghrsHeatngSystem2Efficiency" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatngSystem2Efficiency" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatngSystem2Efficiency !==
                            eeRRForActiveDataSet.fghrsHeatngSystem2Efficiency
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem2PvKwp" class="form-label">kWp</label>
                    <input id="fghrsHeatingSystem2PvKwp" class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.fghrsHeatingSystem2PvKwp" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem2PvKwp !==
                            eeRRForActiveDataSet.fghrsHeatingSystem2PvKwp
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem2PvPitch" class="form-label">Pitch</label>
                    <select id="fghrsHeatingSystem2PvPitch" [(ngModel)]="eeRR.fghrsHeatingSystem2PvPitch"
                      class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem2PvPitch !==
                            eeRRForActiveDataSet.fghrsHeatingSystem2PvPitch
                      }">
                      <option *ngFor="
                          let property of filterLookupCodes(
                            'fghrsHeatingSystem2PvPitch'
                          )
                        " [value]="property.lookupValue">
                        {{ property.lookUpItem }}
                      </option>
                    </select>
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem2PvOrientation" class="form-label">Orientation</label>
                    <select id="fghrsHeatingSystem2PvOrientation" [(ngModel)]="eeRR.fghrsHeatingSystem2PvOrientation"
                      class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem2PvOrientation !==
                            eeRRForActiveDataSet.fghrsHeatingSystem2PvOrientation
                      }">
                      <option *ngFor="
                          let property of filterLookupCodes(
                            'fghrsHeatingSystem2PvOrientation'
                          )
                        " [value]="property.lookupValue">
                        {{ property.lookUpItem }}
                      </option>
                    </select>
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="fghrsHeatingSystem2PvOvershading" class="form-label">Overshading</label>
                    <select id="fghrsHeatingSystem2PvOvershading" [(ngModel)]="eeRR.fghrsHeatingSystem2PvOvershading"
                      class="form-select" [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.fghrsHeatingSystem2PvOvershading !==
                            eeRRForActiveDataSet.fghrsHeatingSystem2PvOvershading
                      }">
                      <option *ngFor="
                          let property of filterLookupCodes(
                            'fghrsHeatingSystem2PvOvershading'
                          )
                        " [value]="property.lookupValue">
                        {{ property.lookUpItem }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex gap-2 mb-3">
              <div class="card col-lg-4 col-md-4 col-sm-12" *ngIf="
                  wasteWaterHeatRecovery === 'Instantaneous (1 system)' ||
                  wasteWaterHeatRecovery === 'Instantaneous (2 systems)'
                ">
                <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                  WWHRS Instantaneous 1
                </div>
                <div class="card-body">
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">ID</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wwhsrs1ID" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wwhsrs1ID !== eeRRForActiveDataSet.wwhsrs1ID
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Make</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS1Make" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS1Make !== eeRRForActiveDataSet.wWHSRS1Make
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Model</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS1Model" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS1Model !==
                            eeRRForActiveDataSet.wWHSRS1Model
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Efficiency</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS1Efficiency" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS1Efficiency !==
                            eeRRForActiveDataSet.wWHSRS1Efficiency
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Mixer showers with WWHRS and bath</label>
                    <input class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.wWHSRS1MixerShowersWithWWHRSAndBath" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS1MixerShowersWithWWHRSAndBath !==
                            eeRRForActiveDataSet.wWHSRS1MixerShowersWithWWHRSAndBath
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Mixer showers with WWHRS, no bath</label>
                    <input class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.wWHSRS1MixerShowersWithWWHRSNoBath" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS1MixerShowersWithWWHRSNoBath !==
                            eeRRForActiveDataSet.wWHSRS1MixerShowersWithWWHRSNoBath
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="wwhrsInstantaneous1Index" class="form-label">Instantaneous System 1</label>
                    <input class="form-control" name="wwhrsInstantaneous1Index"
                      [(ngModel)]="eeRR.wwhrsInstantaneous1Index" [disabled]="true"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                </div>
              </div>
              <div class="card col-lg-4 col-md-4 col-sm-12"
                *ngIf="wasteWaterHeatRecovery === 'Instantaneous (2 systems)'">
                <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                  WWHRS Instantaneous 2
                </div>
                <div class="card-body">
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">ID</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS2ID" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS2ID !== eeRRForActiveDataSet.wWHSRS2ID
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Make</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS2Make" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS2Make !== eeRRForActiveDataSet.wWHSRS2Make
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Model</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS2Model" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS2Model !==
                            eeRRForActiveDataSet.wWHSRS2Model
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Efficiency</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRS2Efficiency" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS2Efficiency !==
                            eeRRForActiveDataSet.wWHSRS2Efficiency
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Mixer showers with WWHRS and bath</label>
                    <input class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.wWHSRS2MixerShowersWithWWHRSAndBath" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS2MixerShowersWithWWHRSAndBath !==
                            eeRRForActiveDataSet.wWHSRS2MixerShowersWithWWHRSAndBath
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Mixer showers with WWHRS, no bath</label>
                    <input class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.wWHSRS2MixerShowersWithWWHRSNoBath" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRS2MixerShowersWithWWHRSNoBath !==
                            eeRRForActiveDataSet.wWHSRS2MixerShowersWithWWHRSNoBath
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="wwhrsInstantaneous2Index" class="form-label">Instantaneous System 2</label>
                    <input class="form-control" name="wwhrsInstantaneous2Index"
                      [(ngModel)]="eeRR.wwhrsInstantaneous2Index" [disabled]="true"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="card col-lg-4 col-md-4 col-sm-12" *ngIf="wasteWaterHeatRecovery === 'Storage'">
                <div class="card-header" [ngStyle]="{ background: 'blue-grey-400' }">
                  WWHSRS Storage
                </div>
                <div class="card-body">
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">ID</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRSStorageID" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageID !==
                            eeRRForActiveDataSet.wWHSRSStorageID
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Make</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRSStorageMake" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageMake !==
                            eeRRForActiveDataSet.wWHSRSStorageMake
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Model</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRSStorageModel" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageModel !==
                            eeRRForActiveDataSet.wWHSRSStorageModel
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Efficiency</label>
                    <input class="form-control" type="text" [(ngModel)]="eeRR.wWHSRSStorageEfficiency"
                      [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageEfficiency !==
                            eeRRForActiveDataSet.wWHSRSStorageEfficiency
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">Total showers and baths</label>
                    <input class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.wWHSRSStorageTotalShowersAndBaths" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageTotalShowersAndBaths !==
                            eeRRForActiveDataSet.wWHSRSStorageTotalShowersAndBaths
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">No. of showers and baths with WWHRS</label>
                    <input class="form-control" type="number" min="0"
                      [(ngModel)]="eeRR.wWHSRSStorageShowersAndBathsToWWHRS" [disabled]="!isEdit"
                      [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageShowersAndBathsToWWHRS !==
                            eeRRForActiveDataSet.wWHSRSStorageShowersAndBathsToWWHRS
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400">
                    <label class="form-label">WWHRS Storage volume(I)</label>
                    <input class="form-control" type="number" min="0" [(ngModel)]="eeRR.wWHSRSStorageVolume"
                      [disabled]="!isEdit" [ngModelOptions]="{ standalone: true }" [ngClass]="{
                        modifiedBackgroundClass:
                          hasAnActiveDataSet &&
                          eeRR.wWHSRSStorageVolume !==
                            eeRRForActiveDataSet.wWHSRSStorageVolume
                      }" />
                  </div>
                  <div class="mh-16 mv-8 w-400 d-none">
                    <label for="wwhrsStorageIndex" class="form-label">Storage</label>
                    <input class="form-control" name="wwhrsStorageIndex" [(ngModel)]="eeRR.wwhrsStorageIndex"
                      [disabled]="true" [ngModelOptions]="{ standalone: true }" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="0">
        <a ngbNavLink (click)="onSelectTab(0)" role="button">Results</a>
        <ng-template ngbNavContent>
          <app-rdsap-summary [isEdit]="isEdit" [canCalculate]="canCalculate()"
            (addendaData)="setAddendum($event.addendum)" (deselectedItemsData)="
              setDeselectedItems($event.deselectedImprovementMeasures)
            " [getAddendum]="eeGeneralDetails?.addendum"></app-rdsap-summary>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
  <app-info *ngIf="isHealthy$ | async"></app-info>
</div>

<ng-template #standardTpl> {{ standardMessage }} </ng-template>

<ng-template #successTpl> {{ successMessage }} </ng-template>

<ng-template #dangerTpl>
  <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M10.872 6.831l1.695 3.904 3.654-1.561-1.79 3.426 3.333.954-3.417 1.338 2.231 4.196-4.773-2.582-2.869 2.287.413-3.004-3.792-.726 2.93-1.74-1.885-2.512 3.427.646.843-4.626zm-.786-6.831l-1.665 9.119-6.512-1.228 3.639 4.851-5.548 3.294 7.108 1.361-.834 6.076 5.742-4.577 9.438 5.104-4.288-8.064 6.834-2.677-6.661-1.907 3.25-6.22-6.98 2.982-3.523-8.114z" />
  </svg>
  {{ errorMessage }}
</ng-template>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>